var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _polygon, _path7, _polygon2, _polygon3, _path8, _path9, _polygon4, _path10, _polygon5, _path11, _polygon6, _g2, _ellipse2, _ellipse3, _path12, _path13, _path14, _path15, _path16, _polygon7, _polygon8, _polygon9, _path17, _path18, _path19, _path20, _path21, _polyline, _path22, _line, _path23, _path24, _path25, _path26, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon10, _path37, _path38, _path39, _g11, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _ellipse4, _polygon11, _path58, _polygon12, _polygon13, _path59, _path60, _polygon14, _path61, _polygon15, _path62, _polygon16, _g12, _ellipse5, _ellipse6, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _polygon17, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g13, _path104, _path105, _path106, _path107, _path108, _g14, _path109, _path110, _path111, _path112, _path113, _ellipse7, _path114, _path115, _path116, _path117, _path118, _g15, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g16, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _polygon18, _path155, _path156, _path157, _path158, _path159, _path160, _g17, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _rect3, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _polygon19, _polygon20, _path179, _path180, _path181, _path182, _path183, _path184, _rect4, _g18, _g19, _g20, _rect5, _text, _g21, _g22;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 800",
    enableBackground: "new 0 0 1200 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "story-header-bg"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "white-bg_2_",
    fill: "#FFFFFF",
    width: 1200,
    height: 800
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1087,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1EBEE4",
    width: 113,
    height: 531
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "windpower_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1131.19,375.18C1131.19,375.18,1131.19,375.18,1131.19,375.18C1131.2,375.18,1131.19,375.18,1131.19,375.18 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1231.05,388.07c-0.17-0.01-0.35-0.02-0.53-0.04C1231.3,388.18,1231.52,388.16,1231.05,388.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1180.88,365.37c0,0.01,0,0.02,0,0.03c0,0-0.6,0.28-1.59,0.28c-0.99,0-1.12-0.29-1.12-0.29 c-16,0.53-31.12,14.68-31.12,14.68s-7.24-4.67-15.85-4.89c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.01,0 c-0.06,0.04-0.56,0.72-2.96,0.72c-1.29,0-2.33-0.32-2.51-0.38c-12.25,1.82-20.21,10.38-27.89,12.78c0,0,7.14-2.24,19.86-3.15 c12.32-0.88,24.12,0.89,21.91-0.14c-2.2-1.03-6.74-3.68,3.42-2.19c10.27,1.51,16.73,5.85,24.77,6.71 c30.15,3.22,27.89-6.02,21.73-10.54c-12.81-9.4,4.52-7.4,17.87,0c9.21,5.1,18.1,8.59,23.12,9.05c-2.24-0.45-9.14-2.44-17.93-8.86 C1201.48,371.06,1194.16,365.61,1180.88,365.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1131.19,375.18C1131.19,375.18,1131.2,375.18,1131.19,375.18 C1131.2,375.18,1131.2,375.18,1131.19,375.18C1131.2,375.18,1131.2,375.18,1131.19,375.18c-0.19-3.4-1.38-45.89-1.66-56.25 c2.78,3.18,8.66,9.92,12.88,14.75l2.86-2.5c-2.81-4.5-6.22-9.97-7.24-11.71c-1.64-2.82-1.97-1.88-3.7-2.17 c-1.38-0.23-2.57-0.74-3.49-1.5c-0.21,1.31-1.34,2.31-2.71,2.31c-0.59,0-1.13-0.19-1.58-0.5l-0.86,57.89c0,0,0.01,0,0.03,0.01 c0.18,0.06,1.22,0.38,2.51,0.38C1130.63,375.9,1131.13,375.22,1131.19,375.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1130.27,313.66c1.06-3.12,4.41-12.99,6.73-19.83l-3.59-1.22c-2.48,4.69-5.5,10.39-6.49,12.14 c-1.61,2.84-0.64,2.65-0.02,4.29c0.48,1.28,0.65,2.54,0.47,3.69c0.24-0.07,0.5-0.11,0.77-0.11 C1128.99,312.62,1129.76,313.03,1130.27,313.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1139.25,287.19c0.74-2.17-1.28-3.14-2.45-0.98c-0.52,0.97-1.86,3.49-3.39,6.4l3.59,1.22 C1138.1,290.56,1138.97,287.99,1139.25,287.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1147.01,338.96c1.51,1.72,3.36,0.47,2.08-1.63c-0.57-0.94-2.09-3.36-3.83-6.15l-2.86,2.5 C1144.67,336.28,1146.46,338.32,1147.01,338.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1125.38,315.37c0-0.38,0.08-0.74,0.21-1.06c-3.42,0.7-13.39,2.73-20.33,4.14l0.76,3.72 c5.31-0.22,11.74-0.49,13.76-0.51c3.27-0.04,2.61-0.78,3.72-2.14c0.8-0.99,1.72-1.73,2.72-2.17 C1125.7,316.84,1125.38,316.14,1125.38,315.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1098.4,319.85c-2.24,0.46-2.07,2.69,0.39,2.61c1.1-0.03,3.95-0.15,7.23-0.29l-0.76-3.72 C1101.89,319.14,1099.23,319.68,1098.4,319.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1130.83,315.8c0.02-0.14,0.04-0.29,0.04-0.43c0-0.65-0.23-1.24-0.6-1.71c-0.5-0.63-1.28-1.03-2.14-1.03 c-0.27,0-0.52,0.04-0.77,0.11c-0.8,0.23-1.44,0.81-1.76,1.57c-0.14,0.33-0.21,0.69-0.21,1.06c0,0.78,0.32,1.48,0.84,1.98 c0.1,0.1,0.21,0.19,0.32,0.27c0.45,0.31,0.99,0.5,1.58,0.5C1129.49,318.11,1130.62,317.11,1130.83,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1179.29,365.68c0.99,0,1.59-0.28,1.59-0.28c0-0.01,0-0.02,0-0.03c-0.09-1.79-0.79-29.22-0.92-34.41 c-0.55,0.34-1.27,0.32-1.8-0.11c-0.19-0.15-0.33-0.34-0.42-0.55c-0.26,0.61-0.74,1.13-1.4,1.53c-0.72,0.44-1.03,0.08-1.26,1.64 c-0.14,0.96-0.68,4.01-1.12,6.53l1.73,0.6c0.82-2.35,1.9-5.46,2.63-7.58l-0.14,32.37 C1178.17,365.39,1178.3,365.68,1179.29,365.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1173.35,343.44c-0.19,1.17,0.86,1.39,1.22,0.35c0.13-0.38,0.56-1.62,1.11-3.19l-1.73-0.6 C1173.68,341.56,1173.44,342.91,1173.35,343.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1180.44,330.49c0.38,0.07,0.77,0.21,1.16,0.42c0.74,0.4,0.59,0.85,2.05,0.27 c0.9-0.36,3.81-1.43,6.21-2.31l-0.35-1.79c-2.93,0.57-6.98,1.35-9.05,1.75C1180.77,329.33,1180.77,329.98,1180.44,330.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1193.13,327.67c1.11-0.42,0.77-1.44-0.31-1.23c-0.4,0.08-1.68,0.33-3.31,0.64l0.35,1.79 C1191.34,328.33,1192.63,327.85,1193.13,327.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1177.93,328.67c0.14-0.17,0.3-0.3,0.48-0.4c-0.14-0.43-0.19-0.92-0.15-1.44 c0.06-0.84,0.54-0.89-0.59-1.98c-0.7-0.67-2.86-2.9-4.64-4.73l-1.49,1.05c2.08,2.96,5.26,7.53,6.07,8.7 C1177.54,329.45,1177.65,329.02,1177.93,328.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1170.59,317.63c-0.84-0.84-1.63-0.12-1,0.78c0.23,0.33,0.98,1.4,1.94,2.76l1.49-1.05 C1171.92,318.99,1170.97,318,1170.59,317.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1178.16,330.86c0.53,0.43,1.25,0.45,1.8,0.11c0.14-0.09,0.28-0.2,0.39-0.34 c0.03-0.04,0.06-0.09,0.09-0.13c0.33-0.51,0.33-1.16,0.02-1.66c-0.09-0.15-0.2-0.28-0.34-0.4c-0.5-0.4-1.18-0.45-1.71-0.16 c-0.18,0.1-0.34,0.23-0.48,0.4c-0.28,0.35-0.39,0.79-0.32,1.2c0.02,0.15,0.07,0.3,0.13,0.44 C1177.83,330.51,1177.97,330.7,1178.16,330.86z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1175.14,378.57c-3.74-7.13,4.92-7.99,10.07-9.04c3.9-0.8,4.92-2.35,1.96-3.16 c-2.11-0.57-4.23-0.88-6.31-0.96c-0.02,0.01-0.06,0.02-0.11,0.04c0.08-0.03,0.13-0.05,0.13-0.05l0-0.03l-0.91-34.42 c-0.31,0.19-0.67,0.27-1.02,0.23c-0.02,0.07-0.05,0.15-0.08,0.23c0.2,0.47,0.38,1.12,0.41,2.02c0.09,2.39,0.74,31.67,0.77,32.19 c-0.22,0.03-0.47,0.06-0.76,0.06c-0.79,0-1.03-0.18-1.1-0.26c-5.3,0.25-10.37,1.81-14.82,3.83c-9.59,4.35-16.32,10.81-16.32,10.81 c9.79,8.02,20.74,9.45,20.74,9.45C1175.76,389.39,1177.3,382.69,1175.14,378.57z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1127.55,379.8c1.58-3.78,7.48-3.99,8.76-3.99c0.16,0,0.25,0,0.25,0c-0.98-0.2-1.92-0.34-2.85-0.44 c-0.09-0.01-0.19-0.02-0.28-0.03c-0.05-0.01-0.1-0.01-0.15-0.02c-0.71-0.07-1.41-0.11-2.1-0.13c0,0,0.01-0.01,0.01-0.01v0v0 l-0.88-28.16l-0.91-29.23c-0.38,0.2-0.82,0.32-1.28,0.32c-0.38,0-0.74-0.08-1.07-0.22c0.57,0.52,1.48,1.73,1.57,4.21 c0.14,3.64,0.96,53.39,0.96,53.68c0.12,0,0.22-0.02,0.33-0.03c-0.42,0.09-0.96,0.15-1.68,0.15c-1.22,0-2.22-0.29-2.47-0.37 c-1.53,0.23-2.99,0.58-4.4,0.99c-2.78,0.82-5.35,1.93-7.87,3.24c-1.72,0.9-3.42,1.89-5.13,2.96c-6.37,3.96-9.34,5.17-10.23,5.49 c-0.08,0.03-0.15,0.05-0.19,0.07c-0.07,0.02-0.1,0.03-0.1,0.03l8.54-1.85l1.59-0.34C1118.24,384.46,1125.61,384.44,1127.55,379.8z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ix3"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1115.14,439.63c-10.47-10.75-21.74-23.44-52.23-25.69c-1.62-0.12-3.2-0.23-4.76-0.32l17.27,41.22 c0.13,0.01,0.26,0.02,0.37,0.03c5.64,0.51,44.95,5.04,49.48,5.34c4.53,0.31,5.27-3,5.27-3S1125.6,450.37,1115.14,439.63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M890.25,553.67c0,0-15.1,0.84-25.87,1.52c-11.36,0.72-45.66,3.34-21.64,9.05 c3.52,0.84,25.69,6.1,50.39,10.16c31.89,5.24,47.48,2.75,52.75,2.14c29.76-3.46,55.97-6.47,82.58-9.98 c36.42-4.81,130.81-15.13,141.63-16.96c10.82-1.84-6.77-5.18-36.21-7.68c-21.54-1.83-58.28-5.19-71.81-2.92 C1035.63,543.43,890.25,553.67,890.25,553.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1147.08,534.28c1.52-0.63,37.95-11.58,37.95-11.58s6.83-40.14-12.14-38.85 C1153.92,485.13,1147.08,534.28,1147.08,534.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M990.73,544.57c0,0,52.63-0.51,61.23-1.8c8.6-1.29,9.87-55.06-22.26-55.58 C997.56,486.68,990.73,544.57,990.73,544.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1030.91,498.94c7.3,0,20.53,8.22,19.09,35.4c-1.33,25.15-15.72,32.35-22.08,32.35 c-5.38,0-31.24-0.54-41.04-21.01c0,0,8.14-0.58,9.86-7.99C998.63,529.53,1005.9,498.94,1030.91,498.94z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1008.67,535.94c-0.5-6.19-2.69-12.79-3.96-17.25c0,0,8.48-21.56,26.71-18.54 c21.01,3.48,18.9,37.18,17.67,42.4c-1.55,6.61-5.65,22.71-20.64,24C1013.48,567.85,1009.24,542.98,1008.67,535.94z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0288 -0.9996 0.9996 0.0288 467.6517 1546.3083)",
    fill: "#FFFFFF",
    cx: 1029.58,
    cy: 532.49,
    rx: 27.89,
    ry: 17.32
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#191C1C",
    points: "1033.93,506.54 1035.57,517.04 1043.92,518.74 1045.72,530.02 1039.31,536.68 1041.52,549.43 1037.85,550.61 1035.36,556.45 1030.03,549.2 1022.63,556.75 1020.62,550.54 1016.83,549.64 1020.13,536.68 1013.34,530.22 1016.26,524.78 1015.94,518.13 1023.87,517.53 1026.63,506.34 1029.89,507.82  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1029.1326,
    y1: 557.4421,
    x2: 1029.881,
    y2: 505.3371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7515,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_)",
    strokeMiterlimit: 10,
    d: "M1026.63,506.34l-3.2,9.15l-7.5,2.64 c0,0-2.3,7.42-2.6,12.09l4.8,8.13l-1.3,11.28c0,0,2.1,4.78,5.8,7.11l6.7-4.57l6,4.57c0,0,4.3-3.76,6.2-7.32l-0.4-10.98 l4.6-8.44c0,0,0-6.2-1.8-11.28l-6.7-2.24l-3.3-9.96C1033.93,506.54,1031.53,505.12,1026.63,506.34z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1033.93,506.54 1032.63,521.08 1034.82,523.41 1043.92,518.74 1037.22,516.5  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1026.63,506.34 1025.53,520.57 1023.43,523.21 1015.94,518.13 1023.43,515.49  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1015.94,518.13l1.8,4.47l-1.7,6.5l-2.7,1.12C1013.34,530.22,1013.84,523.52,1015.94,518.13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1043.92,518.74l-2.2,3.96l1,6.1l3,1.22C1045.72,530.02,1045.72,524.02,1043.92,518.74z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1045.72,530.02 1036.72,534.29 1035.72,538.35 1041.52,549.43 1041.12,538.46  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1041.52,549.43l-3-1.93l-3.1,3.66l-0.1,5.59C1035.32,556.75,1040.22,552.69,1041.52,549.43z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1035.32,556.75 1029.63,544.86 1027.43,544.35 1022.63,556.75 1029.33,552.18  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1022.63,556.75l0.8-5.18c0,0-3.7-4.07-3.8-3.76c-0.1,0.3-2.8,1.83-2.8,1.83 S1019.53,554.92,1022.63,556.75z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1016.83,549.64 1021.63,537.74 1021.03,533.88 1013.34,530.22 1018.13,538.35  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#191C1C",
    x1: 1041.12,
    y1: 538.46,
    x2: 1045.22,
    y2: 540.59
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1037.22,
    y1: 516.5,
    x2: 1039.92,
    y2: 511.01
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1029.33,
    y1: 552.18,
    x2: 1029.33,
    y2: 559.19
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1018.13,
    y1: 538.35,
    x2: 1013.94,
    y2: 540.39
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1023.43,
    y1: 515.49,
    x2: 1020.33,
    y2: 510.91
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 1026.66,
    cy: 532.2,
    rx: 1.63,
    ry: 2.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1EBEE4",
    cx: 1026.66,
    cy: 532.2,
    rx: 1.06,
    ry: 1.83
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M875.72,530.21c0,0-1.58,28.01,33.36,28.01c25.02,0,25.5-26.09,25.5-26.09L875.72,530.21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M875.87,533.42l15.08,4.02c0,0,0.96,15.47,13.16,20.58C904.11,558.01,878.84,557.72,875.87,533.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.8655,
    y1: 545.7153,
    x2: 904.1096,
    y2: 545.7153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4606,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6335,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M875.87,533.42l15.08,4.02c0,0,0.96,15.47,13.16,20.58 C904.11,558.01,878.84,557.72,875.87,533.42z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M994.27,544.82c0,0-14.19,2.3-43.63,1.21c-24.43-0.91-98.73-9.52-101.6-22.49l116.69,6.21L994.27,544.82z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 931.4492,
    y1: 437.042,
    x2: 917.5982,
    y2: 574.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M994.27,544.82c0,0-14.19,2.3-43.63,1.21c-24.43-0.91-98.73-9.52-101.6-22.49l116.69,6.21 L994.27,544.82z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1EBEE4",
    points: "1021.59,413.32 1066,415.33 1079.59,455.79 1027.21,451.07 1021.74,447.7  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.63,
    fill: "#A1C8D9",
    points: "1021.59,413.32 1066,415.33 1079.59,455.79 1027.21,451.07 1021.74,447.7  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A59B91",
    points: "1120.84,459.26 1116.73,454.04 1086.06,453.57 1087.61,456.42 1121.07,460.3  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1120.32,459.45c0,0-13.11-18.01-22.48-25.98c-9.37-7.97-30.31-15.76-78.51-13.16l-0.3-7.23 c0,0,27.04-0.91,47.31,0.99c20.27,1.91,35.08,9.18,51.77,28.23c16.69,19.05,15.5,18.01,15.5,18.01S1124.24,463.26,1120.32,459.45 z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M866.75,441.53c-0.92,1-3.46,2.99,1.21,3.28c4.67,0.29,30.83,0.15,30.83,0.15s24.13,0,33.87-0.48 c9.75-0.48,26.38-0.48,29.59-4.83c3.21-4.35,7.01-11.36,7.01-11.36s-0.15-0.28-0.49-0.74c-1.47-2.02-6.45-7.47-17.58-7.47 c-13.67,0-51.34,0-55.26,0c-3.82,0-10.09,0.69-17.6,8.7c-0.19,0.21-0.39,0.42-0.59,0.64 C869.98,438.02,867.67,440.54,866.75,441.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1180.1903,
    y1: 474.3766,
    x2: 1189.1564,
    y2: 483.3427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6582,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9675,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M1187.22,485.28c0,0,1.04-9.05-5.11-12.34c0,0-2.71,0.48-0.65,3.57 C1183.52,479.6,1187.22,485.28,1187.22,485.28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1188.68,490.31c-0.79-4.56-1.71-5.77-1.71-5.77s-2.11-4.02-4.22-6.84c-2.11-2.82-2.51-4.29-0.53-4.83 c0,0-6.46-8.99-43.25-17.03c0,0-1.16,1.3-4.35,1.88c0,0-0.24,0.21-0.65,0.47c-0.46,0.29-1.15,0.65-1.98,0.87 c0,0-2.64,2.28-6.59,2.15c-3.96-0.13-52.35-5.63-52.35-5.63s-24.53-2.01-31.39-2.68c-6.86-0.67-20.44-4.56-27.03-6.57 c-6.59-2.01-19.25-6.71-22.29-7.64s-4.22-2.82-3.43-7.38c0.79-4.56,3.56-12.34,4.62-14.89c1.05-2.55,9.36-4.29,15.03-4.69 c5.67-0.4,35.47-2.15,54.99,0.27c19.52,2.41,31.71,6.74,43.96,18.79c12.25,12.05,19.52,20.38,19.52,20.38l0.27-0.75l0.67-1.56 c0,0-24.64-27.93-38.64-33.14c-14-5.2-37.16-9.45-56.68-10.41c-19.52-0.96-49.81,1.47-49.81,1.47l-12.89,3.81L950,452.56 l39.62,34.33l20.16,3.1l21.1-8.11l19.22,8.11l6.8,24.08l91.43,0.95l13.6-30.75l13.13-3.81l7.5,4.77l4.45,10.49l0.7,16.21 l0.84-2.29C1188.55,509.62,1189.47,494.87,1188.68,490.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.4797,
    y1: 407.629,
    x2: 948.2413,
    y2: 407.629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2783,
    style: {
      stopColor: "#FBFBFB",
      stopOpacity: 0.9172
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3622,
    style: {
      stopColor: "#F0F0F0",
      stopOpacity: 0.8372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#DCDCDC",
      stopOpacity: 0.7584
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    style: {
      stopColor: "#C1C1C1",
      stopOpacity: 0.6803
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    style: {
      stopColor: "#9E9E9E",
      stopOpacity: 0.6026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    style: {
      stopColor: "#737372",
      stopOpacity: 0.5253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.4498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.4
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M902.48,410.26c0,0,10.45-6.34,45.76-5.09"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "948.24,405.16 906.39,410.63 902.48,410.26  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M959.96,485.71c0,0-0.73,4.47-1.44,10.05c-0.57,4.46-0.95,8.49-3.94,9.46 c-2.98,0.97-14.91,3.4-19.44,3.52c-3.36,0.09-39.57-1.29-61.39-2.01c-7.58-0.25-13.42-0.42-15.54-0.42 c-8.23,0-9.06-2.79-9.78-5.46c-0.57-2.14-1.15-4.98-1.35-6.02c0,2.88,0,5.6,0,6.47c0,1.97-0.25,5.6-0.25,7.38 c0,1.78,0.38,5.6,0.38,5.6s0.71,1.64,6.37,2.19c2.21,0.21,14.09,0.95,28.2,1.77c21.97,1.28,49.36,2.75,54.2,2.75 c7.94,0,29.08-1.1,29.08-1.1s2.08-13,2.42-19.17C967.93,492.55,968.71,486.26,959.96,485.71z"
  })), /*#__PURE__*/React.createElement("g", null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 983.5,
    y1: 526.33,
    x2: 965.82,
    y2: 524.65
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M966.49,519.19l-1.31-0.06c-0.08,0.49-0.12,0.76-0.12,0.76s-21.14,1.1-29.08,1.1 c-4.84,0-32.23-1.47-54.2-2.75c-14.11-0.82-25.99-1.56-28.2-1.77c-5.18-0.5-6.21-1.92-6.35-2.16l2,10.7 c0,0,9.04,3.26,26.66,4.19c17.62,0.93,68.87,4.19,77.91,4.19s11.21-2.09,11.21-2.09l0.82-6.64L966.49,519.19z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M850.74,516.15l-1.23,2.84c-0.03,0.07-0.12,0.1-0.18,0.05l-1.42-1.22c-0.03-0.02-0.05-0.05-0.05-0.09 c0,0-0.72-3.48-0.64-3.42c0.35,0.26,1.42,0.95,3.45,1.67C850.74,516.01,850.77,516.08,850.74,516.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 847.2245,
    y1: 523.851,
    x2: 965.0566,
    y2: 523.851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M965.06,519.89c0,0-21.14,1.1-29.08,1.1c-4.84,0-32.23-1.47-54.2-2.75 c-14.11-0.82-25.99-1.56-28.2-1.77c-5.18-0.5-6.21-1.92-6.35-2.16l2,10.7c0,0,9.04,3.26,26.66,4.19 c17.62,0.93,68.87,4.19,77.91,4.19s10.48-1.73,10.48-1.73L965.06,519.89z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M853.57,516.47c2.21,0.21,14.09,0.95,28.2,1.77c21.97,1.28,49.36,2.75,54.2,2.75 c7.94,0,29.08-1.1,29.08-1.1s0.04-0.28,0.12-0.76c0.45-2.87,2.01-13.14,2.3-18.41c0.45-8.17,1.23-14.47-7.52-15.02 c0,0-0.73,4.47-1.44,10.05c-0.57,4.46-0.95,8.49-3.94,9.46c-2.98,0.97-14.91,3.4-19.44,3.52c-3.36,0.09-39.57-1.29-61.39-2.01 c-7.58-0.25-13.42-0.42-15.54-0.42c-8.23,0-9.06-2.79-9.78-5.46c-0.57-2.14-1.15-4.98-1.35-6.02c0,2.88,0,5.6,0,6.47 c0,1.97-0.25,5.6-0.25,7.38c0,1.24,0.18,3.46,0.29,4.7c0.03,0.35,0.06,0.63,0.07,0.77c0.01,0.08,0.01,0.13,0.01,0.13 s0.01,0.01,0.02,0.03C847.36,514.55,848.39,515.97,853.57,516.47z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M855.79,486.03l-0.09-11.93c0,0,0,7.3,0,9.9C855.7,484.59,855.73,485.28,855.79,486.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M857.47,493.59c1.18,2.2,1.77,5.89,7.47,6.29c5.51,0.39,64.78,2.55,74.71,2.69 c4.56-4.11,5.94-12.22,6.82-16.5c1.21-5.89,2.96-9.86,2.96-9.86l2.41-0.03l0.07-0.3l-1.83-15.66c0,0-21.81,0.93-29.88,0.93 c-8.07,0-44.88-0.63-44.88-0.63l-5.47,6.92c0,0-9.46,1.88-9.26,1.88c0.2,0-4.9,4.77-4.9,4.77l0.09,11.93 C855.99,488.62,856.56,491.89,857.47,493.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M864.94,499.89c-5.7-0.4-6.29-4.1-7.47-6.29c-0.91-1.7-1.48-4.97-1.68-7.56 c-0.06-0.75-0.09-1.44-0.09-2.03c0-2.6,0-9.9,0-9.9s-2.49,7.5-2.49,8.52c0,1.03,0.09,4.54,0.36,10.7 c0.27,6.16,1.08,8.08,4.31,8.49c3.23,0.41,65.03,3.29,75.13,3.29c2.12,0,3.9-0.58,5.38-1.56c0.44-0.29,0.86-0.62,1.26-0.97 C929.72,502.44,870.45,500.27,864.94,499.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M951.85,476.19l-2.41,0.03c0,0-1.75,3.97-2.96,9.86c-0.88,4.28-2.26,12.39-6.82,16.5 c-0.39,0.36-0.81,0.68-1.26,0.97c-1.49,0.97-3.26,1.56-5.38,1.56c-10.1,0-71.9-2.88-75.13-3.29c-3.23-0.41-4.04-2.33-4.31-8.49 c-0.27-6.16-0.36-9.67-0.36-10.7c0-1.03,2.49-8.52,2.49-8.52l-3.61-0.06c0,0-3.32,6.94-4.01,8.53c-0.69,1.59-1,2.74-1,4.01 c0,0.71,0,4.6,0,8.24c0.2,1.04,0.78,3.88,1.35,6.02c0.72,2.67,1.55,5.46,9.78,5.46c8.23,0,72.39,2.55,76.93,2.43 c4.53-0.12,16.46-2.55,19.44-3.52c2.98-0.97,3.36-5,3.94-9.46c0.72-5.58,1.44-10.05,1.44-10.05s5.1-7.3,11.7-9.77L951.85,476.19 z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M980.65,458.21c-2.79-1.61-18.64-2.53-34.27-0.61c-11.74,1.44-18.79,3.01-21.57,3.71 c-0.7,0.17-1.04,0.97-0.69,1.61l2.57,4.72c0.19,0.34,0.54,0.56,0.92,0.57c1.81,0.05,7.06,0.26,8.74,0.83 c2.04,0.69,8,4.84,10.87,4.84s20.76,0,22.64,0c2.4,0,5.62-3.02,7.93-6.09c-3.54,0.11-24.34,0.76-28.56,0.62 c-4.61-0.16-6.88-1.35-9.46-2.15c-2.58-0.79-3.52-1.03-5.86-0.95c-1.9,0.06-4.42,0.18-5.3,0.22c-0.2,0.01-0.38-0.11-0.45-0.29 l-0.71-1.69c-0.12-0.29,0.06-0.61,0.36-0.66c4.16-0.61,29.23-4.07,54.21-2.39C982.16,459.61,981.81,458.88,980.65,458.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M940.64,465.19c-0.26,0.01-0.35,0.36-0.12,0.49c0.98,0.54,2.67,1.38,4.03,1.52 c1.16,0.12,3.18,0.13,3.89,0.14c0.14,0,0.26-0.12,0.26-0.26v-1.81c0-0.15-0.12-0.27-0.26-0.26L940.64,465.19z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M856.12,469.55c0.15,0.01,0.29-0.03,0.41-0.12l4.38-3.37c0.09-0.07,0.2-0.11,0.31-0.12l5.29-0.45 c0.23-0.02,0.43-0.17,0.51-0.4l0.79-2.14c0.14-0.37-0.1-0.77-0.48-0.82l-13.72-1.88c0.09,0.06,0.14,0.16,0.14,0.27l-0.17,6.53 c0,0.08-0.03,0.16-0.09,0.22l-1.76,1.79c-0.05,0.05-0.09,0.13-0.09,0.21l-0.01,0.1c0.11-0.08,0.24-0.12,0.38-0.11L856.12,469.55 z M856.14,464.18c0-0.13,0.11-0.24,0.24-0.23l3.38,0.34c0.2,0.02,0.27,0.28,0.11,0.41l-1.74,1.31 c-0.04,0.03-0.09,0.05-0.14,0.04l-1.64-0.07c-0.12-0.01-0.21-0.1-0.21-0.23V464.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M980.65,458.21c-2.79-1.61-18.64-2.53-34.27-0.61c-11.74,1.44-18.79,3.01-21.57,3.71 c-0.7,0.17-1.04,0.97-0.69,1.61l2.57,4.72c0.19,0.34,0.54,0.56,0.92,0.57c1.81,0.05,7.06,0.26,8.74,0.83 c2.04,0.69,8,4.84,10.87,4.84c2.87,0,20.76,0,22.64,0c2.4,0,5.62-3.02,7.93-6.09c-3.54,0.11-24.34,0.76-28.56,0.62 c-4.61-0.16-6.88-1.35-9.46-2.15c-2.58-0.79-3.52-1.03-5.86-0.95c-1.9,0.06-4.42,0.18-5.3,0.22c-0.2,0.01-0.38-0.11-0.45-0.29 l-0.71-1.69c-0.12-0.29,0.06-0.61,0.36-0.66c4.16-0.61,29.23-4.07,54.21-2.39C982.16,459.61,981.81,458.88,980.65,458.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M940.64,465.19c-0.26,0.01-0.35,0.36-0.12,0.49c0.98,0.54,2.67,1.38,4.03,1.52 c1.16,0.12,3.18,0.13,3.89,0.14c0.14,0,0.26-0.12,0.26-0.26v-1.81c0-0.15-0.12-0.27-0.26-0.26L940.64,465.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M857.76,450.73c-0.71,0.45-0.96,0.91-0.96,1.35c0,0.61,0,1.15,0,1.61c0.02,0.04,0.02,0.08,0.02,0.12 v1.52c0,0.14,0.09,0.26,0.22,0.3l14.69,4.74c0.03,0.01,0.06,0.01,0.08,0.01l4.81,0.16c0.09,0,0.16,0.04,0.21,0.1 c0.1,0.11,0.13,0.28,0.03,0.41l-0.41,0.56l45.93-0.16c0.25-0.28,0.67-0.5,1.18-0.67c0.2-0.07,0.41-0.13,0.63-0.19 c6.79-1.77,21.64-3.73,25.36-4.24c0.53-0.07,1.01-0.34,1.37-0.75c1.18-1.36,2.96-2.93,4.02-3.83 c0.09-0.07,0.17-0.15,0.25-0.21c0.36-0.3,0.8-0.48,1.27-0.51c0.05,0,0.11-0.01,0.16-0.01c0,0-0.05-0.01-0.14-0.02 c-2.09-0.29-26.94-3.65-59.66-3.65C869.73,447.39,860.45,449.01,857.76,450.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M986.17,456.84c-5.4-3.53-14.88-5.72-29.55-5.79c-0.52,0-1.03,0.18-1.43,0.52 c-1.01,0.85-2.99,2.57-4.26,4.04c-0.35,0.41-0.84,0.67-1.37,0.75c-3.72,0.51-18.57,2.47-25.36,4.24 c-0.22,0.06-0.43,0.12-0.63,0.19c-0.51,0.17-0.93,0.38-1.18,0.67c-0.29,0.33-0.33,0.77,0.02,1.35l4.25,6.8 c0.41,0.68,1.14,1.09,1.93,1.08c0.51-0.01,1.14-0.01,1.79,0.02c0.34,0.02,0.69,0.04,1.04,0.07c0.44,0.02,0.76,0.06,0.97,0.12 c0.58,0.1,1.11,0.23,1.53,0.42c1.96,0.9,7.07,4.79,11.39,4.79c4.32,0,26.91,0,29.86,0s6.48-2.8,9.13-7.09 C986.96,464.74,991.67,460.44,986.17,456.84z M982.02,460.49c-24.98-1.68-50.05,1.78-54.21,2.39c-0.3,0.04-0.48,0.37-0.36,0.66 l0.71,1.69c0.08,0.18,0.26,0.3,0.45,0.29c0.89-0.04,3.4-0.16,5.3-0.22c2.34-0.08,3.28,0.16,5.86,0.95 c2.58,0.79,4.84,1.99,9.46,2.15c4.21,0.15,25.02-0.51,28.56-0.62c-2.31,3.07-5.53,6.09-7.93,6.09c-1.89,0-19.78,0-22.64,0 c-2.87,0-8.83-4.14-10.87-4.84c-1.68-0.57-6.93-0.77-8.74-0.83c-0.39-0.01-0.73-0.23-0.92-0.57l-2.57-4.72 c-0.35-0.64,0-1.44,0.69-1.61c2.78-0.69,9.83-2.26,21.57-3.71c15.62-1.92,31.47-1,34.27,0.61 C981.81,458.88,982.16,459.61,982.02,460.49z M948.71,467.08c0,0.14-0.12,0.26-0.26,0.26c-0.71,0-2.74-0.02-3.89-0.14 c-1.36-0.14-3.06-0.98-4.03-1.52c-0.23-0.13-0.15-0.49,0.12-0.49l7.8-0.18c0.14,0,0.26,0.11,0.26,0.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M940.65,465.22c-0.26,0.01-0.35,0.36-0.12,0.49c0.98,0.54,2.68,1.38,4.05,1.52 c1.16,0.12,3.19,0.13,3.9,0.14c0.14,0,0.26-0.12,0.26-0.26v-1.8c0-0.15-0.12-0.26-0.26-0.26L940.65,465.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M876.84,460.64c-0.05-0.06-0.13-0.09-0.21-0.1l-4.81-0.16c-0.03,0-0.06-0.01-0.08-0.01l-14.69-4.74 c-0.13-0.04-0.22-0.16-0.22-0.3v-1.52c0-0.05-0.01-0.09-0.02-0.12c-0.09-0.22-0.41-0.27-0.55-0.04l-1.41,2.3 c-0.02,0.04-0.05,0.07-0.09,0.1l-1.42,0.96c0,0,0,0-0.01,0c0.02,0,0.04,0,0.06,0.01l16.23,3.85c0.35,0.08,0.55,0.46,0.43,0.81 l-1.85,5.03c-0.09,0.24-0.31,0.4-0.56,0.4h-5.47c-0.15,0-0.29,0.05-0.4,0.15l-4.8,4.3c-0.11,0.1-0.25,0.15-0.4,0.15h-4.52 c-0.23,0-0.42-0.13-0.53-0.32l-0.04,0.64c0,0.04,0,0.08,0.01,0.12l0.53,1.67c0.04,0.13,0.16,0.22,0.3,0.22h6.45 c0.05,0,0.11-0.01,0.15-0.04l6.73-3.84c0.04-0.02,0.08-0.04,0.13-0.04l4.04-0.3l0.5-0.04c0.09-0.01,0.17-0.05,0.23-0.13 l5.91-8.05l0.41-0.56C876.97,460.92,876.94,460.75,876.84,460.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M852.04,471.72h4.52c0.15,0,0.29-0.05,0.4-0.15l4.8-4.3c0.11-0.1,0.25-0.15,0.4-0.15h5.47 c0.25,0,0.48-0.16,0.56-0.4l1.85-5.03c0.13-0.35-0.07-0.73-0.43-0.81l-16.23-3.85c-0.02,0-0.04-0.01-0.06-0.01 c-0.06,0.05-0.11,0.11-0.13,0.19l-0.53,2.38c-0.03,0.15,0.05,0.31,0.19,0.37l0.69,0.27c0.02,0.01,0.04,0.02,0.06,0.03 l13.72,1.88c0.38,0.05,0.62,0.45,0.48,0.82l-0.79,2.14c-0.08,0.22-0.28,0.38-0.51,0.4l-5.29,0.45 c-0.11,0.01-0.22,0.05-0.31,0.12l-4.38,3.37c-0.12,0.09-0.26,0.13-0.41,0.12l-4.11-0.29c-0.14-0.01-0.27,0.03-0.38,0.11 l-0.12,2.03C851.61,471.59,851.81,471.72,852.04,471.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1CAB7",
    d: "M856.36,465.99l1.64,0.07c0.05,0,0.1-0.01,0.14-0.04l1.74-1.31c0.16-0.12,0.09-0.39-0.11-0.41 l-3.38-0.34c-0.13-0.01-0.24,0.09-0.24,0.23v1.58C856.14,465.89,856.24,465.99,856.36,465.99z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0398 0.0398 0.9992 -17.4072 36.0225)",
    fill: "#1EBEE4",
    cx: 894.98,
    cy: 454.7,
    rx: 3.46,
    ry: 4.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0401 0.0401 0.9992 -17.5363 36.2854)",
    fill: "#141616",
    cx: 894.68,
    cy: 454.77,
    rx: 2.83,
    ry: 4.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0401 0.0401 0.9992 -17.5363 36.2854)",
    fill: "#FFFFFF",
    cx: 894.68,
    cy: 454.77,
    rx: 1.76,
    ry: 2.52
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M894.58,452.26v2.48h-1.65C892.93,454.73,892.85,452.47,894.58,452.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M894.58,454.73v2.56c0,0,1.82,0.19,1.86-2.56L894.58,454.73z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M860.29,489l1.08-0.03c0,0-0.71,2.99-0.74,3.14c-0.03,0.15-0.11,0.28-0.43,0.25s-0.79-0.1-0.79-0.1 s0.58-2.77,0.67-3.02S860.29,489,860.29,489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M860.53,489.91c0,0,0.39,0.08,0.47-0.13c0.07-0.21,0.12-0.46,0.12-0.46l-0.45,0.02L860.53,489.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M860.92,490.1c0,0-0.16,0-0.29,0c-0.13,0-0.18,0.11-0.21,0.23c-0.03,0.13-0.39,1.8-0.39,1.8 s0.23,0.01,0.32,0.02c0.09,0.01,0.15-0.1,0.21-0.34C860.61,491.57,860.92,490.1,860.92,490.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M861.69,489.38l0.38-0.01c0.02,0,0.04,0.01,0.05,0.03l0.34,0.76c0.01,0.03,0.06,0.04,0.08,0.02l0.84-0.8 c0.01-0.01,0.02-0.01,0.04-0.01l0.61,0c0.05,0,0.07,0.06,0.04,0.09l-1.27,1.31c-0.02,0.02-0.02,0.04-0.01,0.06l0.69,1.38 c0.02,0.04-0.01,0.08-0.05,0.08l-0.54-0.03c-0.02,0-0.03-0.01-0.04-0.03l-0.48-0.95c-0.02-0.03-0.06-0.04-0.08-0.01 c-0.17,0.18-0.72,0.75-0.78,0.8c-0.07,0.06-0.09,0.06-0.23,0.05c-0.08,0-0.19-0.02-0.27-0.02c-0.04,0-0.06-0.06-0.03-0.09 l1.12-1.29c0.01-0.01,0.02-0.04,0.01-0.05l-0.45-1.21C861.63,489.42,861.66,489.38,861.69,489.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M864.61,489.86l1.85,0.01c0.03,0,0.05,0.03,0.04,0.05l-0.19,0.68c-0.01,0.02-0.02,0.03-0.04,0.03 c-0.17,0-0.94-0.01-1.09-0.02c-0.15,0-0.22,0.19-0.26,0.39c-0.01,0.03,0.01,0.05,0.04,0.05l1.13,0.05 c0.03,0,0.04,0.03,0.04,0.05c-0.03,0.14-0.12,0.55-0.15,0.63c-0.04,0.1-0.08,0.08-0.22,0.07s-1.23-0.05-1.47-0.05 c-0.22,0-0.34,0.22-0.39,0.46c-0.01,0.02,0.01,0.05,0.04,0.05c0.3,0.02,2.01,0.14,2.24,0.16c0.25,0.02,0.44-0.11,0.53-0.51 c0.09-0.4,0.71-2.31,0.76-2.53c0.06-0.22-0.21-0.16-0.31-0.17c-0.11-0.01-1.97,0.03-2.18,0.04c-0.2,0.01-0.37,0.22-0.42,0.51 C864.56,489.84,864.58,489.86,864.61,489.86z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M968.8,427.54c0.33,0.46,0.49,0.74,0.49,0.74s-3.8,7.01-7.01,11.36c-3.21,4.35-19.85,4.35-29.59,4.83 c-9.75,0.48-33.87,0.48-33.87,0.48s-26.17,0.14-30.83-0.15c-4.67-0.29-2.13-2.28-1.21-3.28c0.92-1,3.23-3.51,11-12.13 c0.2-0.22,0.39-0.43,0.59-0.64l-0.77,0.01c0,0-7.29,8.05-13.97,15.31c-3.26,3.55-4.96,5.53-5.84,6.64 c2.69-1.72,11.97-3.34,39.05-3.34c32.71,0,57.57,3.36,59.66,3.65c1.17-1.77,4.02-6.11,5.83-9.31c2.33-4.1,8.07-14.2,8.07-14.2 L968.8,427.54z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F1",
    d: "M998.06,403.61c0.47,0,0.74-0.01,0.8-0.01C998.59,403.6,998.33,403.6,998.06,403.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F1",
    d: "M998.86,403.6C998.86,403.6,998.86,403.6,998.86,403.6C998.87,403.6,998.86,403.6,998.86,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M973.92,419.5c-1.55-0.9-8.79-4.94-15.31-6.05c-7.35-1.25-16.12-1.25-16.53-1.35 c-0.38-0.1-3.28,0.78-3.72,0.92c-0.04,0.01-0.08,0.02-0.11,0.02c-1.43-0.04-28.84-0.78-43.46,1.03c-0.04,0-0.07,0-0.11,0 l-2.85-0.5c-0.04-0.01-0.07-0.01-0.11,0c-0.66,0.08-7.19,0.9-9.13,2.28c-0.45,0.32-0.83,0.71-1.15,1.15 c-1.17,1.57-1.64,3.66-1.8,4.56c-0.17,0.96,0.02,2.29,0.08,2.68c0.01,0.08,0,0.16-0.03,0.23l-1.82,3.77 c-0.12,0.25,0.06,0.55,0.34,0.54c0.1,0,0.19-0.04,0.26-0.12c7.47-7.9,13.68-8.59,17.49-8.59c3.92,0,41.6,0,55.26,0 c10.87,0,15.87,5.19,17.47,7.32c0.07,0.1,0.18,0.15,0.3,0.15l1.2-0.02c0.14,0,0.26-0.08,0.33-0.21l3.57-7.32 C974.15,419.82,974.09,419.6,973.92,419.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464648",
    d: "M918.09,439.41c0,0,0.1,0.47,1.32,0.59c0.91,0.09,7.1,0.1,10.05,0.16c1.32-0.23,2.1-0.76,1.49-1.07 c-0.84-0.43-10.25,0-11.6-0.74c-1.36-0.74-14.64-1.17-17.56-1.06c-2.93,0.11-5.07,0.46-4.47,2.52c0.02,0.07,0.15-0.1,0.18-0.03 c1.06-0.44,2.76-0.86,6.97-0.86C910.64,438.91,918.09,439.41,918.09,439.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M902.89,442.12c0.18-0.11,0.3-0.3,0.32-0.51c0.03-0.31,0.26-0.78,1.27-0.89 c3.14-0.32,11.81-0.32,14.64-0.32c1.38,0,6.69-0.32,8.89-0.21c0.6,0.03,1.16-0.01,1.65-0.1c-2.95-0.06-8.91-0.18-9.82-0.28 c-0.7-0.07-1-0.31-1.12-0.5c-0.11-0.16-0.29-0.26-0.48-0.28c-1.66-0.13-8.23-0.6-13.59-0.6c-3.42,0-5.6,0.16-6.87,0.46 c-0.4,0.09-0.61,0.53-0.46,0.91c0.35,0.87,0.72,1.74,0.9,2.16c0.07,0.16,0.2,0.29,0.36,0.35 C900.66,443.16,902.23,442.5,902.89,442.12z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M902.43,415.03c-0.21,0-0.39-0.17-0.4-0.38c-0.02-0.23,0.15-0.42,0.38-0.44 c0.1-0.01,10.52-0.74,23.14-0.41c0.22,0.01,0.4,0.2,0.39,0.42c-0.01,0.23-0.19,0.41-0.42,0.4c-12.58-0.33-22.96,0.4-23.07,0.4 C902.45,415.03,902.44,415.03,902.43,415.03z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M973.02,409.08l3.33,1.13c0,0,62.42-12.67,114.95,6.39c0,0-1.7-4.78-15.17-8.16 c-11.21-2.82-37.57-9.39-80.52-4.93C987.92,404.31,980.37,406.04,973.02,409.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 973.0213,
    y1: 409.301,
    x2: 1091.3057,
    y2: 409.301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    style: {
      stopColor: "#1C1C1A",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M973.02,409.08l3.33,1.13c0,0,62.42-12.67,114.95,6.39c0,0-1.7-4.78-15.17-8.16 c-11.21-2.82-37.57-9.39-80.52-4.93C987.92,404.31,980.37,406.04,973.02,409.08z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M971.21,476.1c-6.37,2.62-11.24,9.59-11.24,9.59c8.75,0.55,7.97,6.84,7.52,15.02 c-0.06,1.1-0.18,2.41-0.33,3.82l0.23-1.67c0,0,18.78,2.34,19.93,2.34c1.15,0,5.99,1.64,9.1-3.05c1.63-2.46,5.8-9.76,12.63-15.63 c-4-1.07-13.07-3.53-19.4-5.52c-5.27-1.66-8.39-4.69-9.98-6.69c-1.52,1.15-3.08,1.79-4.49,1.79 C974.58,476.1,973.14,476.1,971.21,476.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C9C6",
    d: "M1127.44,450.53l-0.27,0.63c0,0-7.27-8.22-19.52-20.26c-12.25-12.05-24.44-16.38-43.96-18.79 c-19.52-2.41-49.32-0.67-54.99-0.27c-5.67,0.4-13.98,2.15-15.03,4.69c-1.05,2.55-3.82,10.33-4.62,14.89 c-0.79,4.56,0.4,6.44,3.43,7.38c3.03,0.94,15.69,5.63,22.29,7.64c6.59,2.01,20.18,5.9,27.03,6.57 c6.86,0.67,31.39,2.68,31.39,2.68s48.4,5.5,52.35,5.63c3.96,0.13,6.59-2.15,6.59-2.15c0.83-0.21,1.42-0.71,1.88-1.01 L1127.44,450.53z M1125.27,460.22c-4.53-0.31-43.85-4.83-49.48-5.34c-5.64-0.51-32-3.07-35.93-3.68 c-3.92-0.61-18.62-3.89-24.05-5.73c-5.43-1.84-17.51-6.14-20.33-7.16c-2.82-1.02-2.52-4.71-2.01-6.96 c0.5-2.25,2.42-9.62,2.42-9.62c0.81-2.35,2.11-5.32,9.06-6.65c6.94-1.33,27.47-3.38,57.97-1.13 c30.49,2.25,41.76,14.94,52.23,25.69c10.47,10.75,15.41,18.03,15.41,18.03S1129.8,460.52,1125.27,460.22z"
  })), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1004.94,415.06c-6.94,1.33-8.25,4.3-9.06,6.65c0,0-1.91,7.37-2.42,9.62c-0.5,2.25-0.81,5.94,2.01,6.96 c2.82,1.02,14.89,5.32,20.33,7.16c2.26,0.77,6.12,1.78,10.14,2.75c-0.38-7-1.55-23.83-4.35-34.88 C1013.64,413.76,1007.99,414.48,1004.94,415.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 996.6517,
    y1: 441.8634,
    x2: 1027.7146,
    y2: 423.9292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M1004.94,415.06c-6.94,1.33-8.25,4.3-9.06,6.65c0,0-1.91,7.37-2.42,9.62 c-0.5,2.25-0.81,5.94,2.01,6.96c2.82,1.02,14.89,5.32,20.33,7.16c2.26,0.77,6.12,1.78,10.14,2.75c-0.38-7-1.55-23.83-4.35-34.88 C1013.64,413.76,1007.99,414.48,1004.94,415.06z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    fill: "#A1C8D9",
    d: "M1115.14,439.63c-10.47-10.75-21.74-23.44-52.23-25.69c-1.62-0.12-3.2-0.23-4.76-0.32 l17.27,41.22c0.13,0.01,0.26,0.02,0.37,0.03c5.64,0.51,44.95,5.04,49.48,5.34c4.53,0.31,5.27-3,5.27-3 S1125.6,450.37,1115.14,439.63z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1021.59,413.32c0,0,3.48,21.56,3.62,34.64l0.73,0.24c0,0,0.88-12.09-3.45-34.93L1021.59,413.32z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1058.15,413.62l17.27,41.22l12.38,1.35l-20.21-41.68C1067.59,414.5,1063.86,413.89,1058.15,413.62z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "1060.65,413.78 1079.32,455.21 1087.8,456.19 1067.59,414.5  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1117.91,442.53l7.37,17.68c0,0,2.69,0.41,4.48-1.32C1131.55,457.18,1125.68,450.84,1117.91,442.53z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M940.7,520.91l5.88,3.4c0.29,0.17,0.61,0.24,0.94,0.22c2.23-0.13,11.25-0.62,14.18-0.62 c3.35,0,3.36-4.01,3.36-4.01S950.76,520.74,940.7,520.91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 940.7042,
    y1: 522.2126,
    x2: 965.0566,
    y2: 522.2126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M940.7,520.91l5.88,3.4c0.29,0.17,0.61,0.24,0.94,0.22c2.23-0.13,11.25-0.62,14.18-0.62 c3.35,0,3.36-4.01,3.36-4.01S950.76,520.74,940.7,520.91"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1174.71,482.42c-18.34-3.62-24.52,38.63-24.52,38.63c-26.82,0.76-94.58,3.4-95.25,3.99 c0,0.02-0.01,0.02-0.01,0.01c0,0,0-0.01,0.01-0.01c0.18-0.79,4.72-36.22-22.09-39.96c-27.32-3.81-38.31,38.37-38.31,38.37 l-29.49-3.56c0,0-0.8,5.72-1.32,9.36c-0.22,1.58,0.46,3.94,2.07,4.62c7.3,3.05,28.46,10.96,28.46,10.96s3.21-18.82,7.43-30.49 c4.22-11.67,12.3-23.14,23.2-24.18c9.95-0.95,28.89,0.46,27.44,29.68c-0.26,5.23-0.79,16.76-1.19,19.04s-2.11,4.02-2.11,4.02 s79.78-8.85,99.56-9.25c0,0,0.66-0.13,1.45-1.61c0.79-1.48,2.9-16.09,5.27-24.94c2.37-8.85,7.52-23.2,19.78-20.65 c12.26,2.55,11.6,20.12,10.29,31.11l-0.92,3.89l-0.13,3.89c0,0,3.6-1.75,3.84-7.51l-1.87,0.19 C1186.31,518.01,1193.05,486.03,1174.71,482.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1174.52,478.23c-17.63-2.9-22.43,25.77-26.25,31.64c-1.32,2.02-1.45,2.66-5.09,2.49 c-3.4-0.16-9.01-0.1-9.01-0.1c-2.25,0-71.15-2.23-73.84-2.59c-2.69-0.37-2.29-0.7-2.75-3.75s-1.04-23.67-23.39-27.18 s-34.68,18.74-37.79,23.43c-3.11,4.69-7.95,3.05-9.1,3.05c-1.15,0-19.93-2.34-19.93-2.34l-2.33,17.02l29.49,3.56 c0,0,10.99-42.18,38.31-38.37c26.81,3.73,22.27,39.16,22.09,39.96c0.67-0.59,68.43-3.23,95.25-3.99c0,0,6.18-42.25,24.52-38.63 c18.34,3.62,11.6,35.59,11.6,35.59l1.87-0.19C1188.18,517.82,1193.23,481.31,1174.52,478.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1054.94,525.05C1054.94,525.06,1054.94,525.05,1054.94,525.05 C1054.94,525.04,1054.94,525.05,1054.94,525.05z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1075.86,533.29l3.32,0.07c0.28,0.01,0.46,0.32,0.32,0.57l-0.2,0.35c-0.15,0.26,0.05,0.59,0.35,0.57 l5.75-0.35c0.06,0,0.11-0.02,0.16-0.05l2.75-1.59c0.06-0.03,0.13-0.05,0.19-0.05l2.76,0.06c0.29,0.01,0.47,0.34,0.3,0.59 l-0.01,0.02c-0.17,0.26,0.02,0.6,0.32,0.59l5.95-0.14c0.07,0,0.13-0.02,0.19-0.06l2.97-1.89c0.06-0.04,0.13-0.06,0.21-0.06 l3.02,0.06c0.32,0.01,0.48,0.39,0.27,0.63l0,0c-0.22,0.25-0.03,0.64,0.3,0.63l4.56-0.2c0.05,0,0.1-0.01,0.14-0.03l3.09-1.46 c0.04-0.02,0.09-0.03,0.14-0.03l3.17-0.19c0.32-0.02,0.52,0.36,0.31,0.62l-0.02,0.03c-0.21,0.25-0.02,0.64,0.31,0.62l4.26-0.2 c0.06,0,0.12-0.02,0.17-0.05l2.99-1.75c0.05-0.03,0.12-0.05,0.18-0.05l3.16-0.06c0.29-0.01,0.48,0.32,0.33,0.58l-0.14,0.24 c-0.16,0.26,0.04,0.59,0.34,0.58l4.08-0.2c0.06,0,0.12-0.02,0.18-0.06l3.06-1.89c0.06-0.04,0.13-0.06,0.19-0.06h2.55 c0.3,0,0.48,0.35,0.31,0.6c-0.34,0.49-0.75,1.1-0.6,1c0.2-0.14,2.18-0.16,2.76-0.16c0.1,0,0.19-0.04,0.26-0.11l2.61-2.72 c0.24-0.25,0.05-0.66-0.28-0.64c-7.99,0.39-63.9,3.1-66.09,3.39c-2.36,0.32-5.98-1.52-9.28-1.04s-1.89,2.24-1.26,2.8 s2.91,2.16,3.54,2.56c0.63,0.4,2.44,0.24,3.78-0.8c1.14-0.88,1.99-1.19,2.22-1.26C1075.78,533.3,1075.82,533.29,1075.86,533.29z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1076,532.79c-2,0.87-2.05,1.96-4.23,0.91c-2.18-1.04-1.44-0.63-2.18-1.04s-1.37-1.58,1.32-1.63 s58.55-2.55,70.94-3.37l-2.07,1.49c0,0-18.04,1.16-37.7,2.07C1082.42,532.13,1077.2,532.26,1076,532.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1068.9443,
    y1: 530.8909,
    x2: 1141.8422,
    y2: 530.8909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5959,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.2289
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.4494
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.6
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M1076,532.79c-2,0.87-2.05,1.96-4.23,0.91c-2.18-1.04-1.44-0.63-2.18-1.04s-1.37-1.58,1.32-1.63 s58.55-2.55,70.94-3.37l-2.07,1.49c0,0-18.04,1.16-37.7,2.07C1082.42,532.13,1077.2,532.26,1076,532.79z"
  })), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M925.72,535.53c0.39,0.06,0,1.73,0,1.73l-10.31-1.86l-1.7-11.02 C913.71,524.38,914.62,533.8,925.72,535.53z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M913.71,524.38l16.44,0.93c0,0,11.75,7.03,13.18,8.23c1.44,1.19,1.31,4.11,1.31,4.11l-18.92-0.4v-1.73 c0,0-2.74-0.53-5.74-1.73C916.97,532.61,913.97,527.57,913.71,524.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 929.1761,
    y1: 524.3812,
    x2: 929.1761,
    y2: 537.6534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M913.71,524.38l16.44,0.93c0,0,11.75,7.03,13.18,8.23c1.44,1.19,1.31,4.11,1.31,4.11l-18.92-0.4 v-1.73c0,0-2.87-0.38-5.73-1.89C916.61,531.85,913.97,527.57,913.71,524.38z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M952.86,538.45l-8.22-0.8c0,0,0.45-2.88-1.7-4.19c-2.15-1.31-12.78-8.15-12.78-8.15l0.99-1.48 c0,0,10.59,7.27,12.57,8.67c1.98,1.4,2.32,4.2,2.32,4.2l6.8,1.23L952.86,538.45z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M913.58,523.48l0.13,0.9l1.7,11.02l-1.31-0.01C914.09,535.39,912.28,523.74,913.58,523.48z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M913.58,523.48c0,0,13.69,0.09,17.57,0.35l-0.99,1.48l-16.44-0.93L913.58,523.48z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M931.14,523.83l21.7,14.1l-7.23-1.05c0,0-0.26-2.45-1.46-3.59c-1.21-1.14-13.43-8.67-13.43-8.67 L931.14,523.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.7111,
    y1: 530.8755,
    x2: 952.8401,
    y2: 530.8755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M931.14,523.83l21.7,14.1l-7.23-1.05c0,0-0.26-2.45-1.46-3.59c-1.21-1.14-13.43-8.67-13.43-8.67 L931.14,523.83z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M850.16,530.64l-0.71-3.03c0,0,2.51-5.9,3.15-7.13c0.2-0.38,0.18-0.73,0.18-0.73s-1.04,0.82-1.91,2.45 c-1.28,2.38-1.91,3.97-1.99,4.9c-0.07,0.94,0.57,3.39,0.57,3.39L850.16,530.64z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M852.79,519.75c0,0,9.79,0.36,11.35,0.79c1.56,0.43,1.77,1.01,2.27,3.75s1.13,4.98,1.13,4.98l2.98,3.32 l-4.75-0.43l-0.21-0.79l-4.4-0.22l-0.14,0.94l-10.85-1.44l-0.71-3.03L852.79,519.75z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M852.79,519.75c0,0-1.49,3.17-1.91,4.83c-0.43,1.66,0.64,1.51,1.91,1.73c1.28,0.22,3.26,3.53,8.37,4.83 l4.4,0.22c0,0-1.35-7.43-1.49-8.58c-0.14-1.15-0.43-2.16,0.07-2.24C864.13,520.54,855.98,519.82,852.79,519.75z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M865.77,532.16h0.92c0,0-1.63-9.37-1.91-10.38c-0.28-1.01-1.06-0.87-0.85,0.22 C864.13,523.07,865.77,532.16,865.77,532.16z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1026.63,506.34c0.45,0.65,1.99,2.89,1.99,2.89l3.64-0.06l1.67-2.62 C1033.93,506.54,1031.62,505.1,1026.63,506.34z"
  })), /*#__PURE__*/React.createElement("g", null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1171.66,490.01c4.9,0,13.78,7.24,12.81,31.18c-0.9,22.15-10.55,28.5-14.82,28.5 c-3.61,0-22.45,4.19-26.96-16.01c0,0,7.51,1.87,9.01-7.81C1152.82,518.68,1154.87,490.01,1171.66,490.01z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1156.73,522.6c-0.33-5.45-1-10.29-1.86-14.22c0,0,4.89-19.97,17.13-17.31 c14.1,3.06,12.68,32.75,11.86,37.35c-1.04,5.82-3.79,20-13.85,21.14C1159.96,550.71,1157.11,528.81,1156.73,522.6z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0174 -0.9998 0.9998 0.0174 630.9325 1681.1274)",
    fill: "#FFFFFF",
    cx: 1170.77,
    cy: 519.57,
    rx: 24.56,
    ry: 11.62
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#191C1C",
    points: "1173.68,496.71 1174.79,505.95 1180.39,507.45 1181.6,517.39 1177.29,523.25 1178.78,534.49 1176.32,535.52 1174.65,540.67 1171.07,534.28 1166.1,540.93 1164.75,535.46 1162.21,534.67 1164.43,523.25 1159.87,517.57 1161.83,512.77 1161.61,506.91 1166.94,506.39 1168.79,496.53 1170.98,497.83  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.3838,
    y1: 541.6533,
    x2: 1171.0454,
    y2: 495.5911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7515,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_)",
    strokeMiterlimit: 10,
    d: "M1168.79,496.53l-2.15,8.06l-5.03,2.33 c0,0-1.54,6.53-1.74,10.65l3.22,7.16l-0.87,9.94c0,0,1.41,4.21,3.89,6.27l4.49-4.03l4.02,4.03c0,0,2.88-3.31,4.16-6.45 l-0.27-9.67l3.09-7.43c0,0,0-5.46-1.21-9.94l-4.49-1.97l-2.21-8.77C1173.68,496.71,1172.07,495.46,1168.79,496.53z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1173.68,496.71 1172.81,509.51 1174.29,511.57 1180.39,507.45 1175.9,505.48  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1168.79,496.53 1168.05,509.06 1166.64,511.39 1161.61,506.91 1166.64,504.59  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1161.61,506.91l1.21,3.94l-1.14,5.73l-1.81,0.98C1159.87,517.57,1160.2,511.66,1161.61,506.91z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1180.39,507.45l-1.48,3.49l0.67,5.37l2.01,1.07C1181.6,517.39,1181.6,512.11,1180.39,507.45z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1181.6,517.39 1175.56,521.15 1174.89,524.73 1178.78,534.49 1178.51,524.82  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1178.78,534.49l-2.01-1.7l-2.08,3.22l-0.07,4.92C1174.62,540.93,1177.91,537.35,1178.78,534.49z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1174.62,540.93 1170.8,530.46 1169.32,530.01 1166.1,540.93 1170.6,536.9  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1166.1,540.93l0.54-4.57c0,0-2.48-3.58-2.55-3.31c-0.07,0.27-1.88,1.61-1.88,1.61 S1164.03,539.32,1166.1,540.93z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "1162.21,534.67 1165.43,524.19 1165.03,520.79 1159.87,517.57 1163.09,524.73  "
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1175.9,
    y1: 505.48,
    x2: 1177.71,
    y2: 500.65
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1178.51,
    y1: 524.82,
    x2: 1181.26,
    y2: 526.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1170.6,
    y1: 536.9,
    x2: 1170.6,
    y2: 543.08
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1163.09,
    y1: 524.73,
    x2: 1160.27,
    y2: 526.52
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1166.64,
    y1: 504.59,
    x2: 1164.56,
    y2: 500.56
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 1168.81,
    cy: 519.31,
    rx: 1.09,
    ry: 2.46
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1EBEE4",
    cx: 1168.81,
    cy: 519.31,
    rx: 0.71,
    ry: 1.61
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 846.8315,
    y1: 503.3488,
    x2: 967.7267,
    y2: 503.3488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M959.96,485.71c0,0-0.73,4.47-1.44,10.05c-0.57,4.46-0.95,8.49-3.94,9.46 c-2.98,0.97-14.91,3.4-19.44,3.52c-3.36,0.09-39.57-1.29-61.39-2.01c-7.58-0.25-13.42-0.42-15.54-0.42 c-8.23,0-9.06-2.79-9.78-5.46c-0.57-2.14-1.15-4.98-1.35-6.02c0,2.88,0,5.6,0,6.47c0,1.97-0.25,5.6-0.25,7.38 c0,1.78,0.39,5.63,0.39,5.63s0.69,1.61,6.35,2.16c2.21,0.21,14.09,0.95,28.2,1.77c21.97,1.28,49.36,2.75,54.2,2.75 c7.94,0,29.08-1.1,29.08-1.1s2.08-13,2.42-19.17C967.93,492.55,968.71,486.26,959.96,485.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 903.8052,
    y1: 460.2295,
    x2: 903.8052,
    y2: 502.5771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M857.47,493.59c1.18,2.2,1.77,5.89,7.47,6.29c5.51,0.39,64.78,2.55,74.71,2.69 c4.56-4.11,5.94-12.22,6.82-16.5c1.21-5.89,2.97-9.95,2.97-9.95l2.37-0.01l0.1-0.23l-1.83-15.66c0,0-21.81,0.93-29.88,0.93 c-8.07,0-44.88-0.63-44.88-0.63l-5.47,6.92c0,0-9.46,1.88-9.26,1.88c0.2,0-4.9,4.77-4.9,4.77l0.09,11.93 C855.99,488.62,856.56,491.89,857.47,493.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 847.0818,
    y1: 491.3936,
    x2: 971.6541,
    y2: 491.3936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M951.82,476.12l-2.4,0.01c0,0-1.73,4.06-2.94,9.95c-0.88,4.28-2.26,12.39-6.82,16.5 c-0.39,0.36-0.81,0.68-1.26,0.97c-1.49,0.97-3.26,1.56-5.38,1.56c-10.1,0-71.9-2.88-75.13-3.29c-3.23-0.41-4.04-2.33-4.31-8.49 c-0.27-6.16-0.36-9.67-0.36-10.7c0-1.03,2.49-8.52,2.49-8.52l-3.61-0.06c0,0-3.32,6.94-4.01,8.53c-0.69,1.59-1,2.74-1,4.01 c0,0.71,0,4.6,0,8.24c0.2,1.04,0.78,3.88,1.35,6.02c0.72,2.67,1.55,5.46,9.78,5.46c8.23,0,72.39,2.55,76.93,2.43 c4.53-0.12,16.46-2.55,19.44-3.52c2.98-0.97,3.36-5,3.94-9.46c0.72-5.58,1.44-10.05,1.44-10.05s5.1-7.3,11.7-9.77L951.82,476.12z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 851.6305,
    y1: 464.9039,
    x2: 867.8549,
    y2: 464.9039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M852.01,469.26l4.11,0.29c0.15,0.01,0.29-0.03,0.41-0.12l4.38-3.37c0.09-0.07,0.2-0.11,0.31-0.12 l5.29-0.45c0.23-0.02,0.43-0.17,0.51-0.4l0.79-2.14c0.14-0.37-0.1-0.77-0.48-0.82l-13.72-1.88c0.09,0.06,0.14,0.16,0.14,0.27 l-0.17,6.53c0,0.08-0.03,0.16-0.09,0.22l-1.76,1.79c-0.05,0.05-0.09,0.13-0.09,0.21l-0.01,0.1 C851.74,469.29,851.87,469.25,852.01,469.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 851.4706,
    y1: 463.7719,
    x2: 876.9299,
    y2: 463.7719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M876.63,460.55l-4.81-0.16c-0.03,0-0.06-0.01-0.08-0.01l-14.69-4.74 c-0.13-0.04-0.22-0.16-0.22-0.3v-1.52c0-0.32-0.41-0.44-0.58-0.17l-1.41,2.3c-0.02,0.04-0.05,0.07-0.09,0.1l-1.42,0.96 c0,0,0,0-0.01,0c0.02,0,0.04,0,0.06,0.01l16.23,3.85c0.35,0.08,0.55,0.46,0.43,0.81l-1.85,5.03c-0.09,0.24-0.31,0.4-0.56,0.4 h-5.47c-0.15,0-0.29,0.05-0.4,0.15l-4.8,4.3c-0.11,0.1-0.25,0.15-0.4,0.15h-4.52c-0.23,0-0.42-0.13-0.53-0.32l-0.04,0.64 c0,0.04,0,0.08,0.01,0.12l0.53,1.67c0.04,0.13,0.16,0.22,0.3,0.22h6.45c0.05,0,0.11-0.01,0.15-0.04l6.73-3.84 c0.04-0.02,0.08-0.04,0.13-0.04l4.54-0.34c0.09-0.01,0.17-0.05,0.23-0.13l6.33-8.6C877.02,460.85,876.88,460.56,876.63,460.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 851.5095,
    y1: 464.3651,
    x2: 870.077,
    y2: 464.3651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M852.04,471.72h4.52c0.15,0,0.29-0.05,0.4-0.15l4.8-4.3c0.11-0.1,0.25-0.15,0.4-0.15h5.47 c0.25,0,0.48-0.16,0.56-0.4l1.85-5.03c0.13-0.35-0.07-0.73-0.43-0.81l-16.23-3.85c-0.02,0-0.04-0.01-0.06-0.01 c-0.06,0.05-0.11,0.11-0.13,0.19l-0.53,2.38c-0.03,0.15,0.05,0.31,0.19,0.37l0.69,0.27c0.02,0.01,0.04,0.02,0.06,0.03l13.72,1.88 c0.38,0.05,0.62,0.45,0.48,0.82l-0.79,2.14c-0.08,0.22-0.28,0.38-0.51,0.4l-5.29,0.45c-0.11,0.01-0.22,0.05-0.31,0.12l-4.38,3.37 c-0.12,0.09-0.26,0.13-0.41,0.12l-4.11-0.29c-0.14-0.01-0.27,0.03-0.38,0.11l-0.12,2.03 C851.61,471.59,851.81,471.72,852.04,471.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 853.2123,
    y1: 489.6059,
    x2: 939.6519,
    y2: 489.6059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M864.94,499.89c-5.7-0.4-6.29-4.1-7.47-6.29c-0.91-1.7-1.48-4.97-1.68-7.56 c-0.06-0.75-0.09-1.44-0.09-2.03c0-2.6,0-9.9,0-9.9s-2.49,7.5-2.49,8.52c0,1.03,0.09,4.54,0.36,10.7 c0.27,6.16,1.08,8.08,4.31,8.49c3.23,0.41,65.03,3.29,75.13,3.29c2.12,0,3.9-0.58,5.38-1.56c0.44-0.29,0.86-0.62,1.26-0.97 C929.72,502.44,870.45,500.27,864.94,499.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 922.1584,
    y1: 463.5851,
    x2: 988.7209,
    y2: 463.5851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2965,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M986.17,456.84c-5.4-3.53-14.88-5.72-29.55-5.79c-0.52,0-1.03,0.18-1.43,0.52 c-1.01,0.85-2.99,2.57-4.26,4.04c-0.35,0.41-0.84,0.67-1.37,0.75c-3.72,0.51-18.57,2.47-25.36,4.24 c-0.22,0.06-0.43,0.12-0.63,0.19c-1.1,0.37-1.81,0.93-1.16,2.02l4.25,6.8c0.41,0.68,1.14,1.09,1.93,1.08 c0.51-0.01,1.14-0.01,1.79,0.02c0.34,0.02,0.69,0.04,1.04,0.07c0.44,0.02,0.76,0.06,0.97,0.12c0.58,0.1,1.11,0.23,1.53,0.42 c1.96,0.9,7.07,4.79,11.39,4.79s26.91,0,29.86,0s6.48-2.8,9.13-7.09C986.96,464.73,991.67,460.44,986.17,456.84z M982.02,460.49 c-24.98-1.68-50.05,1.78-54.21,2.39c-0.3,0.04-0.48,0.37-0.36,0.66l0.71,1.69c0.08,0.18,0.26,0.3,0.45,0.29 c0.89-0.04,3.4-0.16,5.3-0.22c2.34-0.08,3.28,0.16,5.86,0.95c2.58,0.79,4.84,1.99,9.46,2.15c4.21,0.15,25.02-0.51,28.56-0.62 c-2.31,3.07-5.53,6.09-7.93,6.09c-1.89,0-19.78,0-22.64,0s-8.83-4.14-10.87-4.84c-1.68-0.57-6.93-0.77-8.74-0.83 c-0.39-0.01-0.73-0.23-0.92-0.57l-2.57-4.72c-0.35-0.64,0-1.44,0.69-1.61c2.78-0.69,9.83-2.26,21.57-3.71 c15.62-1.92,31.47-1,34.27,0.61C981.81,458.88,982.16,459.61,982.02,460.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 923.978,
    y1: 465.1984,
    x2: 982.0477,
    y2: 465.1984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2963,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M980.65,458.21c-2.79-1.61-18.64-2.53-34.27-0.61c-11.74,1.44-18.79,3.01-21.57,3.71 c-0.7,0.17-1.04,0.97-0.69,1.61l2.57,4.72c0.19,0.34,0.54,0.56,0.92,0.57c1.81,0.05,7.06,0.26,8.74,0.83 c2.04,0.69,8,4.84,10.87,4.84s20.76,0,22.64,0c2.4,0,5.62-3.02,7.93-6.09c-3.54,0.11-24.34,0.76-28.56,0.62 c-4.61-0.16-6.88-1.35-9.46-2.15c-2.58-0.79-3.52-1.03-5.86-0.95c-1.9,0.06-4.42,0.18-5.3,0.22c-0.2,0.01-0.38-0.11-0.45-0.29 l-0.71-1.69c-0.12-0.29,0.06-0.61,0.36-0.66c4.16-0.61,29.23-4.07,54.21-2.39C982.16,459.61,981.81,458.88,980.65,458.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.3967,
    y1: 460.4334,
    x2: 900.3967,
    y2: 483.1938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7973,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M932.19,470.8c-0.31-0.05-0.64-0.09-0.97-0.12c-0.15-0.01-0.31-0.01-0.49-0.01 c-0.19,0-0.37-0.02-0.55-0.06c-0.65-0.03-1.28-0.03-1.79-0.02c-0.78,0.01-1.52-0.4-1.93-1.08l-4.25-6.8 c-0.65-1.09,0.05-1.65,1.16-2.02c-0.06-0.16-0.09-0.25-0.09-0.25h-46.26l-0.18,0.21c0.1,0.11,0.13,0.28,0.03,0.41l-6.33,8.6 c-0.05,0.07-0.14,0.12-0.23,0.13l-0.5,0.04l-1.26,0.16c0,0-2.98,13.17,9.47,13.17c8.25,0,34.01,0.04,38.44,0.04 s10.27-4.54,12.48-7.82C930.78,472.67,933.54,471.22,932.19,470.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 856.8057,
    y1: 454.5007,
    x2: 956.6194,
    y2: 454.5007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6631,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.2996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.4
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M923.57,460.79c0.2-0.07,0.41-0.13,0.63-0.19c6.79-1.77,21.64-3.73,25.36-4.24 c0.53-0.07,1.01-0.34,1.37-0.75c1.27-1.47,3.26-3.2,4.26-4.04c0.4-0.34,0.91-0.52,1.43-0.52c0,0-25.61-3.67-59.8-3.67 c-34.19,0-40.01,2.59-40.01,4.69c0,0.61,0,1.15,0,1.61c0.02,0.04,0.02,0.08,0.02,0.12v1.52c0,0.14,0.09,0.26,0.22,0.3l14.69,4.74 c0.03,0.01,0.06,0.01,0.08,0.01l4.81,0.16c0.09,0,0.16,0.04,0.21,0.1c0.1,0.11,0.13,0.28,0.03,0.41l-0.41,0.56l45.93-0.16 C922.64,461.17,923.06,460.96,923.57,460.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 881.4327,
    y1: 411.8016,
    x2: 998.0625,
    y2: 411.8016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6704,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.1742
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8349,
    style: {
      stopColor: "#090908",
      stopOpacity: 0.237
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9517,
    style: {
      stopColor: "#141414",
      stopOpacity: 0.2816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M973.69,408.94c0,0,10.31-5.14,24.37-5.33c-5.57,0.05-38.91,0.42-63.92,2.66 c-27.38,2.45-46.16,5.97-49.31,7.36c-2.49,1.1-3.2,2.72-3.4,3.36c0.33-0.44,0.71-0.83,1.15-1.15c1.94-1.38,8.47-2.2,9.13-2.28 c0.04,0,0.07,0,0.11,0l2.85,0.5c0.04,0.01,0.07,0.01,0.11,0c14.62-1.81,42.03-1.07,43.46-1.03c0.04,0,0.08,0,0.11-0.02 c0.44-0.13,3.34-1.01,3.72-0.92c0.41,0.1,9.18,0.1,16.53,1.35c6.52,1.1,13.76,5.15,15.31,6.05c0.17,0.1,0.23,0.32,0.15,0.49 C974.07,420,981.48,408.8,973.69,408.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 857.7806,
    y1: 439.2713,
    x2: 970.3969,
    y2: 439.2713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.0617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.008066498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2198,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M968.8,427.54c0.33,0.46,0.49,0.74,0.49,0.74s-3.8,7.01-7.01,11.36 c-3.21,4.35-19.85,4.35-29.59,4.83c-9.75,0.48-33.87,0.48-33.87,0.48s-26.17,0.14-30.83-0.15c-4.67-0.29-2.13-2.28-1.21-3.28 c0.92-1,3.23-3.51,11-12.13c0.2-0.22,0.39-0.43,0.59-0.64l-0.77,0.01c0,0-7.29,8.05-13.97,15.31c-3.26,3.55-4.96,5.53-5.84,6.64 c2.69-1.72,11.97-3.34,39.05-3.34c32.71,0,57.57,3.36,59.66,3.65c1.17-1.77,4.02-6.11,5.83-9.31c2.33-4.1,8.07-14.2,8.07-14.2 L968.8,427.54z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 965.0566,
    y1: 501.5402,
    x2: 1188.804,
    y2: 501.5402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2017,
    style: {
      stopColor: "#161819",
      stopOpacity: 0.0631
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#0B0C0D",
      stopOpacity: 0.0253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.0208
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8316,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.0629
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M965.06,519.89l29.49,3.56c0,0,10.99-42.18,38.31-38.37c27.32,3.81,22.08,40.54,22.08,39.97 s68.31-3.24,95.26-4c0,0,6.18-42.25,24.52-38.63c18.34,3.62,11.6,35.59,11.6,35.59l1.87-0.19c0,0,5.05-36.51-13.66-39.59 c-17.63-2.9-22.43,25.77-26.25,31.64c-1.32,2.02-1.45,2.66-5.09,2.49c-3.4-0.16-9.01-0.1-9.01-0.1c-2.25,0-71.15-2.23-73.84-2.59 c-2.69-0.37-2.29-0.7-2.75-3.75c-0.46-3.05-1.04-23.67-23.39-27.18s-34.68,18.74-37.79,23.43c-3.11,4.69-7.95,3.05-9.1,3.05 c-1.15,0-19.93-2.34-19.93-2.34L965.06,519.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1104.437,
    y1: 480.9306,
    x2: 1104.437,
    y2: 506.9267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001784581,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.9026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1228,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.8041
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    style: {
      stopColor: "#E4E4E4",
      stopOpacity: 0.696
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    style: {
      stopColor: "#CFCFCE",
      stopOpacity: 0.5832
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5424,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.4673
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6899,
    style: {
      stopColor: "#888888",
      stopOpacity: 0.3489
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8399,
    style: {
      stopColor: "#585858",
      stopOpacity: 0.2285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    style: {
      stopColor: "#20201F",
      stopOpacity: 0.1085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M1059.71,506.93c0,0,8.61-5.03,37.44-5.42c28.83-0.39,53.53,2.28,53.53,2.28l8.11-17.9 c0,0-76.61-4.13-90.09-4.52c-4.18-0.12-20.89-1.43-18.34,1.16C1061.95,494.34,1059.71,506.93,1059.71,506.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1001.2131,
    y1: 456.1658,
    x2: 993.6132,
    y2: 469.3293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M988.3,459.06c0,0,9.94,0.48,19.58,0.95l0.88,2.56c-2.48,0.21-5.17,0.3-7.08,0.54 c-7.46,0.94-14.35,2.21-14.87,2.29C986.61,465.43,989.77,461.65,988.3,459.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1040.3481,
    y1: 465.1493,
    x2: 1050.7345,
    y2: 465.1493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M1047.25,463.55l3.48-0.21c0,0-1.09,2.85-3.79,3.39c-2.63,0.52-4.34,0.17-6.59-1.2 c0,0,0.11-0.05,0.45-0.4c0.34-0.35,0,0,0,0s0.68,0.72,2.66,0.69C1045.55,465.8,1047.25,465.29,1047.25,463.55L1047.25,463.55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1036.7091,
    y1: 459.9051,
    x2: 1049.1509,
    y2: 459.9051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M1049.07,461.09c0,0-11.29-2.56-11.65,0l-0.7-0.07c0,0-0.43-2.1,2.47-2.28 C1042.09,458.55,1050.02,460.79,1049.07,461.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1037.3539,
    y1: 463.5781,
    x2: 1050.7345,
    y2: 463.5781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      stopColor: "#222222",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#353534",
      stopOpacity: 0.2887
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3212,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.4174
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#7C7C7B",
      stopOpacity: 0.5603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#B1B1B1",
      stopOpacity: 0.7148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    style: {
      stopColor: "#F1F1F1",
      stopOpacity: 0.8769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7903,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.881
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M1038.57,461.63c0,0,1.68,1.62,5.15,1.71s7.02,0,7.02,0s-6.74,0.29-8.33,0.86 c-1.59,0.57-2.06,1.33-2.06,1.33s-2.43-1.52-2.99-3.71L1038.57,461.63z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 1119.7585,
    y1: 494.7596,
    x2: 1089.3339,
    y2: 442.0625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2536,
    style: {
      stopColor: "#818283",
      stopOpacity: 0.4996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#B7B7B6",
      stopOpacity: 0.7439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#646463",
      stopOpacity: 0.4305
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.2083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M1052.71,463.21l103.67,10.41c0,0-8.08,2.74-23.97,1.64c-15.89-1.1-51.97-4.38-59.51-5.48 C1065.37,468.68,1052.71,463.21,1052.71,463.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1097.8944,
    y1: 470.8922,
    x2: 1106.2549,
    y2: 470.8922
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M1103.45,469.05l2.8-0.25c0,0-0.88,3.29-3.05,3.91c-2.12,0.6-3.49,0.19-5.31-1.39 c0,0,0.09-0.06,0.36-0.46c0.27-0.4,0,0,0,0s0.55,0.83,2.14,0.8C1102.08,471.64,1103.45,471.05,1103.45,469.05L1103.45,469.05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1094.9652,
    y1: 464.8365,
    x2: 1104.9801,
    y2: 464.8365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M1104.92,466.2c0,0-9.09-2.95-9.37,0l-0.56-0.08c0,0-0.34-2.42,1.99-2.64 C1099.3,463.27,1105.68,465.86,1104.92,466.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 1095.4841,
    y1: 469.0778,
    x2: 1106.2549,
    y2: 469.0778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      stopColor: "#222222",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#353534",
      stopOpacity: 0.2887
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3212,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.4174
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#7C7C7B",
      stopOpacity: 0.5603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#B1B1B1",
      stopOpacity: 0.7148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    style: {
      stopColor: "#F1F1F1",
      stopOpacity: 0.8769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7903,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.881
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M1096.46,466.83c0,0,1.36,1.87,4.14,1.98c2.79,0.11,5.65,0,5.65,0s-5.42,0.33-6.7,0.99 c-1.28,0.66-1.66,1.54-1.66,1.54s-1.96-1.76-2.41-4.29L1096.46,466.83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1060.6541,
    y1: 434.9857,
    x2: 1087.8018,
    y2: 434.9857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_37_)",
    points: "1060.65,413.78 1079.32,455.21 1087.8,456.19 1067.59,414.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 972.2013,
    y1: 507.4301,
    x2: 990.4684,
    y2: 475.7904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2364,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2393,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.1275
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6941,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.2191
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8608,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2994
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M971.21,476.1c-6.37,2.62-11.24,9.59-11.24,9.59c8.75,0.55,7.97,6.84,7.52,15.02 c-0.06,1.1-0.18,2.41-0.33,3.82l0.23-1.67c0,0,18.78,2.34,19.93,2.34c1.15,0,5.99,1.64,9.1-3.05c1.63-2.46,5.8-9.76,12.63-15.63 c-4-1.07-13.07-3.53-19.4-5.52c-5.27-1.66-8.39-4.69-9.98-6.69c-1.52,1.15-3.08,1.79-4.49,1.79 C974.58,476.1,973.14,476.1,971.21,476.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1148.88,493.11c0,0-0.23,4.12-0.57,7.95c-0.34,3.83-1.49,9.27-1.63,10.03 c-0.14,0.77,0.27,1.04,1.23-0.14c0.96-1.18,3.9-8.22,5.14-11.22c1.23-3,2.06-5.43,2.47-6.55s-0.27-1.23-1.58-1.25 c-1.03-0.02-2.07-0.05-3.78-0.01C1149.5,491.94,1148.88,492.01,1148.88,493.11z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4B",
    d: "M1148.88,492.65c0,0-1.48,3.51-1.84,8.53c-0.36,5.02-0.27,10.13-0.27,10.13s1.66-7.21,1.97-11.36 C1149.06,495.8,1148.88,492.65,1148.88,492.65z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M963.06,404.94c0,0-3.39-5.31-12.35-5.4l-1.65,3.63c0,0-1.22,1.06-1.22,2.39 C947.83,405.56,956.71,407.33,963.06,404.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 955.4447,
    y1: 399.5475,
    x2: 955.4447,
    y2: 406.1946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    style: {
      stopColor: "#151514",
      stopOpacity: 0.0837
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    style: {
      stopColor: "#050505",
      stopOpacity: 0.0372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1717
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M963.06,404.94c0,0-3.39-5.31-12.35-5.4l-1.65,3.63c0,0-1.22,1.06-1.22,2.39 C947.83,405.56,956.71,407.33,963.06,404.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 1117.9067,
    y1: 451.3956,
    x2: 1130.0781,
    y2: 451.3956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M1117.91,442.53l7.37,17.68c0,0,2.69,0.41,4.48-1.32 C1131.55,457.18,1125.68,450.84,1117.91,442.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.9657,
    y1: 449.1626,
    x2: 1139.4683,
    y2: 449.1626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0143,
    style: {
      stopColor: "#393A3C",
      stopOpacity: 0.1258
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364,
    style: {
      stopColor: "#626364",
      stopOpacity: 0.1657
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0612,
    style: {
      stopColor: "#888989",
      stopOpacity: 0.2106
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0883,
    style: {
      stopColor: "#A8A9A9",
      stopOpacity: 0.2595
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1182,
    style: {
      stopColor: "#C4C4C4",
      stopOpacity: 0.3135
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#DADADA",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    style: {
      stopColor: "#EAEBEB",
      stopOpacity: 0.4456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2402,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.5337
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3085,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.6572
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4984,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6895,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.657
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7584,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.5334
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    style: {
      stopColor: "#EBEBEA",
      stopOpacity: 0.4453
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    style: {
      stopColor: "#DADADA",
      stopOpacity: 0.3741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#C4C4C4",
      stopOpacity: 0.3131
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9114,
    style: {
      stopColor: "#A9A9A8",
      stopOpacity: 0.259
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9386,
    style: {
      stopColor: "#888888",
      stopOpacity: 0.2101
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9637,
    style: {
      stopColor: "#636362",
      stopOpacity: 0.1651
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#3A3A39",
      stopOpacity: 0.1252
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M1127.99,444.79c-0.26-0.8,1.93-0.9,2.74-0.76c0.45,0.07,0.98,0.22,1.61,0.47 c1.71,0.68,3.46,1.69,4.17,2.12c0.21,0.13,0.38,0.32,0.47,0.56l2.48,6.54c0.3,0.76-2.95,0.65-3.76,0.61l-2.99-1.19 c-0.46-0.02-0.86-0.33-1.01-0.78L1127.99,444.79z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1125.07,454.54h1.79c0,0,0-6.89,0-7.9s0.6-3.85,4.68-1.72c4.08,2.13,4.48,6.08,4.58,8.51h3.29 c0,0,0.2,4.15-1.49,4.15c-1.69,0-2.99-0.2-4.28,0.81c-1.29,1.01-2.49,0.51-3.88,0.51c-1.39,0-1.69,1.32-4.48,1.32L1125.07,454.54 z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    fill: "#A1C8D9",
    d: "M1129.08,446.44c0-0.49,0.46-0.83,0.92-0.69c1.58,0.51,4.97,2.28,4.97,8.44 c0,2.17-3.7,3.32-5.23,3.12c-0.35-0.05-0.61-0.35-0.61-0.71L1129.08,446.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.0775,
    y1: 451.5315,
    x2: 1134.9628,
    y2: 451.5315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M1129.08,446.44c0-0.49,0.46-0.83,0.92-0.69c1.58,0.51,4.97,2.28,4.97,8.44 c0,2.17-3.7,3.32-5.23,3.12c-0.35-0.05-0.61-0.35-0.61-0.71L1129.08,446.44z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1126.9,448.41c0,0,0,4.97,0,5.62c0,0.64-0.59,0.76-1.67,0.76v-0.29c0,0,1.44,0.13,1.44-1.05 c0-1.7,0.26-5.01,0-4.74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 913.709,
    y1: 530.8182,
    x2: 925.716,
    y2: 530.8182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M925.72,535.53v1.73l-10.31-1.86l-1.7-11.02C913.71,524.38,914.62,533.8,925.72,535.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 858.1658,
    y1: 519.7516,
    x2: 858.1658,
    y2: 531.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M852.79,519.75c0,0-1.49,3.17-1.91,4.83c-0.43,1.66,0.64,1.51,1.91,1.73 c1.28,0.22,3.26,3.53,8.37,4.83l4.4,0.22c0,0-1.35-7.43-1.49-8.58c-0.14-1.15-0.43-2.16,0.07-2.24 C864.13,520.54,855.98,519.82,852.79,519.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 922.1588,
    y1: 537.5815,
    x2: 922.4124,
    y2: 519.9293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7309,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M913.58,523.48c0,0,13.69,0.09,17.57,0.35l-0.78,1.47l-16.65-0.91L913.58,523.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 1154.8771,
    y1: 520.106,
    x2: 1184.5123,
    y2: 520.106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M1156.72,522.5c-0.34-5.47-0.98-10.17-1.84-14.11c0,0,4.9-20.24,17.21-17.57 c14.2,3.08,12.77,32.9,11.94,37.53c-1.05,5.85-3.82,20.1-13.94,21.24C1159.96,550.74,1157.1,528.73,1156.72,522.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 989.8979,
    y1: 487.2454,
    x2: 956.9604,
    y2: 491.8754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5619,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1561
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9619,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M966.27,488.62c0,0,6.52-9.77,8.91-12.52s-3.72,19.85-4.03,27.18l-3.76-0.42 C967.4,502.86,969.63,495.95,966.27,488.62z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1025.96,447.51c0.08-0.03,46.58,0.3,46.58,0.3l2.88,7.03c0,0-35.49-3.65-40.51-4.69 c-5.02-1.04-8.96-1.95-8.96-1.95L1025.96,447.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 1043.2629,
    y1: 437.5195,
    x2: 1058.802,
    y2: 464.4338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005137858,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0225,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0325,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0435,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0705,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1138,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.94
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#282827",
      stopOpacity: 0.9457
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464645",
      stopOpacity: 0.9559
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787877",
      stopOpacity: 0.9694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC",
      stopOpacity: 0.9855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M1025.96,447.51c0.08-0.03,46.63,0.13,46.63,0.13l2.83,7.2c0,0-33.45-2.57-40.96-4.58 c-4.96-1.32-8.51-2.06-8.51-2.06L1025.96,447.51z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M885.34,472.16c0.21-1.02,0.42-2.05,0.64-3.07c0.03-0.15,0.18-0.32-0.01-0.41 c-0.22-0.1-0.31,0.11-0.38,0.27c-0.12,0.29-0.23,0.58-0.35,0.87c-0.05,0.13-0.15,0.25-0.3,0.22c-0.17-0.03-0.16-0.19-0.16-0.32 c-0.01-0.22,0.01-0.45-0.01-0.67c-0.01-0.16,0.08-0.41-0.2-0.41c-0.21,0-0.26,0.2-0.29,0.39c-0.17,0.92-0.26,1.85-0.51,2.75 c-0.09,0.31-0.18,0.51-0.52,0.42c-0.35-0.09-0.18-0.34-0.14-0.54c0.29-1.51,0.59-3.01,0.88-4.52c0.13-0.45,0.11-0.93,0.26-1.37 l0,0c0.42-0.23,0.77-0.02,0.78,0.26c0.08,0.56,0.1,1.14,0.15,1.7c0.02,0.33,0.13,0.48,0.42,0.18l-0.01,0.01 c0.29-0.52,0.34-0.82,0.55-1.22c0,0,0,0.01,0,0.01c0.2-0.36,0.24-0.59,0.43-0.89c0.1-0.15,0.28-0.23,0.48-0.17 c0.22,0.07,0.24,0.19,0.2,0.37c-0.38,1.94-0.76,3.88-1.14,5.82C886.02,472.37,885.66,472.21,885.34,472.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M909.83,472.59c-0.53,0.03-0.42-0.29-0.32-0.73c0.39-1.83,0.86-3.64,1.07-5.5 c0.05-0.42,0.24-0.63,0.7-0.61c0.62,0.03,1.11,0,1.73,0.02c0.19,0.01,0.73-0.08,0.68,0.36c-0.04,0.32-0.08,0.62-0.58,0.59 c-0.42-0.02-0.85,0.05-1.27-0.02c-0.5-0.09-0.51,0.41-0.6,1.08c-0.02,0.16,0.09,0.32,0.25,0.33c0.42,0.04,1.11-0.21,1.02,0.44 c-0.11,0.61-0.41,0.48-0.76,0.48c-0.97,0-0.79,0.03-0.95,0.98c-0.25,1.47-0.49,1.5,1.04,1.49c0.42,0,0.97-0.17,0.83,0.62 c-0.07,0.38-0.27,0.47-0.6,0.47c-0.36-0.01-0.71,0-1.07,0C911.01,472.56,910.17,472.57,909.83,472.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M903.32,472.46c-0.11,0-0.23,0.03-0.33,0c-0.52-0.01-0.91,0.09-1.04-0.37 c-0.14-0.46-0.01-0.84,0.31-1.24c0.15-0.19,0.41-0.51,0.61-0.65c0.64-0.79,1.18-1.24,1.75-1.9c0.21-0.18,0.33-0.54,0.37-0.84 c0.04-0.32,0.05-0.61-0.32-0.69c-0.35-0.07-0.75-0.04-0.89,0.34c-0.04,0.13-0.06,0.26-0.12,0.38c-0.08,0.16-0.24,0.19-0.4,0.17 c-0.2-0.02-0.25-0.16-0.24-0.33c0.02-0.57,0.1-1.15,0.65-1.45c0.58-0.32,1.38-0.33,1.8,0c0.42,0.25,0.41,0.77,0.4,1.15 c-0.04,1.28-0.69,2.15-1.57,3.03c-0.33,0.33-0.68,0.64-1.02,0.96c-0.09,0.09-0.23,0.29-0.17,0.45 c0.06,0.17,0.22,0.11,0.38,0.11c0.31-0.01,0.62-0.04,0.93-0.04c0.22,0,0.51-0.02,0.48,0.31c-0.02,0.27-0.04,0.62-0.43,0.65 C904.08,472.49,903.7,472.46,903.32,472.46C903.32,472.46,903.32,472.46,903.32,472.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M906.92,472.46c-0.11,0-0.23,0.03-0.33,0c-0.52-0.01-0.91,0.09-1.04-0.37 c-0.14-0.46-0.01-0.84,0.31-1.24c0.15-0.19,0.41-0.51,0.61-0.65c0.64-0.79,1.18-1.24,1.75-1.9c0.21-0.18,0.33-0.54,0.37-0.84 c0.04-0.32,0.05-0.61-0.32-0.69c-0.35-0.07-0.75-0.04-0.89,0.34c-0.04,0.13-0.06,0.26-0.12,0.38c-0.08,0.16-0.24,0.19-0.4,0.17 c-0.2-0.02-0.25-0.16-0.24-0.33c0.02-0.57,0.1-1.15,0.65-1.45c0.58-0.32,1.38-0.33,1.8,0c0.42,0.25,0.41,0.77,0.4,1.15 c-0.04,1.28-0.69,2.15-1.57,3.03c-0.33,0.33-0.68,0.64-1.02,0.96c-0.09,0.09-0.23,0.29-0.17,0.45 c0.06,0.17,0.22,0.11,0.38,0.11c0.31-0.01,0.62-0.04,0.93-0.04c0.22,0,0.51-0.02,0.48,0.31c-0.02,0.27-0.04,0.62-0.43,0.65 C907.68,472.49,907.3,472.46,906.92,472.46C906.92,472.46,906.92,472.46,906.92,472.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M896.41,465.59c0.31,0.09,0.78-0.07,0.89,0.48c0.11,0.55-0.04,0.96-0.3,1.46 c-0.07,0.14-0.28,0.11-0.44,0.07c-0.2-0.05-0.2-0.21-0.16-0.38c0.09-0.34,0.19-0.69-0.34-0.74c-0.45-0.04-0.79,0.08-0.9,0.58 c-0.22,1.11-0.47,2.22-0.68,3.34c-0.07,0.36,0.05,0.7,0.44,0.8c0.46,0.12,0.86-0.05,1.07-0.48c0.16-0.34,0.26-0.87,0.74-0.6 c0.38,0.22,0.1,0.69-0.06,1.02c-0.31,0.62-0.71,1.13-1.48,1.2c-1.06,0.09-1.63-0.48-1.46-1.53c0.17-1.06,0.4-2.1,0.6-3.15 c0.03-0.15,0.08-0.3,0.11-0.46C894.64,465.92,895.04,465.59,896.41,465.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M891.77,470.15c-0.04-0.32-0.27-0.02-0.35,0.14c-0.28,0.55-0.56,1.1-0.85,1.65 c-0.12,0.22-0.28,0.46-0.56,0.31c-0.33-0.17-0.1-0.41,0-0.62c0.39-0.84,0.84-1.56,1.22-2.49c0.21-0.4,0.22-0.6,0.19-0.92 c-0.08-0.69-0.17-1.37-0.27-2.06c-0.04-0.29-0.02-0.56,0.34-0.61c0.36-0.05,0.46,0.21,0.48,0.5c0.03,0.38,0.04,0.76,0.06,1.14 c0.01,0.13,0,0.29,0.18,0.31c0.15,0.02,0.25-0.08,0.31-0.2c0.21-0.44,0.4-0.89,0.62-1.33c0.12-0.24,0.3-0.53,0.61-0.37 c0.33,0.18,0.12,0.44-0.01,0.68c-0.33,0.6-0.6,1.24-0.96,1.83c-0.3,0.5-0.29,1.02-0.23,1.55c0.09,0.71,0.19,1.42,0.28,2.13 c0.03,0.25,0.05,0.52-0.32,0.54c-0.33,0.02-0.47-0.14-0.5-0.48C891.97,471.28,891.91,470.88,891.77,470.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M899,471.93c0.09-1.13,0.59-2.09,1.2-3.01c0.33-0.5,0.63-1.02,0.92-1.55c0.13-0.23,0.48-0.82-0.02-0.84 c-0.63-0.02-0.8-0.04-0.97,0.46c-0.03,0.1-0.03,0.22-0.07,0.33c-0.09,0.26-0.31,0.22-0.51,0.19c-0.24-0.03-0.28-0.22-0.22-0.4 c0.11-0.34,0.18-0.69,0.21-1.04c0.03-0.33,0.27-0.44,0.57-0.44c0.65,0,1.29,0.01,1.94,0.01c0.38,0,0.48,0.19,0.43,0.56 c-0.12,1-0.79,1.73-1.24,2.56c-0.57,1.04-1.42,1.95-1.47,3.24c-0.01,0.29-0.25,0.4-0.53,0.37 C898.98,472.34,898.97,472.13,899,471.93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M884.01,464.37c-0.89,0-1.61,0-2.12,0c-0.49,0-0.91,0.34-1.02,0.82l-1.7,7.63 c-0.14,0.65,0.35,1.27,1.01,1.27l1.46,0.01l0.37-0.1L884.01,464.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M881.4,473.95l-0.46-0.01l31.92,0.14c0.5,0,0.94-0.22,1.04-0.54c0,0-0.44,0.98-2.06,0.98 s-28.61,0-30.3,0c-2.39,0-2.18-0.68-2.18-0.68l1.9,0.1l0.29,0.03"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0978 -0.9952 0.9952 0.0978 332.2403 1308.9437)",
    fill: "#5E5D5B",
    cx: 888.08,
    cy: 471.22,
    rx: 1.73,
    ry: 1.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1278 -0.9918 0.9918 0.1278 312.1717 1288.7092)",
    fill: "#D25959",
    cx: 888.79,
    cy: 466.87,
    rx: 1.54,
    ry: 1
  })))))), /*#__PURE__*/React.createElement("g", null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1007.02,457.05c0,0,0.36,1.21,0.86,2.96c0.5,1.76,1.88,6.15,2.38,7.28c0.5,1.13,1.76,2.26,4.02,2.26 c2.26,0,9.39-0.25,11.04-0.25c1.99,0,1.79-2.88,0.28-6.39c-1.51-3.51-2.14-6.33-7.06-6.78c-4.15-0.39-8.09-0.54-9.59-0.54 C1007.44,455.58,1006.71,455.78,1007.02,457.05z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1026.44,458.3c0.64,1.73,1.7,4.61,2.42,6.74c0.37,1.09,1.62,1.59,2.64,1.06l11.18-5.84 c0.79-0.41,1.18-1.33,0.93-2.19c0,0-0.55-3.73-1.96-6.74c-0.88-1.87-2.49-2.13-3.54-1.54l-10.83,6.23 C1026.47,456.48,1026.12,457.44,1026.44,458.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 1026.3218,
    y1: 457.9097,
    x2: 1043.694,
    y2: 457.9097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0382
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.0749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M1026.44,458.3c0.64,1.73,1.7,4.61,2.42,6.74c0.37,1.09,1.62,1.59,2.64,1.06l11.18-5.84 c0.79-0.41,1.18-1.33,0.93-2.19c0,0-0.55-3.73-1.96-6.74c-0.88-1.87-2.49-2.13-3.54-1.54l-10.83,6.23 C1026.47,456.48,1026.12,457.44,1026.44,458.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C9C6",
    d: "M1024.52,460.66l3.56-1.46c0,0,0-1,1.83-1.83c1.83-0.82,7.49-4.29,8.77-4.84 c1.28-0.55,3.65,3.65,2.56,5.84l-10.68,5.94l-1.46-1.92l-3.56,1.46L1024.52,460.66z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1010.94,461.09c0,0-0.49-1.16-0.92-2.76c-0.44-1.6,4.61-1.02,7.23-0.87c2.62,0.15,3.1,0.82,3.49,1.55 L1010.94,461.09z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1010.94,461.09l1.97,5.12c0,0,2.13-1.23,3.31-2.08c1.17-0.85,1.12-1.76,1.33-2.45 c0.15-0.5,0.57-1.5,1.31-2.08c-1.76-0.38-4.34-0.44-5.45-0.45C1011.72,459.9,1010.94,461.09,1010.94,461.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1010.94,461.09l1.97,5.12c0,0,2.13-1.23,3.31-2.08c1.17-0.85,1.12-1.76,1.33-2.45 c0.15-0.5,0.57-1.5,1.31-2.08c-1.76-0.38-4.34-0.44-5.45-0.45C1011.72,459.9,1010.94,461.09,1010.94,461.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFB",
    d: "M1021.71,460.56c-0.21-2.08-2.67-2.19-5.97-1.97c-0.92,0.06-1.69,0.28-2.33,0.57 c1.11,0.01,3.69,0.07,5.45,0.45c0.28-0.22,0.6-0.38,0.99-0.43C1021.23,459.01,1021.71,460.56,1021.71,460.56z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1021.71,460.56l6.47,0.18c0,0-1.86,2.79,0.05,4.34l-7.29-0.47c0,0-1.5,2.27-3.2,3.51 c0,0-1.86,0.21-3.05,0.05c-1.19-0.16-1.55-1.31-1.78-1.97l4.99-6.45c0,0,0.98-0.93,2.17-0.72 C1021.26,459.25,1021.71,460.56,1021.71,460.56z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFB",
    d: "M1021.71,460.56c0,0-0.56-1.26-1.59-1.06c-1.03,0.21-1.71,1.81,1.6,1.81c3.31,0,6.1,0.1,6.1,0.1 s-0.1-0.47,0.62-0.72L1021.71,460.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 1013.4047,
    y1: 459.5745,
    x2: 1021.7085,
    y2: 459.5745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.0617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.00806646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M1015.74,458.59c-0.92,0.06-1.69,0.28-2.33,0.57c1.11,0.01,3.69,0.07,5.45,0.45 c0.28-0.22,0.6-0.38,0.99-0.43c1.39-0.16,1.87,1.39,1.87,1.39"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1028.83,465.64c-0.92,0-1.67-1.18-1.67-2.63s0.75-2.63,1.67-2.63h1.16v5.27H1028.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 1027.1538,
    y1: 463.0115,
    x2: 1029.9805,
    y2: 463.0115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M1028.83,465.64c-0.92,0-1.67-1.18-1.67-2.63s0.75-2.63,1.67-2.63h1.16v5.27H1028.83z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E5D5B",
    cx: 1029.98,
    cy: 463.01,
    rx: 1.67,
    ry: 2.63
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1010.89,460.97l1.63,4.16c0,0-1.2-3.86-1.09-4.7"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 849.4556,
    y1: 526.1698,
    x2: 870.5169,
    y2: 526.1698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M852.79,519.75c0,0,9.79,0.36,11.35,0.79c1.56,0.43,1.77,1.01,2.27,3.75s1.13,4.98,1.13,4.98 l2.98,3.32l-4.75-0.43l-0.21-0.79l-4.4-0.22l-0.14,0.94l-10.85-1.44l-0.71-3.03L852.79,519.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 874.5452,
    y1: 459.9583,
    x2: 959.3036,
    y2: 411.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008980082,
    style: {
      stopColor: "#F2F2F1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    style: {
      stopColor: "#C5C5C5",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0782,
    style: {
      stopColor: "#9D9D9C",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#7A7A79",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1592,
    style: {
      stopColor: "#5D5D5C",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2056,
    style: {
      stopColor: "#454544",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#323232",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3204,
    style: {
      stopColor: "#262625",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9317
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9458
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8144,
    style: {
      stopColor: "#323231",
      stopOpacity: 0.9564
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8523,
    style: {
      stopColor: "#444443",
      stopOpacity: 0.9653
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8855,
    style: {
      stopColor: "#5B5B5B",
      stopOpacity: 0.9731
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9155,
    style: {
      stopColor: "#787877",
      stopOpacity: 0.9801
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#9A9A9A",
      stopOpacity: 0.9866
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9686,
    style: {
      stopColor: "#C2C2C2",
      stopOpacity: 0.9926
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9918,
    style: {
      stopColor: "#EEEEEE",
      stopOpacity: 0.9981
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M866.75,441.53c-0.92,1-3.46,2.99,1.21,3.28c4.67,0.29,30.83,0.15,30.83,0.15s24.13,0,33.87-0.48 c9.75-0.48,26.38-0.48,29.59-4.83c3.21-4.35,7.01-11.36,7.01-11.36s-0.15-0.28-0.49-0.74c-1.47-2.02-6.45-7.47-17.58-7.47 c-13.67,0-51.34,0-55.26,0c-3.82,0-10.09,0.69-17.6,8.7c-0.19,0.21-0.39,0.42-0.59,0.64 C869.98,438.02,867.67,440.54,866.75,441.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 879.6103,
    y1: 469.194,
    x2: 915.424,
    y2: 469.194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7009,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8971,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.1233
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9457,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0161
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M914.43,464.32c-5.71-0.15-23.14-0.14-30.07-0.12c-0.87,0-1.57,0-2.07,0 c-0.48,0-0.89,0.34-0.99,0.82l-1.66,7.67c-0.14,0.65,0.34,1.27,0.99,1.28l1.43,0.01l30.8,0.22c0.49,0,0.91-0.35,1.01-0.84 l1.55-7.78C915.53,464.94,915.06,464.34,914.43,464.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 1007.4317,
    y1: 533.3879,
    x2: 1052.5292,
    y2: 533.3879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M1011.39,536.1c-0.5-6.19-2.69-12.79-3.96-17.25c0,0,8.48-21.56,26.71-18.54 c21.01,3.48,18.9,37.18,17.67,42.4c-1.55,6.61-5.65,22.71-20.64,24C1016.19,568,1011.95,543.14,1011.39,536.1z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1031.63,433.28l0.24-5.49c-0.04,0.01-0.08,0.03-0.12,0.04C1031.66,428.6,1031.57,430.58,1031.63,433.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1049.99,424.99c-0.02,0.2-0.01,1.15-0.02,1.34c-0.11,1.93-0.22,3.24-0.25,4.71 c-0.13,6.94-0.6,11.54-1.29,14.39c-0.04,0.19-0.09,0.33-0.13,0.44l-0.03,0.4c0.42-0.24,0.69-0.33,1.18-0.41 c0.63-0.1,0.95-0.33,1.5-0.63l0.04,0.01c1.24-3.77,0.98-8.83,0.65-10.2c-0.46-1.94-0.75-4.64-0.92-6.9 c-0.2-0.12-0.3-0.23-0.3-0.23L1049.99,424.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1055.75,427.17c-0.66,0.41-1.88,1.15-2.31,1.27c-1.35,0.39-2.28-0.01-2.72-0.29 c0.17,2.26,0.46,4.97,0.92,6.9c0.33,1.37,0.59,6.42-0.65,10.2l-0.04-0.01c-0.55,0.3-0.88,0.53-1.5,0.63 c-0.5,0.08-0.76,0.18-1.18,0.41c-0.11,0.06-0.23,0.13-0.37,0.21c-0.68,0.4-1.33-0.15-1.1,0.65c0.12,0.41,0.74,0.5,1.36,0.46 c0.58-0.04,1.17-0.19,1.36-0.28c0.4-0.2,0.55-0.08,0.45,0.3c-0.1,0.38-0.58,1.05-1,1.73c-0.43,0.68-0.53,1.33-0.6,2.3 c-0.08,0.98-0.18,1.35,0.38,1.38c0.55,0.03,0.83-1.33,1.1-2.13c0.28-0.8,0.93-1.78,0.93-1.78s-0.08,0.28-0.2,0.68 c-0.12,0.4-0.4,1.3-0.25,1.85c0.15,0.55,0.33,1.05,0.8,1.15c0.48,0.1,0.65-0.83,0.65-0.83c0.1,0.43,0.43,0.83,0.9,0.8 c0.48-0.02,0.75-1.03,0.9-1.58c0.15-0.55,0.45-1.03,0.45-1.03c-0.08,0.23,0,0.73-0.1,1.05c-0.1,0.33-0.2,0.85,0.15,0.88 c0.35,0.03,0.35,0.03,0.95-0.55c0.6-0.58,0.25-0.85,0.3-1.78c0.04-0.73-0.75-2.13-0.89-2.9c0.71-4.65,1.37-4.25,1.92-9.04 C1056.73,434.66,1056.25,430.33,1055.75,427.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1037.97,446.4c0,0-1.01-0.06-1.53-0.22c-1-0.29-1.84-0.65-2.45-0.49c-0.99,0.25-1.12-0.68-1.2-1.22 c-0.69-4.21-0.96-8.19-1.03-11.25c-0.06-2.7,0.22-4.93,0.31-5.7c-1.25,0.39-3.5,0.78-5.17-1.1c-0.08,1.47-0.35,7.67,0.69,13.85 c0.6,3.57,1.88,7.93,1.88,7.93s0.25,0.53,0.45,1.38c0.2,0.85,0.65,1.38,0.95,2.12c0.3,0.74,0.9,1.5,1.48,1.12 c0,0,0.58,1.17,1.19,1.02c0.61-0.15,0.5-0.58,0.5-0.58s0.52,0.41,0.97,0.2c0.44-0.2,0.36-1.14,0.36-1.14s0.58,0.12,0.77-0.23 c0.19-0.35,0.06-2.22,0.03-2.54c-0.03-0.32-0.6-2.04-0.6-2.04s1.52,0.11,1.85,0.03c0.11-0.03,0.2-0.06,0.28-0.1 C1038.34,447.12,1037.97,446.4,1037.97,446.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1036.91,417.25c-0.07-0.02-0.14-0.05-0.21-0.08C1036.8,417.22,1036.87,417.24,1036.91,417.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M1055,420.56c-0.2-1.32-0.72-4.17-1.99-4.99c-1.24-0.8-3.54-0.73-5.58-0.48 c-1.18,0.15-2.36,0.33-3.09,0.47c-0.12,1.61-0.11,1.93-0.23,2.71c-0.44,2.97-1.34,4.03-3.27,4.03c-3.57,0-3.79-5.02-3.8-5.1 c0,0-0.1,0.03-0.11,0.02c-0.19-0.18-1.14-1.22-1.18-1.28c-0.12-0.18-0.37-0.51-0.63-0.98c-0.02,0-1.72-0.24-1.85-0.26 c-0.01-0.01-0.01-0.02-0.01-0.02c-2.26-0.37-5.31-0.61-5.89,1.28c-1.04,3.41-1.04,10.01-1.04,10.01c0.14,0.2,0.29,0.38,0.44,0.55 c1.67,1.88,3.73,1.66,4.98,1.27c0.04-0.01,0.08-0.03,0.12-0.04l-0.24,5.49c0.07,3.06,0.34,7.04,1.03,11.25 c0.09,0.54,0.2,1.54,1.19,1.3c0.62-0.15,1.46,0.19,2.46,0.49c0.52,0.15,1.56,0.25,1.56,0.25s0.24,0.66-0.41,0.98l10.69,0.17 l0.01-0.12c-0.63,0.04-1.25-0.04-1.36-0.46c-0.23-0.8,0.43-0.25,1.1-0.65c0.14-0.08,0.26-0.15,0.37-0.21l0.03-0.4 c0.04-0.11,0.08-0.25,0.13-0.44c0.69-2.84,1.15-7.45,1.29-14.39c0.03-1.47,0.15-2.78,0.25-4.71c0.01-0.19,0-1.14,0.02-1.34 l0.43,2.93c0,0,0.1,0.1,0.3,0.23c0.44,0.28,1.37,0.68,2.72,0.29c0.43-0.12,1.65-0.86,2.31-1.27c0.27-0.16,0.44-0.28,0.44-0.28 S1055.35,422.88,1055,420.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1045.16,412.74c0,0-0.01-0.29,0.04-0.8c0.04-0.01,0.06-0.02,0.1-0.04c0.83-0.27,1.43-1.52,1.65-2.17 c0.23-0.65,0.31-1.73-0.64-1.74c-0.29,0-4.08-5.82-4.08-5.82c-0.67,0.53-4.68,0.03-4.66-0.89c-0.15,0.92-4.06,1.35-3.64,0.45 c0,0-0.05,0.11-0.12,0.29c-0.14,0.39-0.47,1.13-0.42,1.96c-0.11,1.2-0.24,2.02-0.12,2.48c0,0.1,0.01,0.07,0.02,0.28 c-0.02,0.38-0.07,0.6-0.02,0.96c0.22,1.8-0.12,3.32,0.25,4.62c0.04,0.16,0.08,0.28,0.14,0.46c0.01,0.01,0.05,0.08,0.06,0.09 c0.28,0.74,0.77,1.49,1.14,2.15c0.26,0.47,0.48,0.86,0.6,1.04c0.04,0.07,0.11,0.15,0.16,0.23c0.45,0.57,0.79,0.9,1.05,0.96 c0.07,0.03,0.17-0.03,0.24-0.01c0.02,0,0.03,0.01,0.03,0.01c0,0,0,0,0,0c0.01,0.08,0.34,5.21,3.91,5.21 c1.93,0,2.94-1.21,3.37-4.18c0.11-0.78,0.09-1.06,0.21-2.67c0.03-0.45,0.25-0.95,0.32-1.65 C1045.23,413.27,1045.16,412.74,1045.16,412.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1034.11,407.79c-0.29,0.16-0.32,0.43-0.32,0.43s0.09,0.01,0.34-0.01c0.03,0,0.08,0,0.13-0.01 C1034.25,408.2,1034.01,408.09,1034.11,407.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1036.73,412.32c-0.32-0.01-0.61,0.04-0.77,0.16c0.09-0.04,0.32-0.14,0.73-0.16 C1036.71,412.32,1036.72,412.32,1036.73,412.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1038.39,413.38c0.01-0.01,0.01-0.02,0.02-0.02C1038.41,413.36,1038.4,413.37,1038.39,413.38 C1038.4,413.38,1038.4,413.38,1038.39,413.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1036.35,414.1c0.25,0.24,0.6,0.34,1.02,0.19c-0.09,0.03-0.19,0.04-0.29,0.04 C1036.73,414.34,1036.5,414.23,1036.35,414.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1035.66,412.7l0.04-0.01c0,0,0.11,0.61,0.4,1.1c0,0-0.01-0.63,0.76-0.75s1.27-0.11,1.59,0.06 c0,0,0.08,0.06,0.01,0.17c0.13-0.2,0.23-0.38,0.28-0.47l-0.12-0.11c-0.18-0.05-0.55-0.22-0.86-0.29 c-0.93,0.37-1.57,0.08-1.66,0.04c0,0-0.18,0.07-0.19,0.08C1035.84,412.6,1035.74,412.66,1035.66,412.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1037.72,409.96c-0.06-0.11-0.1-0.18-0.1-0.18C1037.64,409.82,1037.67,409.89,1037.72,409.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1037.82,412.49c-0.22-0.05-0.36-0.22-0.53-0.24c-0.17-0.03-0.4,0-0.56,0c-0.01,0-0.02,0-0.03,0 c-0.41,0.03-0.64,0.11-0.73,0.16c-0.01,0.01-0.03,0.1-0.04,0.11C1036.02,412.54,1036.89,412.86,1037.82,412.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M1037.2,413.94c-0.66,0.02-1.1-0.16-1.1-0.16s0,0.23,0.18,0.38c0.15,0.13,0.42,0.29,0.77,0.28 c0.1,0,0.28-0.01,0.37-0.04c0.59-0.17,0.9-0.9,0.97-1.02c0,0,0,0,0,0C1038.2,413.65,1037.87,413.92,1037.2,413.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M1036.83,412.91c-0.77,0.12-0.72,0.87-0.72,0.87s0.37,0.27,1.03,0.25c0.67-0.02,1.05-0.38,1.25-0.66 c0.01-0.01,0.01-0.01,0.02-0.02c0.02-0.03,0.04-0.05,0.05-0.08c0.07-0.11,0.1-0.19,0.1-0.19 C1038.25,412.91,1037.6,412.79,1036.83,412.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1046.11,403.61L1046.11,403.61c0.01-0.02,0.02-0.05,0.03-0.08L1046.11,403.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1035.35,413.18c-0.01-0.04-0.02-0.09-0.04-0.14C1035.33,413.21,1035.4,413.37,1035.35,413.18z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1031.13,449.13c0,0,0.47,1.55,0.64,2.43c0.12,0.66,0.22,1.2,0.26,1.43c0.01,0.08,0.02,0.12,0.02,0.12 l0.22-0.12c0,0,0-0.02-0.01-0.06c-0.03-0.22-0.15-1.06-0.41-1.84C1031.55,450.18,1031.13,449.13,1031.13,449.13z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1033.04,450.44c0.07,0.5,0.69,2.79,0.81,3.23c0.01,0.05,0.02,0.07,0.02,0.07l0.08-0.32 c0,0-0.01-0.03-0.02-0.09c-0.14-0.59-0.95-3.94-1.25-4.76C1032.68,448.57,1032.95,449.89,1033.04,450.44z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1034.38,448.69c-0.13-0.48-0.22-0.82-0.21-0.96c0,0-0.09,0.06,0.02,0.63c0.11,0.57,0.44,1.69,0.51,2.16 c0.07,0.45,0.48,1.86,0.52,2.42c0,0.02,0,0.05,0,0.07l0.04-0.52c0,0-0.01-0.03-0.02-0.09c-0.05-0.27-0.23-1.13-0.48-2.19 C1034.64,449.62,1034.49,449.1,1034.38,448.69z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1036.23,408.39c0-0.06,0.01-0.12,0.01-0.18c0-0.09-0.01-0.19-0.01-0.29c-0.05-0.51-0.19-0.94-0.19-0.94 c0.01,0.02,0.01,0.03,0.02,0.05c-0.19-0.42-0.49-0.62-0.49-0.62c-1.01-0.63-1.64,0.07-1.64,0.07c0.04,0,0.07,0,0.1,0 C1035.79,406.45,1036.16,407.74,1036.23,408.39z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1035.7,447.28c-0.23-0.1-0.98-0.44-1.17-0.53c0.84,0.43,1.04,0.78,1.04,0.78l0.67,0.04 c0,0,0.06,0.01-0.05-0.05C1036.11,447.48,1035.97,447.41,1035.7,447.28z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1031.06,435.39c-0.08,1.88-1.08,2.23-1.33,2.29c0.29-0.05,1.61-0.16,1.76,1.76 c0.17,2.15,0.6,4.31,0.69,5.43c0.09,1.12,1.23,0.96,1.23,0.96s0,0,0,0c-0.01-0.05-0.48-0.99-0.71-2.19 c0.04-0.97,0.11-2.65,0.2-4.58c0.02-0.02,0.03-0.04,0.05-0.07c0.46-0.8,2.13,0.26,3.11,0.99c-1.83-1.71-4.75-5.8,0.61-2.66 c5.69,3.33,7.75,3.14,5.59,2.35c-2.16-0.78-5.59-2.35-6.96-4.9c-1.37-2.55-2.06-4.71-1.69-8.37c0,0-0.05,0.45-0.12,1.18 c0.04-0.59,0.09-1.01,0.12-1.18c0.27-1.33,0.87-2.07,0.27-1.47c-0.6,0.6-1.07,1.07-1.2-0.07c-0.13-1.13-0.49-4.13-0.49-4.13 s0.03,2-0.04,3.73c-0.05,1.22-0.27,2.99-0.41,3.35c-0.2,0.08-0.97,0.22-0.97,0.23C1030.8,428.45,1031.14,433.33,1031.06,435.39z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1054.51,446.41c0.02-0.16,0.06-0.34,0.1-0.55c0.16-0.78,0.4-1.89,0.73-3.06 c0.38-1.36,0.58-2.05,0.84-3.61c0.15-0.86,0.3-1.63,0.32-2.19c0.1-2.38,0.16-5.14-0.74-9.84c0-0.01,0,0-0.01-0.04 c-1.99,1.52-3.48,1.48-3.48,1.48l-0.1,0.04c1.65,3.54,2.43,5.37,1.91,7.51c-0.33,1.36-0.37,2.5-0.07,3.98 c0.47,2.37-0.24,4.96-0.29,6.04c0,0,0,0,0,0.01c-0.23,2.04,0,2.26-0.46,4.14c-0.12,0.47-0.23,0.8-0.32,1.02 c-0.33,0.04-0.93,0.06-0.95-0.23c-0.03-0.4,0.48-2.08,0.23-1.68c-0.26,0.4-0.43,1.85-0.74,1.85c-0.29,0-0.74,0.01-1.19-0.04 c-0.03,0,0.03,0,0,0c-0.03,0.68,0.41,1.73,1,1.54c0.43-0.13,0.49-0.81,0.49-0.81c-0.02,0.14,0.16,0.41,0.28,0.54 c0.16,0.17,0.24,0.24,0.44,0.27c0.34,0.06,0.51-0.08,0.8-0.65c0,0,0.11-0.33,0.1-0.31c0.04-0.14,0.06-0.25,0.18-0.62 c0.06-0.19,0.28-0.71,0.42-0.94c-0.01,0.26-0.01,0.65-0.08,0.99c-0.02,0.1-0.06,0.22-0.07,0.32c-0.04,0.31,0.01,0.55,0.32,0.54 c0.44-0.02,0.33-0.08,0.48-0.2c0.09-0.07,0.18-0.14,0.24-0.21c0.44-0.37,0.58-0.65,0.46-1.34c-0.02-0.14-0.01-0.51-0.03-0.67 c-0.04-0.46-0.13-0.74-0.32-1.24c-0.07-0.2-0.13-0.27-0.18-0.43c-0.08-0.26-0.27-0.71-0.32-0.89c-0.12-0.38-0.01-0.37-0.02-0.45 c0-0.02,0.01-0.05,0.01-0.08C1054.5,446.53,1054.5,446.47,1054.51,446.41z M1054.24,450.11c0-0.01,0-0.03,0-0.04c0,0,0,0,0,0 C1054.24,450.08,1054.24,450.09,1054.24,450.11z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1050.73,448.66c0.03-0.31-0.28,0.25-0.7,1.01c-0.43,0.77-0.67,1.1-0.8,1.9c-0.12,0.75-0.4,1.25-0.82,1.31 c-0.02,0,0.02,0,0,0c0,0,0.3,0.28,0.57,0.1c0.29-0.19,0.52-0.88,0.64-1.34c0.12-0.46,0.42-1.3,0.64-1.66 c0.21-0.37,0.52-0.86,0.52-0.86S1050.7,448.97,1050.73,448.66z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1040.55,408.2c0.03,0,0.05,0,0.05,0l-0.1-0.05c-0.21-0.2-0.82-0.71-1.4-0.67 c-0.72,0.05-1.04,0.7-1.04,0.7s0.31-0.44,0.8-0.56c-0.04,0.02-0.09,0.03-0.13,0.06c0,0-0.11,0.28,0.08,0.5l0.69,0.01 c0,0,0.24-0.13,0.17-0.46c0.32,0.13,0.62,0.31,0.79,0.42c-0.09,0.01-0.41,0.03-0.84,0.03c-0.44,0,0.65,0.02,0.92,0.02 c0.03,0.02,0.04,0.03,0.04,0.03S1040.57,408.22,1040.55,408.2z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1034.96,407.73c0.41,0.12,0.72,0.38,0.72,0.38s-0.39-0.63-1.25-0.5c-0.6,0.09-0.77,0.64-0.77,0.64 s0.75-0.01,1.09-0.04c0.05-0.01,0.08-0.01,0.09-0.01c0,0,0,0-0.01,0l0.08,0C1035.05,408.05,1034.99,407.82,1034.96,407.73z  M1033.79,408.22c0,0,0.03-0.27,0.32-0.43c-0.09,0.29,0.14,0.41,0.15,0.41c-0.05,0-0.09,0-0.13,0.01 C1033.88,408.23,1033.79,408.22,1033.79,408.22z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1039.5,407.4c0.24,0.05,0.48,0.14,0.71,0.23c0.23,0.1,0.46,0.2,0.69,0.32c-0.4-0.31-0.87-0.54-1.37-0.67 c-0.25-0.05-0.53-0.07-0.78-0.01c-0.26,0.06-0.49,0.24-0.57,0.48c0.12-0.22,0.36-0.34,0.6-0.39 C1039,407.32,1039.26,407.34,1039.5,407.4z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1041.27,406.91c0,0-0.79-1.05-1.81-1.03s-1.55,0.69-1.55,0.69s0.67-0.19,1.56-0.21 C1040.35,406.35,1041.27,406.91,1041.27,406.91z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1035.35,410.88c0.07-0.15,0.12-0.25,0.17-0.33c0,0.06,0.02,0.14,0.09,0.22c0,0,0,0,0,0.01 c-0.01,0.06,0.03,0.08,0.09,0.09c0.01,0.01,0.02,0.02,0.04,0.04c-0.01-0.01-0.02-0.02-0.03-0.04c0.1,0.01,0.24-0.01,0.31-0.03 c0.09,0.08,0.22,0.12,0.39,0.06c0,0-0.52,0.04-0.48-0.59c0.02-0.33,0.26-0.99,0.33-1.57c0.07-0.57,0.09-1.24-0.21-1.77 c0,0,0.3,0.9,0.17,1.64s-0.33,1.65-0.35,1.8c-0.01,0.08,0.02,0.25,0.11,0.37c-0.15-0.07-0.27-0.13-0.33-0.06 c-0.05-0.17-0.03-0.4,0.25-0.53c0,0-0.16,0.05-0.26,0.15c0.03-0.08,0.04-0.18,0.04-0.33c0,0-0.32,0.66-0.5,1.29 c-0.06,0.22-0.06,0.46-0.04,0.68C1035.11,411.55,1035.23,411.15,1035.35,410.88z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1037.54,410.6c-0.03-0.19-0.67,0.21-0.67,0.21C1037.38,410.88,1037.57,410.79,1037.54,410.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1037.77,410.4c-0.05-0.33-0.39-0.34-0.39-0.34c0.12-0.01,0.28,0.14,0.32,0.37 c0.02,0.12-0.03,0.23-0.11,0.31C1037.7,410.65,1037.79,410.55,1037.77,410.4z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1037.59,410.73c-0.12,0.09-0.27,0.13-0.27,0.13"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1037.59,410.73c-0.07,0.07-0.17,0.11-0.27,0.13"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1033.83,407.53c0.16-0.11,0.37-0.17,0.58-0.17c0.21-0.01,0.43,0.01,0.64,0.07 c0.2,0.06,0.4,0.14,0.56,0.28c-0.25-0.33-0.75-0.46-1.2-0.45c-0.23,0.01-0.47,0.08-0.64,0.22c-0.17,0.13-0.28,0.32-0.31,0.51 C1033.53,407.8,1033.66,407.64,1033.83,407.53z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1035.31,413.04c-0.01-0.14,0-0.28,0.14-0.27c0.13,0.22,0.34,0.98,0.59,1.37c0.24,0.39,0.47,0.74,1.3,0.61 c0.83-0.14,0.84-0.69,1.11-1.08c0.21-0.3,0.29-0.68,0.32-0.85c0.16,0.02,0.22,0.51,0.22,0.5c0-0.01-0.05-0.43-0.08-0.67 c0-0.13-0.02-0.53-0.19-0.99c-0.04-0.1-0.09-0.21-0.15-0.33c-0.24-0.46-0.64-1.01-0.85-1.36c0.18,0.32,0.55,0.99,0.77,1.49 c0.2,0.45,0.32,0.85,0.38,1.07c-0.1,0.15-0.25,0.1-0.29,0.13l0.01,0.01c-0.4-0.17-1.31-0.55-1.52-0.61 c-0.27-0.08-0.37-0.02-0.57,0.05c-0.2,0.07-0.17-0.3-0.64,0c-0.33,0.21-0.39,0.45-0.4,0.58c-0.04,0.08-0.13,0.04-0.22-0.2 c-0.02-0.04-0.03-0.06-0.03-0.07c-0.03-0.12-0.06-0.27-0.07-0.42c0,0.15,0.03,0.3,0.07,0.46 C1035.2,412.55,1035.26,412.81,1035.31,413.04z M1035.93,412.51c0.01-0.01,0.02-0.02,0.04-0.03c0.16-0.12,0.44-0.17,0.77-0.16 c0.16,0,0.32,0.02,0.49,0.04c0.17,0.03,0.39,0.07,0.6,0.12c0.31,0.07,0.62,0.16,0.8,0.21l0.12,0.11 c-0.05,0.09-0.15,0.27-0.28,0.47c-0.02,0.03-0.03,0.05-0.05,0.08c-0.01,0.01-0.01,0.02-0.02,0.02c-0.07,0.12-0.43,0.74-1.02,0.92 c-0.42,0.15-0.77,0.05-1.02-0.19c-0.18-0.15-0.25-0.32-0.25-0.32c-0.29-0.49-0.4-1.1-0.4-1.1l-0.04,0.01 C1035.74,412.66,1035.84,412.6,1035.93,412.51C1035.93,412.51,1035.93,412.51,1035.93,412.51z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1045.33,410.55c-0.2,0.28-0.14,0.47,0.02,0.32c0.16-0.16,0.49-0.56,0.45-0.7 c-0.05-0.13-0.23-0.09-0.28-0.36c0,0-0.07,0.03-0.06,0.2C1045.47,410.18,1045.53,410.27,1045.33,410.55z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1046.04,409.94c-0.01,0.2-0.03,0.37-0.03,0.37s0.16-0.17,0.18-0.39c0.02-0.22-0.01-0.35-0.11-0.65 c-0.1-0.31,0.12-0.59,0.31-0.61c0.27-0.02,0.31,0.67,0.31,0.67c0.02-0.3,0.07-0.73-0.17-0.88c-0.24-0.14-0.43,0.07-0.54,0.2 c-0.11,0.14-0.4,0.77-0.29,1.04C1045.8,409.96,1046.05,409.73,1046.04,409.94z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1045.38,411.43c0.66-0.17,1.07-1.49,1.07-1.49C1046.21,410.68,1045.38,411.43,1045.38,411.43z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M1034.82,400.86c0,0,0.69-0.59,1.79-0.74c1.16-0.17,2.15-0.26,3.85,0.17c1.94,0.48,2.73,1.61,2.73,1.61 s1.21,1.17,1.82,2.55c0.37,0.85,0.99,2.49,1.23,3.61c0.24,1.12-4.6-5.53-4.6-5.53l-6.12-0.14l-1.73-0.11l0.15-0.55L1034.82,400.86 z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M1033.25,415.24c-0.15,1.81,0.13,3.23,0.33,4.26c0.14,1.47,0.39,2.93,0.76,4.36 c-0.15-0.88-0.17-1.79-0.06-2.68c0.2,0.66,0.4,1.32,0.6,1.98c0.08,0.28,0.3,0.62,0.57,0.51c-0.51-0.7,0.11-0.57,0.31,0.39 c0.12-1.06,0.6-1.56,0.89-0.81c-0.06-0.96-0.02-1.93,0.1-2.89c0.01-0.01,0.03-0.01,0.04-0.02c0.1,0.94,0.27,1.87,0.5,2.79 c0.13-1.05-0.33-5.15-0.34-5.61c0-0.09,0-0.19,0-0.28c0,0,0,0,0,0c0,0-0.01,0-0.03-0.01c-0.04-0.01-0.11-0.03-0.21-0.08 c-0.22-0.11-0.61-0.33-1.03-0.92c-0.24-0.34-0.41-0.64-0.71-1.17c0.02,0-0.86-1.58-1.15-2.31c-0.01-0.01-0.01-0.03-0.02-0.04 c-0.06-0.17-0.12-0.34-0.17-0.49c-0.37-1.3,0-2.71-0.22-4.51c-0.05-0.36-0.05-0.57-0.04-0.95c0.14-0.12,0.36-0.26,0.73-0.32 c0.74-0.12,1.47-0.06,1.47-0.06s-0.64-0.47-1.44-0.39c-0.04,0-0.07,0-0.11,0.01c-0.31,0.04-0.51,0.17-0.63,0.33 c0.03-0.47,0.07-1.18,0.12-2.37c-0.07-1.23,0.42-2.25,0.42-2.25c-0.42,0.9-0.33,2.01-0.33,2.01l0.32,1.2 c0.02,0.02,0.03,0.05,0.04,0.07l0.81,0.06c0,0,0.43-0.13,0.43-0.01c0,0.03,0.09,0.06,0.23,0.09c-0.01-0.11,0.06-0.22,0.16-0.25 c0-0.1,0.01-0.2,0.01-0.3c0.06,0.1,0.1,0.22,0.12,0.34c0-0.17,0.01-0.34,0.01-0.51c0.1,0.26,0.19,0.53,0.29,0.79 c0.01,0,0.01,0,0.02,0c-0.13-0.58-0.11-0.81-0.16-1.45c-0.02-0.24-0.11-0.34-0.02-0.57c0.05,0.89,0.16,1.26,0.4,2.03 c0.03,0,0.05,0,0.07,0c0-0.18,0-0.35,0-0.53c0.06,0.11,0.09,0.23,0.11,0.35c-0.06-0.22-0.08-0.44-0.05-0.66 c0.07,0.2,0.13,0.41,0.2,0.61c0.01,0,0.02,0,0.03-0.01c-0.09-0.38-0.17-0.77-0.22-1.16c0.13,0.45,0.28,0.89,0.45,1.32c0,0,0,0,0,0 l0.01,0c-0.23-0.91-0.45-1.84-0.31-2.77c-0.02,0.93,0.19,1.86,0.61,2.69l0.05,0.06l0.94-0.06l0.59,0.11l2.41,0.08 c0,0-0.07-1.45,0.6-1.98c0,0,0,0.11,0.19,1.27c0.16,0.96,1.52,1.84,1.79,2.52c0.39,0.97,1.04,0.97,1.2,1.16 c0.03,0.29,0.08,0.58,0.15,0.87l0.41-0.81c0.19-0.14,0.43-0.25,0.73-0.24c0.95,0.01,0.83,0.97,0.61,1.62 c-0.23,0.65-0.83,1.89-1.66,2.16c-0.05,0.02-0.09,0.03-0.13,0.04c-0.05,0.51-0.08,0.83-0.08,0.83s0.07,0.51-0.4,1.2 c-0.06,0.7-0.1,1.26-0.14,1.71c0.74-0.14,1.82-0.35,3-0.5c0.41-1.14,0.66-2.18,0.51-2.76c-0.47-1.81-0.75-2.26-0.38-5.15 c0.34-2.61-0.4-4.42-1.47-6.49c-0.4-1.13-1.51-2.05-4.05-2.6c-3.27-0.71-5.57-0.46-7.13,0.82c-2.01,1.33-2.62,2.28-2.89,4.48 c-0.35,2.86,1.09,4.47,0.61,6.17c-0.08,0.3-0.13,0.57-0.16,0.82l-0.03,0c-0.01,0.13-0.01,0.26,0,0.38 c-0.03,0.98,0.3,1.66,0.61,2.49c0.03,0.08,0.06,0.16,0.08,0.24c0.07,0.36,0.12,0.76,0.12,1.21 C1033.27,414.87,1033.26,415.05,1033.25,415.24z M1046.11,403.58l0.03-0.08C1046.13,403.53,1046.12,403.56,1046.11,403.58 L1046.11,403.58z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1038.58,399.57c-1.19,1.24-0.81,3.63-0.74,5.38c0.05,0.01,0.16,0.06,0.29,0.13 c0.33,0.17,0.81,0.45,0.81,0.45s0.97,0,1.92,0.04c0.88,0.04,1.96,1.2,2.07,1.73c0.34,1.55-0.77,2.51-1.38,4.18 c-0.41,1.15-0.34,3.09-1.36,4.94c-0.42,0.47-1.06,0.72-1.42,0.8c-1.07,0.26-1.84,0.02-1.84,0.02c0,0.1,0,0.19,0,0.29 c0.01,0.18,0.02,0.44,0.04,0.76c-0.06-0.6-0.05-0.93-0.05-1.04c0-0.03,0-0.05,0-0.05s-0.77-0.16-1.41-1.22 c-0.45-0.75-1.04-1.82-1.36-2.39c-0.13-0.24-0.22-0.4-0.22-0.4c0.46,0.96,0.74,1.81,0.6,3.58c-0.14,1.77,0.11,2.34,0.39,3.3 c0.28,0.96,0.43,3.19,0.43,3.19s0.09,0.11,0.18,0.26c0,0,0,0.01,0.01,0.01c0.08,0.14,0.17,0.32,0.2,0.51 c0.01-0.03,0.01-0.07,0.02-0.13c0.01-0.04,0.02-0.09,0.03-0.15l-0.06,0.33c0,0,2.21-0.64,3.17-2.26c-0.3-0.24-0.56-0.52-0.78-0.83 c0.15-0.43,0.74-2.06,1.71-3.06c0.84-0.87,2.31-2.01,2.98-2.52c0.53-0.33,1.03-0.69,1.4-1.06c0,0,0.21-0.25,0.39-0.53 c0,0,0.02-0.02,0.04-0.06c-0.01,0.02-0.03,0.04-0.04,0.07l0,0.04l0-0.04c-0.02,0.02-0.04,0.05-0.05,0.08 c-0.06,0.7-0.1,1.26-0.14,1.71c0.03-0.01-0.01,0.14,0.02,0.13l-0.09,1.23c0.34-0.11,3.58-1.86,5.91-2.02 c0.07-0.01,0.14-0.01,0.21-0.01c-0.78-0.04-1.77-0.01-3.03,0.14c0.4-1.12,0.65-2.15,0.5-2.73c-0.47-1.81-0.75-2.26-0.38-5.15 c0.23-1.73-0.02-3.11-0.53-4.45c-0.22-0.97-0.61-1.89-1.23-2.64c-0.02-0.03-0.04-0.05-0.06-0.08 C1044.54,398.65,1039.93,398.17,1038.58,399.57z M1046.99,408.73c0.03,0.3-0.05,0.65-0.15,0.94c-0.09,0.25-0.23,0.58-0.41,0.92 C1046.73,409.96,1047.04,409.27,1046.99,408.73z M1046.98,408.64c0-0.01,0-0.01,0-0.02 C1046.98,408.63,1046.98,408.63,1046.98,408.64z M1036.39,422.93C1036.39,422.93,1036.39,422.93,1036.39,422.93 C1036.39,422.93,1036.39,422.93,1036.39,422.93z M1037.51,419.75c0.02,0.06,0.05,0.12,0.07,0.18 C1037.55,419.87,1037.53,419.81,1037.51,419.75z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1055.45,387.17l0.79-3.86c0,0,2.34-2.91,3.63-3.5s3.9-1.79,5.44-1.6c1.54,0.19,4.22,0.1,6.35,1.56 c2.14,1.45,2.77,1.41,3.23,3.18s0.59,2.14,0.5,3.32c-0.09,1.18-1.79,10.64-1.79,10.64s-6.85,1.27-6.98,1.27 c-0.07,0-1.92-1.16-3.14-2.96c-1.13-1.66-1.63-3.97-1.63-3.97l-0.85-1.94l-2.65,0.68L1055.45,387.17"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1088.97,570.09c0,0,1.27,1.67-2.19,3.98c-3.46,2.31-4.13,1.9-5.56,3.11s-11.78,3.14-29.03,5.44 c-17.8,2.37-21.1,1.23-29.63-2.6c-8.6-3.86-0.65-2.39,32.08-7.47"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1084.07,461.81l-0.01,0.04c1.04,0.01,2.11,0.07,3.15,0.21C1087.21,462.06,1086.21,461.78,1084.07,461.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1063.76,405.08c0.04-0.09,0.08-0.18,0.13-0.26c-0.05,0.02-0.1,0.04-0.14,0.06 C1063.75,404.95,1063.76,405.02,1063.76,405.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1087.96,430.39c-0.69,2.64-1.13,13.05-1.69,16.65c-0.15,0.99-0.29,1.39-0.11,1.69 c0.18,0.3,0.65,0.49,0.4,1.73c-0.17,0.86-0.28,1.47-0.11,1.96c1.34-2.19,4.37-9.81,4.36-11.41c-0.02-2.66,0.09-6.92,0.2-11.06 C1090.75,430.1,1089.81,430.6,1087.96,430.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1084.06,461.85c0,0-0.63-0.03-0.99-0.01C1083.07,461.84,1083.73,461.84,1084.06,461.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1053.76,435.19c-2.06-0.91-5.19-2.23-6.1-4.42c-0.68,2.19-1.82,5.81-2.88,10.09c0,0-4.21,4.67-8.59,8.43 c-4.29,3.69-7.68,5.95-8.88,6.71c-0.39,0.11-0.75,0.21-1.08,0.29c-1.25,0.23-2.67,0.51-3.01,0.66c-0.63,0.28-1.88,1.84-2.16,2.31 c0,0,0.12,0.11,0.38,0.52c-0.03,0.08-0.05,0.16-0.09,0.23c-0.28,0.56-0.66,4.07-0.36,5.32c0.17,0.68,0.04,0.19,0.58,1.29 s1.23-0.12,1.47-0.21c0,0,0.51,0.6,0.89,0.85c0.38,0.25,1.5,0.12,1.5,0.12s0.81,0.49,1.27,0.25c0.46-0.23,1.02-0.66,1.02-0.66 s0.22,0.14,0.97-0.06c0.55-0.15,0.99-1.15,1.04-1.27l-0.58-0.35c-0.91,0-0.82-1.03-0.82-2.45c0-1.43,0.32-1.91,1.23-1.91 l0.68-0.45c0.2,0,0.39,0.06,0.57,0.16c0.33-0.29,0.78-0.6,1.42-0.86c2.62-1.06,8.41-4.45,11.7-6.46c0.3-0.19,0.58-0.25,0.84-0.42 c6.58-4.34,8.3-7.61,10.12-11.12c1.35-2.6,2.43-5.03,3.26-7.08C1056.92,435.96,1055.89,435.93,1053.76,435.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1080.91,564.54c0.55,0.9,2.12,3.17,3.63,2.79c1.87-0.47,3.82-1.51,3.82-1.51s0,0.26,0.06,0.65 c-0.1-1.07-0.02-2.07,0.03-2.53c-0.97,0.57-2.35,1.21-4.05,1.53C1082.97,565.73,1081.8,565.23,1080.91,564.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1080.61,564.28c0,0.18,0,0.36,0,0.54l0.07-0.48C1080.66,564.32,1080.63,564.3,1080.61,564.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1084.54,567.33c-1.51,0.38-3.07-1.89-3.63-2.79c-0.08-0.06-0.16-0.13-0.23-0.19l-0.07,0.48 c0.02,2.97,0.02,4.9,0.02,4.9c-0.26,0.09-0.51,0.18-0.77,0.26c0,0.05,0.01,0.1,0.01,0.14c0.25,0.11,1.98,0.89,3.48,1.43 c1.43,0.31,2.71,0.5,3.36,0.38c1.31-0.25,1.97-0.89,2.27-1.3c0.09-0.26,0.13-0.53,0.14-0.79c0.04-0.94-0.32-1.84-0.48-2.32 c-0.13-0.39-0.2-0.75-0.24-1.05c-0.06-0.39-0.06-0.65-0.06-0.65S1086.41,566.86,1084.54,567.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1086.72,573.56c1.2-0.1,1.79-0.62,2.07-1.18C1088.44,572.96,1087.82,573.46,1086.72,573.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1086.72,571.93c-0.65,0.12-1.93-0.07-3.36-0.38c-1.5-0.55-3.23-1.32-3.48-1.43 c0-0.05-0.01-0.09-0.01-0.14c-4.12,1.27-7.69,0.55-10.37-0.63c0.3,0.94,1,2.24,2.67,2.72c1.92,0.56,3.71,0.45,5.08,0.11 c2.43-0.59,2.75-1,2.75-1l0.1,0.53c1.77,0.68,4.55,2.03,6.62,1.85c1.1-0.1,1.72-0.6,2.07-1.18c0.57-0.95,0.42-2.11,0.42-2.11 s-0.02,0.06-0.07,0.14c0.01-0.18,0.01-0.37-0.01-0.57c-0.01,0.26-0.05,0.53-0.14,0.79 C1088.69,571.04,1088.04,571.68,1086.72,571.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1076.7,576.93c-2.75-0.11-6.32-0.3-15.25-1.41c-8.93-1.12-9.62-3.9-9.62-3.9 c-0.09-0.29-0.13-0.54-0.14-0.77c-0.04,0-0.07-0.01-0.07-0.01s-0.45,1.89,1.34,3.34c2.75,2.23,6.7,2.24,11.1,3.02 s11.95,1.19,14.43,0.85c2.47-0.33,2.89-0.89,2.75-2.57C1080.96,576.6,1079.45,577.05,1076.7,576.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M1080,571.17c0,0-0.32,0.41-2.75,1c-1.37,0.33-3.16,0.45-5.08-0.11c-1.67-0.48-2.37-1.78-2.67-2.72 c-1.07-0.47-2-1.02-2.77-1.54c-0.36,0.12-0.79,0.3-1.29,0.56c0,0-1.25,0.44-5.91,0.57c-3.19,0.09-7.97-0.84-7.83,1.9 c0.01,0.23,0.05,0.49,0.14,0.77c0,0,0.69,2.79,9.62,3.9c8.93,1.12,12.5,1.3,15.25,1.41c2.75,0.11,4.26-0.33,4.53-1.45 c0.27-1.12-0.82-2.19-0.82-2.19l-0.31-1.59L1080,571.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1084.08,462.18c1.06-0.01,1.84,0.05,2.36,0.12c0.48,0.06,0.93-0.26,1.03-0.73 c0.17-0.78,0.31-1.95-0.08-2.94c-0.66-1.66-0.66-2.82-0.17-3.81c0.33-0.65-0.27-1.09-0.58-2.02c-0.16-0.49-0.25-1.1-0.08-1.96 c0.5-2.49-0.64-1.45-0.28-3.42c0.58-3.24,1-12.22,1.54-15.79c0.07-0.47,0.48-0.81,0.96-0.81c1.33,0.01,2.03-0.37,2.24-0.5 c0.04-0.03,0.07-0.05,0.07-0.05s0.28-5.57,0.13-9.39c0-0.06,0-0.13,0.01-0.19c0.04-0.27,0.07-0.5,0.07-0.69 c0-1.99-3.31-12.93-6.24-13.71c-4.99-1.32-4.9-1.89-6.45-2.4c-0.51-0.17-1.02-0.34-1.53-0.51c-0.13-0.04-0.25-0.12-0.36-0.21 c-0.27-0.25-0.44-0.5-0.46-0.76c-0.06-0.75-1.21-1.54-2.29-1.52c-0.86,0.02-1.81-0.1-3.05,0.41c-2.64,1.09-6.07,1.35-7.16,3.27 c-0.05,0.08-0.12,0.74-0.16,0.83c-0.02,0.05-0.06,0.15-0.08,0.2c-0.17,0.51-0.12,0.61-0.23,1.02c-0.03,0.11-0.05,0.33-0.07,0.53 c-0.02,0.24-0.14,0.46-0.32,0.61c-0.18,0.16-0.36,0.31-0.54,0.47c-0.07,0.06-0.15,0.11-0.24,0.15 c-4.02,1.77-9.43,4.14-10.62,8.28c-1.93,6.76-3.07,8.97-4.1,12.13c-0.33,1.02-0.26,1.93,0.07,2.74c0.9,2.17,3.72,3.61,5.78,4.53 c0.03,0.01,0.06,0.03,0.09,0.04c2.1,0.72,3.59,0.23,4.82-1.02c0.11-0.11,0.22-0.23,0.33-0.36c-0.34,2.77-1.59,13.14-1.59,16.57 c0,3.65,0.11,8.93,0.15,13.82c0.01,0.64,0.63,1.08,1.24,0.89c9.71-3.13,24.78-3.89,24.78-3.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1083.07,461.84c0,0-16.41,0.72-26.02,4.2c0,0,0,0.08-0.01,0.22l0.01-0.22c0,0-0.78,0.53-0.68,5.08 c0.1,4.55,0,6.2,0,6.2l0.05,0.04c-0.17,3.23-0.36,6.8-0.53,10.22c-0.5,10.11,3.48,31.98,4.47,38.77c0.99,6.79,4.66,26.9,4,32.53 c-0.66,5.63-0.14,6.87-0.14,6.87s0.9,0.98,2.49,2.07c0.77,0.52,1.7,1.07,2.77,1.54c2.68,1.18,6.25,1.9,10.37,0.63 c0.25-0.08,0.51-0.16,0.77-0.26c0,0,0-1.92-0.02-4.9c0-0.18,0-0.36,0-0.54c0.02,0.02,0.05,0.04,0.07,0.06 c0.08,0.06,0.15,0.13,0.23,0.19c0.89,0.69,2.06,1.2,3.48,0.93c1.7-0.32,3.08-0.96,4.05-1.53c1.02-0.6,1.59-1.12,1.59-1.12 c-0.83-7.79-6.79-49.06-6.79-49.06s0.66-16.9,2.65-29.16c1.99-12.26,1.33-22.53,1.33-22.53c-1.04-0.14-2.11-0.21-3.15-0.21 C1083.73,461.84,1083.07,461.84,1083.07,461.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1060.88,391.92c0.22,1.25-0.32,2.92-0.32,2.92C1061.29,394.12,1060.88,391.92,1060.88,391.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M1073.6,396.91c-2.55-1.49-6.59,0.54-6.59,0.54s-4.47-1.84-4.57-5.38c-0.09-3.52-2.45-3.78-3.25-2.58 c-0.66,0.99-0.37-0.4-0.95-0.77c-1.33-0.86-2.46-1.57-2.8-1.55c-0.14,1.38-0.03,2.82,0.37,4.22c0.08,0.28,0.1,0.55,0.1,0.82 c-0.01,0.33-0.01,0.8,0.02,1.02c0.03,0.26,0.11,0.51,0.28,0.72c0.54,0.68-0.17,1.87,0.62,3.75c0.43,1,0.62,1.95,0.73,2.68 c0.03-0.3,6.19,4.86,6.16,4.51c0.05-0.02,0.1-0.04,0.14-0.06c1.09-1.92,4.68-2.01,7.32-3.09c1.24-0.51,2.34-0.77,3.2-0.79 C1073.74,399.63,1073.54,398.27,1073.6,396.91z M1060.88,391.92c0,0,0.42,2.2-0.32,2.92 C1060.56,394.84,1061.1,393.16,1060.88,391.92z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1060.56,394.84c0.73-0.72,0.32-2.92,0.32-2.92C1061.1,393.16,1060.56,394.84,1060.56,394.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1028.76,463.05c0-1.43,0.73-2.58,1.64-2.58h-1.13c-0.91,0-1.64,1.16-1.64,2.58 c0,1.43,0.73,2.58,1.64,2.58h0.62h0.51C1029.49,465.63,1028.76,464.47,1028.76,463.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M1030.24,460.46c-0.91,0-1.64,1.16-1.64,2.58c0,1.43,0.73,2.58,1.64,2.58s1.64-1.16,1.64-2.58 c0-1.11-0.45-2.05-1.07-2.42C1030.64,460.52,1030.45,460.46,1030.24,460.46z M1030.31,465.52c-1.19,0.41-0.99-2.59-0.99-2.59 l1.55,0.79C1030.87,463.71,1031.05,465.26,1030.31,465.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M1029.31,462.93c0,0-0.2,3,0.99,2.59c0.74-0.25,0.56-1.81,0.56-1.81L1029.31,462.93z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1022.44,458.31c-0.53,0.11-1.21,1.11-1.23,1.14c0,0,0,0,0,0c0.09,0.14,0.09,0.14,0.22,0.33c0,0,0,0,0,0 C1021.44,459.78,1021.76,458.95,1022.44,458.31z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1084.54,567.33c-1.51,0.38-3.07-1.89-3.63-2.79c-0.08-0.06-0.16-0.13-0.23-0.19l-0.07,0.48 c0.02,2.97,0.02,4.9,0.02,4.9c-0.26,0.09-0.51,0.18-0.77,0.26c0,0.05,0.01,0.1,0.01,0.14c0.25,0.11,1.98,0.89,3.48,1.43 c1.43,0.31,2.71,0.5,3.36,0.38c1.31-0.25,1.97-0.89,2.27-1.3c0.09-0.26,0.13-0.53,0.14-0.79c0.04-0.94-0.32-1.84-0.48-2.32 c-0.13-0.39-0.2-0.75-0.24-1.05c-0.06-0.39-0.06-0.65-0.06-0.65S1086.41,566.86,1084.54,567.33z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1080,571.17c0,0-2.77,1.51-5.74,1.13c-1.93-0.25-3.37-1.71-4.14-2.69c-1.27-0.5-2.37-1.11-3.26-1.71 c-0.81,0.61-3.23,2.25-6.27,2.56c-3.66,0.37-8.67,0.08-8.89,0.06c-0.01,0-0.01,0-0.01,0s-0.06,0.18-0.09,0.47 c-0.09,0.92,0.11,2.97,3.37,4.35c0.45,0.19,0.9,0.36,1.36,0.5c3.34,1.09,6.79,1.15,9.74,1.71c3.36,0.63,9.67,0.85,11.31,0.66 c1.64-0.19,3.83,0,3.98-1.84c0.16-1.84-0.25-2.31-0.82-3.17c-0.13-0.19-0.23-0.5-0.31-0.81C1080.08,571.8,1080,571.17,1080,571.17 z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1060.85,440.81c4.12-4.17,8.37-9.18,5.94-7.9c-2.43,1.27-9.17,9.71-6.31,3.44 c2.86-6.27,9.3-10.55,5.74-8.56c-3.56,1.99-6.16,6.75-6.16,6.75s1.14-4.03,2.9-8.93s1.92-8.71-0.15-3.31 c-1.32,3.44-2.44,5.82-3.09,7.1c0.77-3.76,1.7-8.44,1.45-7.69c-0.41,1.23-1.65,4.89-1.54,3.29s-0.51-7.92-0.51-6.38 c0,1.54-0.8,3.53-2.25,7.21c-1.88,4.78-3.11,7.41-4.65,9.73c-0.37-0.18-0.84-0.44-1.22-0.65c-0.86,1.32-1.69,2.87-2.72,5.2 c-1.2,3.14-18.56,15.43-20,15.8c-1.43,0.37-1.41,0.73-4.71,2.16c-1.45,0.63-2.07,2.37-2.34,3.04c-0.1,0.24-0.17,0.52-0.22,0.83 c-0.1,0.59-0.12,1.33-0.12,2.12c0,0.78,0.01,1.42,0.61,2.36c0.2,0.3,0.23,0.58,0.63,0.64c0.27,0.05,0.94-0.68,0.94-0.68 c0.63,0.66,0.75,0.79,1.07,0.93c0.34,0.14,1.31,0.04,1.31,0.04s0.67,0.44,1.18,0.28c0.51-0.16,1.11-0.68,1.11-0.68 s0.56,0.21,1.22-0.2c0.41-0.25,0.79-1.14,0.79-1.14s-0.27,0.05-0.63,0.01c-0.6-0.07-1.35-0.8-1.46-2.17 c-0.17-2.2,1.06-2.97,1.43-2.98c0.48-0.01,1-0.02,1.2-0.02c0.06,0,0.12,0.01,0.18,0.03l0.35,0.14c0,0,0.5-0.41,0.9-0.61 c0.26-0.14,0.32-0.14,2.01-0.92c0.65-0.3,1.4-0.73,2.32-1.21c0.11-0.06,0.21-0.11,0.32-0.17c1.84-0.96,5.45-3.03,8-4.62 c0.16-0.1,0.33-0.2,0.48-0.3c0.55-0.35,1-0.64,1.38-0.91c0.57-0.39,0.99-0.71,1.33-0.99c0.43-0.36,0.75-0.64,1.16-0.94 c1.32-0.95,2.79-2.76,4.2-4.71c0.33-0.46,0.62-0.87,0.8-1.21c0.22-0.42,0.44-0.87,0.68-1.32c0.49-0.96,1.01-1.97,1.47-2.89 c0.33-0.66,0.62-1.27,0.86-1.79c0.23-0.52,0.51-1.16,0.77-1.79c0.2-0.49,0.21-0.48,0.38-0.89c0-0.01,0.35-0.34,0.35-0.34 c0.09-0.1,0.18-0.21,0.25-0.31c-0.24,2.14-0.65,4.51-0.89,7.26c-0.22,2.61-0.54,5.26-0.67,8.12c-0.06,1.33,0.01,2.81-0.02,4.15 c-0.06,2.51-0.05,5.01,0.05,7.4c0.02,0.55,0.04,1.04,0.06,1.47C1057.51,473.85,1056.88,444.82,1060.85,440.81z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1062.67,451.9C1061.72,452.57,1061.59,452.83,1062.67,451.9L1062.67,451.9z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1081.99,454.21c-4.64-0.99-12.92-2.65-18.06,1.49c0,0,11.43-2.98,16.9-0.17c5.15,2.65,5.98,1.76,6.07,1.63 c0.01-0.01,0,0,0,0s0.04-0.16,0.02-0.23c-0.03-0.12-0.04-0.34-0.05-0.62c-0.02-0.45,0.06-0.93,0.42-1.69 c0.04-0.09,0.04-0.55-0.1-0.66C1086.98,453.8,1085.56,454.98,1081.99,454.21z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1084.11,461.85l-0.05,0l-0.97,0c0,0-9.5,0.33-18.31,2.15c-2.64,0.54-5.49,1.18-7.73,2.05 c0,0,11.45,0.56,15.53,1.84c5.48,1.72,6.84,9.96,7.15,15.78c-0.11,0.62-0.23,1.3-0.35,2.06c-0.6,3.68-1.47,14.96-2.42,17.89 c-0.68,2.1-0.99,3.83-1.09,5.24c-0.32,1.26-1.52,5.91-2.72,9.63c-1.4,4.35,1.4-1.4,2.67-2.67c1.26-1.26,1.12,3.23,1.54,6.87 c0.42,3.65,2.1,5.47,2.1,5.47s-0.01-0.25-0.02-0.67c0,0,0,0.01,0,0.01c0.74,5.33,0.66,21.06,0.88,25.01s0.4,11.79,0.4,11.79 s0.11,0.21,0.36,0.47c0.69,0.71,2.35,1.46,6.18-0.09c0.86-0.35,1.73-1.11,2.77-1.86c0,0-0.89-6.93-2.06-15.73 c-1.71-12.83-3.96-29.39-4.71-33.21c-0.06-0.29,0.03-1.84,0.2-4.08c0.46-5.93,1-16.75,1.95-21.82c1.42-7.61,2.35-20.36,1.8-25.91 l-2.14-0.19l-0.37-0.01L1084.11,461.85z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1059.38,474.96c-2.21-5.43-2.34-8.12-2.33-8.87c0-0.02,0-0.04,0-0.06c0,0.02,0,0.04,0,0.06 C1056.49,474.45,1062.02,481.44,1059.38,474.96z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1091.31,420.01c0-0.2-0.01-0.21-0.01-0.21c0,0,0.02-0.2,0-0.16c-0.03-0.48-0.13-0.68-0.22-1.17 c-0.4-2.01-1.21-4.25-1.98-6.23c-0.51-1.3-0.93-2.15-1.05-2.38c-0.42-0.79-0.29,3.04-0.12,7.56c0.46,12.53-10.65,15.88-6.97,28.66 c0.16,0.55,0.13,0.95-0.04,1.25c-3.97-0.77-11.05-2.28-16.76,3.14c-0.69,0.65-1.21,1.13-1.59,1.45c1.84-1.29,6.76-4.07,12.03-2.61 c8.95,2.49,12.26,3.97,12.26,3.97s-0.09-0.09-0.19-0.48c-0.02-0.09-0.13-0.38-0.15-0.51c0.06-0.12,0.25-0.39,0.6-1.15 c0.23-0.52,0.6-1.24,0.89-1.93c1.17-2.72,2.77-6.79,2.79-8.2c0.04-2.31,0.07-6.24,0.19-10.67c0-0.03,0.08-0.07,0.08-0.07 c0-0.06,0.02-0.43,0.02-0.49c0.07-3.22,0.22-6.11,0.16-8.05c-0.01-0.15-0.03-0.8-0.03-0.93 C1091.28,420.39,1091.31,420.42,1091.31,420.01z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.3,
    points: "1091.27,419.62 1091.27,419.62 1091.27,419.62  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1060.51,392.09c-0.14-0.32-0.27-0.49-0.62-0.85s-0.28-0.93-0.04-1.09c0.33-0.22,0.89,0.72,0.89,0.72 c-0.2-0.45-0.44-1.1-0.86-1.13c-0.42-0.03-0.52,0.41-0.56,0.69c-0.04,0.28,0.04,1.38,0.38,1.7s0.49-0.2,0.62,0.1 c0.13,0.3,0.23,0.55,0.23,0.55S1060.64,392.41,1060.51,392.09z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1059.55,392.42C1059.55,392.42,1059.4,392.18,1059.55,392.42c0.15,0.24,0.36,0.66,0.3,1.2 c-0.06,0.55,0.16,0.77,0.26,0.44s0.23-1.17,0.07-1.32C1060.03,392.58,1059.82,392.77,1059.55,392.42z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1056.09,393.42c0.38,0.2,0.68,0.45,0.55-0.08c-0.11-0.45-0.57-0.97-0.72-1.12 c-0.03-0.03-0.05-0.05-0.05-0.05c-0.13,0.35-0.06,0.81,0.07,1.07C1055.99,393.32,1056.04,393.39,1056.09,393.42z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M1063.76,405.08c0-0.07-0.01-0.13-0.02-0.2c-0.03-0.21-0.1-0.4-0.2-0.55c-1.1-1.65-2.16-5.43-2.99-6.82 c-0.84-1.39-1.47-4.2-1.37-4.94c0.1-0.74-0.65-2.09,0.01-3.09c0.8-1.2,3.15-0.94,3.25,2.58c0.09,3.54,4.57,5.38,4.57,5.38 s4.04-2.03,6.59-0.54c0,0,0,0,0,0c0,0,2.15-8.33,2.8-10.32c0.65-1.99,0.41-6.01,0.41-6.01s-0.3,1.32-0.57,1.99 c-0.27,0.67-0.53-3.6-0.53-3.6s-0.04,0.57-0.61,1.42c-0.58,0.85-0.41-0.13-3.63-1.97c-2.12-1.21-4.41-1.92-6.5-2.09 c-1.08-0.09-2.11-0.03-3.03,0.19c0,0,2.15,0.14,3.31,0.37c-0.37-0.06-4.01-0.56-8.76,4.19c0,0-1.75,2.4-2.72,5.39 c0,0,0.85-1.44,1.54-1.98c0,0-0.77,2.49-0.77,4.51c0,0,0.47-1.25,0.83-1.76c0.03-0.04,0.06-0.06,0.09-0.06 c0.34-0.01,0.77,2.34,2.1,3.2c1.45,0.93-0.41,3.91-0.48,5.05c-0.07,1.09,0.64,3.47,0.51,4.96c-0.01,0.06-0.01,0.12-0.02,0.18 c-0.2,1.47,0.48,1.9,0.99,3.32s0.48,4.59,2.83,3.98c0.92-0.24,1.53-0.7,1.9-1.23c0.11-0.41,0.25-0.87,0.42-1.38 C1063.72,405.18,1063.74,405.13,1063.76,405.08z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1060.51,379.84c0,0,2.88-0.23,5.51,0.14c0.03,0,0.05,0.01,0.07,0.01c-1.31-0.03-4.41,0.21-7.34,2.24 c0,0,3.78,2.01,3.73,4.98c-0.05,2.97,6.06,7.91,6.97,9.28c0.03,0.04,0.05,0.08,0.07,0.12c0.84,1.32,1.07,2.4,1.07,2.4 s0.15,1.4-0.82,3.22c-0.7,1.31-1.98,2.83-4.33,4.2c-0.75,0.43,5.41-2.39,11.44-2.36c2.47,0.01,4.29,1,4.29,1 c-1.02-0.41-1.68-0.93-2.93-1.27c-1.63-0.45-1.75-0.75-2.07-1.59c0,0-0.16-0.86-1.52-1.24c-0.13-0.03-0.23-0.06-0.29-0.12 c-0.03-0.03-0.06-0.07-0.07-0.12c-0.01-0.04-0.02-0.08-0.04-0.12c-0.19-0.66-0.47-1.53-0.63-2.7c-0.04-0.3,0.02-0.63,0-0.97 c0,0,0.05-0.03,0.06-0.12c0.05-0.45,0.42-1.55,0.78-2.95c0.11-0.42,0.26-1.12,0.44-1.8c0.58-2.15,1.35-4.72,1.71-6.22 c0.44-1.82,0.21-5.25,0.21-5.25l-0.55,1.86c-0.05,0.27-0.16,0.2-0.18,0.05l-0.37-3.52c0,0,0.04,0.07,0.01,0.17 c-0.07,0.3-0.17,0.72-0.62,1.25c-0.22,0.25-0.16,0.66-0.94-0.07c-0.72-0.68-2.13-1.24-2.8-1.48c-0.22-0.08-0.43-0.18-0.64-0.28 C1069.84,378.1,1066.67,376.99,1060.51,379.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 1027.6021,
    y1: 463.0595,
    x2: 1030.3756,
    y2: 463.0595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M1028.74,463.06c0-1.43,0.73-2.58,1.64-2.58h-1.13c-0.91,0-1.64,1.16-1.64,2.58 s0.73,2.58,1.64,2.58h0.62h0.51C1029.47,465.64,1028.74,464.49,1028.74,463.06z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M973.61,588.39c0.01,0.04,0.04,0.1,0.12,0.19c-0.03-0.14-0.05-0.27-0.05-0.41 C973.61,588.28,973.6,588.36,973.61,588.39z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1045.36,607.66c0.27-0.68-0.12-1.53-1.16-2.53c-5.59-5.34-18.57-7.22-32.52-8.82 c-4.17-0.48-8.61-0.88-12.9-1.27c-2.98-0.27-5.69-0.53-8.14-0.78c8.3,1.08,26.44,3.54,37.04,5.86 c7.46,1.63,18.14,5.74,16.56,8.78C1044.95,608.39,1045.24,607.96,1045.36,607.66z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1001.52,578.76c-10.34,2.03-22.07,4.32-27.13,8.6c-0.43,0.36-0.63,0.63-0.72,0.81 c0,0.14,0.02,0.28,0.05,0.41c0.33,0.38,1.52,1.18,5.86,2.02c-1.97-2.73,3.16-6.14,13.1-8.74c11.98-3.12,33.45-7.5,39.41-8.55 c7.99-1.41,3.04-2.73-1.86-1.77c-2.27,0.44-5.02,0.86-8.3,1.51c-2.44,1.18-5.22,2.22-8.39,3.09 C1010.21,577.06,1005.99,577.88,1001.52,578.76z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M942.26,636.12c-0.04,0.1-3.77-1.78-4.04-2c-0.27-0.23-0.59-0.45-0.92-0.67c-0.67-0.43-1.41-0.83-2.18-1.2 c-1.54-0.74-3.17-1.37-4.83-1.95c-3.32-1.14-6.76-2.08-10.2-2.76c-2.7-0.51-5.4-1.07-8.1-1.74c6.96,2.59,20,7.74,22.58,10.91 c0.22-0.05,1.61,3.27,1.16,3.39c-0.92,0.24-1.84,0.44-2.75,0.62c-3.66,0.7-7.29,1.08-10.92,1.4c-3.63,0.3-7.25,0.51-10.88,0.66 c-7.24,0.3-14.49,0.38-21.7,0.39l-21.63,0.09l-21.63,0.09l-2.7,0.01l-1.35,0.01c-0.46,0-0.94,0-1.41-0.01 c-1.89-0.05-3.84-0.2-5.83-0.68c-0.99-0.25-2-0.58-2.97-1.05c-0.94-0.45-1.86-1.03-2.67-1.72c-8.81,1.09-12.98,4.22-3.36,5.61 c13.3,1.93,75.3,2.74,106.33-0.57c9.19-0.98,11.86-3.19,12.1-5.53C944.52,637.7,943.51,636.55,942.26,636.12z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M938.97,634.98C938.97,634.99,938.97,634.99,938.97,634.98L938.97,634.98z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M901.98,618.75C901.98,618.76,901.98,618.76,901.98,618.75L901.98,618.75z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1047.58,608.21c0,0-0.04,0.03-0.12,0.08c-0.02,0.06-0.04,0.13-0.07,0.19c-0.69,1.73-2.81,3.14-6.47,4.32 c-2.85,0.92-6.65,1.7-11.31,2.33c-2.65,0.36-5.35,0.63-7.95,0.85c-1.14,0.1-2.28,0.19-3.42,0.27c-3.62,0.24-7.23,0.41-10.88,0.44 l-10.82,0.04l-43.27,0.17L910,617.07c-1.72,0-3.43,0.15-5.06,0.49c-0.8,0.17-1.59,0.4-2.23,0.7c-0.24,0.11-0.45,0.24-0.59,0.35 c0.04,0.04,0.08,0.09,0.13,0.13c0.13,0.12,0.29,0.24,0.47,0.37c1.31-0.2,3.41-0.44,6.73-0.68c5.79-0.42,54.26,0.69,64.75,0.69 c10.5,0,41.67,2.08,66.45-3.18C1055.92,612.71,1047.58,608.21,1047.58,608.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M902.13,618.61c0.14-0.11,0.35-0.24,0.59-0.35c0.63-0.3,1.42-0.53,2.23-0.7 c1.62-0.34,3.34-0.48,5.06-0.49l43.27-0.17l43.27-0.17l10.82-0.04c3.64-0.03,7.26-0.2,10.88-0.44c1.14-0.08,2.28-0.17,3.42-0.27 c2.6-0.21,5.3-0.49,7.95-0.85c4.66-0.63,8.46-1.41,11.31-2.33c3.66-1.18,5.78-2.59,6.47-4.32c0.02-0.06,0.05-0.12,0.07-0.19 c0.37-1.1,0.32-2.77-1.75-4.74c-6.08-5.81-19.45-7.77-33.78-9.41c-4.19-0.48-8.64-0.89-12.95-1.28 c-6.64-0.6-12.91-1.17-17.69-1.96c-0.62-0.1-1.18-0.2-1.71-0.3c-4.34-0.84-5.53-1.64-5.86-2.02c-0.07-0.09-0.11-0.15-0.12-0.19 c-0.01-0.03,0-0.11,0.06-0.23c0.09-0.18,0.29-0.45,0.72-0.81c5.06-4.27,16.79-6.57,27.13-8.6c4.47-0.88,8.69-1.7,12.03-2.63 c3.17-0.88,5.95-1.92,8.39-3.09c17.87-8.61,17.41-24.63,16.99-38.96c-0.06-2.14-0.13-4.36-0.13-6.47 c0-2.36-0.34-19.43-0.65-34.48c-0.23-11.56-0.44-21.55-0.44-22.6c0-3.23-0.86-5.62-2.57-7.1c-2.15-1.87-4.79-1.52-4.9-1.51 c-0.6,0.08-1.01,0.63-0.93,1.23s0.63,1.01,1.22,0.94c0.02,0,1.81-0.21,3.19,1.01c1.19,1.05,1.8,2.88,1.8,5.44 c0,1.07,0.2,11.07,0.44,22.64c0.3,15.04,0.65,32.09,0.65,34.44c0,2.15,0.06,4.38,0.13,6.54c0.23,8.09,0.48,16.45-2.45,23.54 c-3.27,7.93-10.25,13.27-21.34,16.34c-3.26,0.9-7.44,1.72-11.87,2.59c-10.6,2.08-22.62,4.43-28.12,9.08 c-1.32,1.12-1.81,2.25-1.46,3.36c0.86,2.74,6.64,3.93,19.12,5.21c2.45,0.25,5.16,0.51,8.14,0.78c4.29,0.39,8.73,0.79,12.9,1.27 c13.95,1.6,26.93,3.48,32.52,8.82c1.04,1,1.43,1.85,1.16,2.53c-0.12,0.3-0.41,0.73-1.11,1.23c-1.66,1.19-5.6,2.81-14.93,4.06 c-2.06,0.28-4.16,0.51-6.22,0.7c-1.67,0.15-3.34,0.27-5.01,0.37c-3.58,0.21-7.17,0.35-10.74,0.35l-10.82-0.04l-43.27-0.17 L910,613.99c-1.88-0.01-3.78,0.13-5.7,0.51c-0.96,0.2-1.92,0.45-2.92,0.91c-0.5,0.24-1.02,0.52-1.56,1.03 c-0.26,0.26-0.54,0.6-0.74,1.06c-0.2,0.46-0.27,1.06-0.17,1.57c0.1,0.51,0.31,0.91,0.52,1.22c0.22,0.32,0.44,0.55,0.67,0.77 c0.45,0.42,0.9,0.73,1.34,1c0.89,0.54,1.77,0.94,2.65,1.31c1.77,0.72,3.53,1.27,5.31,1.77c0.86,0.24,1.72,0.46,2.58,0.68 c2.69,0.67,5.4,1.23,8.1,1.74c3.44,0.68,6.88,1.62,10.2,2.76c1.66,0.58,3.29,1.21,4.83,1.95c0.77,0.37,1.51,0.76,2.18,1.2 c0.33,0.22,0.65,0.44,0.92,0.67c0.27,0.23,0.5,0.46,0.63,0.65c0.04,0.06,0.07,0.11,0.09,0.14c-0.01,0.02-0.03,0.04-0.05,0.06 c-0.13,0.13-0.38,0.32-0.68,0.48c-0.3,0.17-0.64,0.32-1.01,0.47c-0.82,0.32-1.71,0.58-2.63,0.8c-0.74,0.18-1.5,0.34-2.26,0.48 c-3.44,0.63-6.99,0.98-10.54,1.26c-3.56,0.27-7.14,0.44-10.72,0.56c-7.17,0.24-14.35,0.26-21.56,0.22l-21.63-0.09l-21.63-0.09 l-2.7-0.01l-1.35-0.01c-0.44,0-0.87-0.01-1.29-0.02c-1.71-0.05-3.38-0.21-4.89-0.59c-1.51-0.38-2.83-1.01-3.89-1.93 c-1.07-0.92-1.89-2.17-2.54-3.6c-0.64-1.44-1.09-3.04-1.44-4.7c-0.34-1.66-0.57-3.38-0.74-5.11c-0.33-3.47-0.42-7.02-0.41-10.58 l0.08-21.63l0.17-43.27l0.09-21.63l0-1.36c0-0.48-0.01-0.95-0.02-1.44c-0.03-0.97-0.09-1.94-0.22-2.95 c-0.13-1-0.32-2.03-0.65-3.1c-0.33-1.06-0.81-2.18-1.59-3.23c-0.77-1.05-1.87-1.96-3.02-2.52c-1.15-0.57-2.29-0.85-3.35-1.03 c-1.06-0.17-2.06-0.24-3.02-0.28c-0.96-0.04-1.89-0.05-2.81-0.05l-0.02,0c-1.51,0-2.73,1.23-2.73,2.74 c0,1.51,1.23,2.73,2.74,2.73h0.01c1.77,0,3.51,0,4.96,0.22c0.72,0.11,1.34,0.29,1.81,0.51c0.47,0.23,0.8,0.5,1.11,0.9 c0.62,0.79,1.04,2.23,1.25,3.79c0.11,0.78,0.17,1.61,0.2,2.44c0.02,0.42,0.03,0.84,0.03,1.27l0.01,1.34l0.09,21.63l0.17,43.27 l0.09,21.64c0.02,3.65,0.14,7.32,0.52,11.02c0.2,1.85,0.46,3.71,0.85,5.58c0.4,1.87,0.94,3.75,1.77,5.61 c0.42,0.92,0.92,1.84,1.54,2.71c0.61,0.87,1.34,1.69,2.18,2.41c0.02,0.02,0.05,0.04,0.07,0.06c0.81,0.69,1.73,1.27,2.67,1.72 c0.97,0.47,1.97,0.8,2.97,1.05c1.99,0.48,3.94,0.63,5.83,0.68c0.47,0.01,0.95,0.01,1.41,0.01l1.35-0.01l2.7-0.01l21.63-0.09 l21.63-0.09c7.21-0.02,14.46-0.1,21.7-0.39c3.62-0.15,7.25-0.35,10.88-0.66c3.63-0.31,7.26-0.7,10.92-1.4 c0.91-0.18,1.83-0.38,2.75-0.62c0.92-0.24,1.85-0.52,2.79-0.9c0.47-0.19,0.95-0.41,1.43-0.68c0.48-0.28,0.99-0.61,1.49-1.13 c0.25-0.26,0.49-0.58,0.69-0.98c0.05-0.09,0.09-0.19,0.13-0.3c0.13-0.33,0.21-0.71,0.22-1.09c0.01-0.49-0.09-0.96-0.24-1.34 c-0.15-0.39-0.34-0.7-0.54-0.98c-0.4-0.54-0.83-0.94-1.25-1.29c-0.42-0.35-0.85-0.64-1.27-0.91c-0.85-0.54-1.71-0.98-2.57-1.39 c-1.72-0.81-3.46-1.46-5.21-2.06c-3.51-1.17-7.05-2.11-10.69-2.8c-3.53-0.64-7.02-1.36-10.43-2.27c-1.7-0.46-3.38-0.98-4.96-1.61 c-0.78-0.32-1.55-0.66-2.2-1.06c-0.13-0.08-0.25-0.15-0.36-0.23c-0.18-0.12-0.34-0.25-0.47-0.37 C902.22,618.69,902.17,618.65,902.13,618.61z M938.97,634.98C938.97,634.99,938.97,634.99,938.97,634.98L938.97,634.98z  M901.98,618.75C901.98,618.76,901.98,618.76,901.98,618.75L901.98,618.75z"
  }))), /*#__PURE__*/React.createElement("g", null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M793.47,397.57c2.25-0.59,18.29-5.32,18.29-5.32s-28.61-3.48-29.48-3.61c-0.87-0.13-2.74,0.11-2.54,1.51 c0.06,0.45,0.22,1.47,0.39,2.59l0.01,0l0.63,4.08c1.8,0.27,3.35,0.47,4.69,0.62C788.58,397.76,792.06,397.94,793.47,397.57z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M749.35,395.33l2.82,2.8l3.91,3.89c0,0,3.21-1.02,5-1.56c1.79-0.53,2.87-0.81,2.87-2.14 c0-0.15-0.04-0.38-0.1-0.66L749.35,395.33z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M761.05,389.19c-2.92,0.71-9.19,2.05-12.51,2.74c0,0,6.84,1.02,14.23,2.13 C761.97,391.66,761.05,389.19,761.05,389.19z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M746.38,392.38L746.38,392.38L746.38,392.38C746.38,392.38,746.38,392.38,746.38,392.38z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M826.98,386.5c-3.86-0.62-54.09-8.28-60.68-8.54s-10.83,1.65-12.81,2.29 c-1.98,0.63-19.58,5.54-20.91,6.22c-1.98,1.02-2.72,3.23-2.87,4.15c0,0,0,0,0.01-0.01c0.02-0.19,0.21-0.38,0.57-0.56 c1.99-0.99,17.33-5.03,20.54-6.08s6.93-3.22,15.08-2.76c8.15,0.46,57.37,7.32,61.62,8.04c2.55,0.43,3.38,1.01,3.24,1.57 c0,0.01,0.01,0.01,0.01,0.02C830.79,390.84,831.44,387.21,826.98,386.5z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M763.25,652.57l-1.99-0.19c-0.34-0.02-0.69-0.05-1.03-0.09l-11.21-1.08c-2.68-0.26-4.69-1.95-4.69-3.96 v-1.43c-23.85,3.33-47.91,6.68-49.15,6.82c-2.49,0.29-7.19,0.92-3.25,3.3c4.58,2.76,13.26,7.79,15.89,8.95 c2.63,1.17,4.3,1.33,6.9,0.89c16.89-2.91,81.19-13.62,93.69-16.05l-44.01,2.86C764.02,652.61,763.63,652.6,763.25,652.57z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M812.49,648.56c0.7-0.37,1.04-0.77,1.13-1.17C813.34,647.83,812.96,648.23,812.49,648.56z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M827.53,389.25c-4.25-0.72-53.47-7.59-61.62-8.04c-8.15-0.46-11.87,1.71-15.08,2.76 s-18.55,5.1-20.54,6.08c-0.36,0.18-0.55,0.36-0.57,0.56c-0.09,0.86,3.26,1.92,11.3,3.3c2.13,2.21,12.86,15.71,15.89,19.52 l4.03-0.4c1.01-0.13,2.63-0.13,2.89-0.18l0.88,0.06c0.34,0,0.63,0.02,0.87,0.05l17.88,1.27l0.01,0.01l0.01,0.01l0-0.01l0-0.01 l0.07,0l-2.3-14.5c0,0,0.36,0.05,0.96,0.12c1.03,0.13,2.93,0.4,5.86,0.87c1.58,0.25,6.27,0.96,8.94,0.59 c2.57-0.36,6.7-1.42,10.34-2.53c3.64-1.12,20.28-6.11,22.1-6.9c0.73-0.32,1.25-0.68,1.34-1.06 C830.91,390.26,830.08,389.69,827.53,389.25z M763.68,396.93l-0.01,0l-14.95-2.23l-0.07-0.01l-2.27-2.31h0c0,0,0,0,0.01,0 l2.15-0.45l0,0c3.32-0.7,9.59-2.03,12.51-2.74c0,0,0.92,2.47,1.72,4.87c0.03,0,0.06,0.01,0.08,0.01L763.68,396.93z  M761.08,400.47c-1.79,0.53-5,1.56-5,1.56l-3.91-3.89l-2.82-2.8l14.51,2.34c0.06,0.29,0.1,0.52,0.1,0.66 C763.95,399.65,762.88,399.93,761.08,400.47z M814.7,393.96c-1.39,0.72-11.09,3.29-17.25,5.19c-6.15,1.91-7.97,1.31-11.09,0.92 c-0.63-0.08-2.55-0.34-5.2-0.7l-0.39-2.54c1.08,0.2,2.82,0.43,4.69,0.62c-1.34-0.15-2.89-0.35-4.69-0.62l-0.63-4.08l-0.01,0 c-0.17-1.11-0.33-2.14-0.39-2.59c-0.2-1.41,1.67-1.65,2.54-1.51c0.87,0.13,29.48,3.61,29.48,3.61 C814.35,392.71,816.09,393.23,814.7,393.96z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M764.71,412.91l-0.88-0.06c-0.26,0.05-1.88,0.05-2.89,0.18C762.17,413.02,763.65,412.91,764.71,412.91z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M783.45,414.23l-17.88-1.27c-0.23-0.03-0.53-0.05-0.87-0.05l18.75,1.32L783.45,414.23z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 783.5,
    y: 414.2,
    transform: "matrix(0.0703 -0.9975 0.9975 0.0703 315.1788 1166.6576)",
    fill: "#5E5D5B",
    width: 0.01,
    height: 0.07
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M783.47,414.24L783.47,414.24L783.47,414.24l-18.76-1.32c-1.06-0.01-2.54,0.11-3.78,0.12l-4.03,0.4 l-9.09,0.91l11.39-1.1c1.96-0.17,2.91-0.16,3.76,0.21c2.12,0.94,2.3,2.17,2.3,5.23s-0.12,227.43-0.12,229.11 c0,4.1-1.87,4.68-3.88,4.58l1.99,0.19c0.38,0.04,0.77,0.04,1.16,0.02l44.01-2.86l0.81-0.05c1.27-0.08,2.4-0.49,3.26-1.11 c0.47-0.34,0.85-0.73,1.13-1.17c0.33-0.52,0.52-1.09,0.52-1.7V420.01c0-1.92-1.83-3.56-4.37-3.92l-26.23-1.85L783.47,414.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 744.3303,
    y1: 532.7292,
    x2: 814.137,
    y2: 532.7292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1019,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2683,
    style: {
      stopColor: "#222221",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3384,
    style: {
      stopColor: "#161616",
      stopOpacity: 0.2038
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4571,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.1648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.1132
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M783.47,414.24L783.47,414.24L783.47,414.24l-18.76-1.32c-1.2-0.12-2.49-0.02-3.78,0.12 l-4.03,0.4l-9.09,0.91l11.39-1.1c1.96-0.17,2.85-0.27,3.7,0.1c2.12,0.94,2.36,2.28,2.36,5.34s-0.12,227.43-0.12,229.11 c0,4.1-1.87,4.68-3.88,4.58l1.99,0.19c0.38,0.04,0.77,0.04,1.16,0.02l44.01-2.86l0.81-0.05c1.27-0.08,2.4-0.49,3.26-1.11 c0.47-0.34,0.85-0.73,1.13-1.17c0.33-0.52,0.52-1.09,0.52-1.7V420.01c0-1.92-1.83-3.56-4.37-3.92l-26.23-1.85L783.47,414.24z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M760.23,652.28c0.34,0.04,0.69,0.08,1.03,0.09l-12.24-1.17L760.23,652.28z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M749.02,651.2l12.24,1.17c2.02,0.1,3.88-0.48,3.88-4.58c0-1.68,0.12-226.04,0.12-229.11 s-0.18-4.29-2.3-5.23c-0.85-0.38-1.8-0.38-3.76-0.21l-11.39,1.1c-2.1,0.58-3.49,2.07-3.49,3.74v227.73v1.43 C744.33,649.25,746.34,650.95,749.02,651.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 744.3303,
    y1: 532.7596,
    x2: 814.137,
    y2: 532.7596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1019,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2683,
    style: {
      stopColor: "#222221",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2761,
    style: {
      stopColor: "#2C2C2B",
      stopOpacity: 0.2355
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3148,
    style: {
      stopColor: "#585857",
      stopOpacity: 0.2788
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3575,
    style: {
      stopColor: "#80807F",
      stopOpacity: 0.3266
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    style: {
      stopColor: "#A2A2A2",
      stopOpacity: 0.3778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4531,
    style: {
      stopColor: "#BFBFBF",
      stopOpacity: 0.4335
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#D7D7D7",
      stopOpacity: 0.4951
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5707,
    style: {
      stopColor: "#E9E9E9",
      stopOpacity: 0.565
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#F6F6F5",
      stopOpacity: 0.6484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7436,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.7585
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9595,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M749.02,651.2l12.24,1.17c2.02,0.1,3.88-0.48,3.88-4.58c0-1.68,0.12-226.04,0.12-229.11 s-0.18-4.29-2.3-5.23c-0.85-0.38-1.8-0.38-3.76-0.21l-11.39,1.1c-2.1,0.58-3.49,2.07-3.49,3.74v227.73v1.43 C744.33,649.25,746.34,650.95,749.02,651.2z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.02,651.2l12.24,1.17c2.02,0.1,3.88-0.48,3.88-4.58c0-1.68,0.12-226.04,0.12-229.11 s-0.08-4.41-2.2-5.34c-0.85-0.38-1.9-0.27-3.85-0.1l-11.39,1.1c-2.1,0.58-3.49,2.07-3.49,3.74v227.73v1.43 C744.33,649.25,746.34,650.95,749.02,651.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.3789,
    y1: 395.0315,
    x2: 815.1896,
    y2: 395.0315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M795,397.19c1.47-0.33,16.76-4.95,16.76-4.95s-16.03,4.73-18.29,5.32 c-1.4,0.37-4.89,0.19-8.01-0.12C792.89,398.28,793.75,397.47,795,397.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.3789,
    y1: 394.4287,
    x2: 815.1896,
    y2: 394.4287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M748.54,391.93c-1.24,0.26-2.06,0.43-2.15,0.45l-0.01,0l2.33,2.32l14.95,2.23 c-0.22-0.81-0.55-1.83-0.9-2.87C755.38,392.95,748.54,391.93,748.54,391.93z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "748.64,394.69 748.71,394.7 746.38,392.38  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.3789,
    y1: 393.5418,
    x2: 815.1896,
    y2: 393.5418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_61_)",
    points: "748.64,394.69 748.71,394.7 746.38,392.38  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M811.75,392.25c0,0-15.28,4.62-16.76,4.95c-1.25,0.28-2.11,1.09-9.54,0.25 c-1.87-0.19-3.61-0.43-4.69-0.62l0.39,2.54c2.65,0.36,4.57,0.62,5.2,0.7c3.12,0.39,4.94,0.99,11.09-0.92 c6.15-1.91,15.86-4.47,17.25-5.19C816.09,393.23,814.35,392.71,811.75,392.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.3789,
    y1: 396.362,
    x2: 815.1896,
    y2: 396.362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M811.75,392.25c0,0-15.28,4.62-16.76,4.95c-1.25,0.28-2.11,1.09-9.54,0.25 c-1.87-0.19-3.61-0.43-4.69-0.62l0.39,2.54c2.65,0.36,4.57,0.62,5.2,0.7c3.12,0.39,4.94,0.99,11.09-0.92 c6.15-1.91,15.86-4.47,17.25-5.19C816.09,393.23,814.35,392.71,811.75,392.25z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M763.67,396.93l0.01,0l-0.83-2.86c-0.03,0-0.06-0.01-0.08-0.01C763.12,395.1,763.44,396.12,763.67,396.93 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.3789,
    y1: 395.4934,
    x2: 815.1896,
    y2: 395.4934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M763.67,396.93l0.01,0l-0.83-2.86c-0.03,0-0.06-0.01-0.08-0.01 C763.12,395.1,763.44,396.12,763.67,396.93z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M748.54,391.93l-2.15,0.45C746.48,392.36,747.3,392.19,748.54,391.93L748.54,391.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.3789,
    y1: 392.1566,
    x2: 815.1896,
    y2: 392.1566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M748.54,391.93l-2.15,0.45C746.48,392.36,747.3,392.19,748.54,391.93L748.54,391.93z"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    fill: "#659896",
    width: 316,
    height: 321
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1D9C8",
    d: "M333.92,76.85c-5.14-7.56-16.2-16.56-28.76-10.8c-2.37,1.18-5,2.86-7.78,5.28 c0.22,0.05,0.44,0.11,0.66,0.18c3.46,1.09,5.08,3.43,5.08,3.43s10.77-0.86,14.15,8.28c0,0-5.42-8.57-14.79-6.89 c0,0-4.16-6.72-15.18-2.94c0,0,4.56-3.23,9.76-2.14c0.98-1.33,3.16-3.88,6.8-6.18c-5.98-7.72-13.04-10.06-18.08-10.86 c-13.62-2.15-28.22,2.45-40.13,9.49c-23.85,14.08-45.33,15.4-70.82,23.11l192.45-2.57C348.75,83.9,341.16,72.45,333.92,76.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1D9C8",
    d: "M168.63,103.99c-13.55-1.51-15.32-11.69-28.83-8.67c-10.71,2.4-15.65-5.39-24.9,0.05 c-1.56,0.92-2.75,2.02-3.37,2.65c2.06,0.69,3.2,1.99,3.75,2.83c2.46-0.41,4.6,0.37,4.6,0.37c2.16-2.28,5.24-2.05,5.24-2.05 c-4.21,0.68-5.13,3.3-5.13,3.3c-5.69-2.62-10.02,2.16-10.02,2.16c1.29-2.27,3.09-3.29,4.8-3.69c-3.41-2.39-7.47-3.6-13.2-2.07 c-2.39,0.81-5.47,2.19-9.53,4.45c-6.75,3.75-26.06,5.81-40.26,6.2l136.93-1.97C188.71,107.55,189.5,106.31,168.63,103.99z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M382.99,505.12l-1.5,0.13l-0.75,0.07l-0.38,0.04c-0.07,0.01-2.33,0.13-2.42,0.14l0.15,0.52l0.02,0.84 c0.07-0.02,2.28-0.44,2.42-0.47l0.36-0.07l0.73-0.14l1.47-0.26l2.95-0.51l5.92-0.99l-5.98,0.46L382.99,505.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M266.63,481.31c-0.15,0.54-0.35,1.12-0.55,1.6l-0.04,0.09l-0.02,0.07c-0.52,1.92-1.21,3.88-1.92,5.79 c-0.73,1.91-1.5,3.82-2.39,5.64c-0.45,0.91-0.91,1.78-1.47,2.59c-0.56,0.82-1.17,1.57-1.88,2.13c-1.42,1.14-3.42,1.41-5.44,1.47 l-12.49,0.13l-3.13,0.03l-0.39,0c-0.1-0.01-0.17-0.02-0.26-0.02c-0.09-0.02-0.17-0.06-0.26-0.08c-0.09-0.03-0.18-0.09-0.27-0.14 c-0.36-0.22-0.71-0.54-1.03-0.89c-1.27-1.48-2.2-3.35-3.13-5.18l-0.16-0.32l-0.34,0.02c-0.95,0.06-1.87,0.17-2.81,0.36 c-0.23,0.05-0.47,0.11-0.7,0.17c-0.05,0.01-0.13,0.04-0.22,0.07c-0.09,0.03-0.15,0.07-0.22,0.11c-0.13,0.08-0.25,0.17-0.35,0.27 c-0.39,0.37-0.66,0.76-0.93,1.14c-0.53,0.76-1.03,1.49-1.62,2.12c-0.59,0.63-1.28,1.16-2.06,1.45c-0.39,0.15-0.8,0.24-1.22,0.27 l-0.32,0.02l-0.34,0l-0.69,0.01c-0.92,0.01-1.83,0-2.74-0.02c-1.82-0.04-3.65-0.15-5.43-0.46c-0.89-0.15-1.78-0.35-2.62-0.64 c-0.85-0.29-1.68-0.65-2.39-1.15c-0.71-0.51-1.29-1.19-1.72-1.96c-0.43-0.77-0.72-1.62-0.93-2.49c-0.21-0.87-0.34-1.77-0.46-2.67 l-0.36-2.7c-0.21-1.8-0.33-3.62-0.39-5.43l-0.01-0.19l-0.16,0.1c-0.78,0.49-1.58,0.97-2.39,1.41c-0.81,0.44-1.63,0.88-2.51,1.16 c-0.43,0.14-0.9,0.08-1.37,0.08c-0.46-0.01-0.92-0.05-1.39-0.09c-0.92-0.11-1.75-0.23-2.7-0.62c0.86,0.35,1.78,0.54,2.69,0.67 c0.46,0.06,0.92,0.1,1.39,0.12c0.23,0.01,0.46,0.02,0.7,0.02c0.23,0.02,0.48-0.02,0.7-0.08c0.9-0.26,1.73-0.69,2.55-1.12 c0.77-0.4,1.52-0.83,2.26-1.28c0.03,1.76,0.11,3.52,0.29,5.28l0.31,2.71c0.1,0.91,0.21,1.82,0.41,2.72c0.2,0.9,0.48,1.8,0.93,2.63 c0.44,0.83,1.06,1.59,1.83,2.16c0.77,0.57,1.64,0.96,2.52,1.28c0.88,0.32,1.79,0.54,2.7,0.72c1.83,0.35,3.68,0.49,5.52,0.57 c0.92,0.04,1.84,0.06,2.76,0.07l0.69,0.01l0.34,0l0.37-0.01c0.49-0.03,0.99-0.13,1.46-0.29c0.95-0.33,1.76-0.94,2.42-1.63 c0.67-0.69,1.21-1.46,1.74-2.19c0.26-0.36,0.53-0.72,0.81-0.97c0.07-0.06,0.14-0.11,0.2-0.15c0.03-0.01,0.06-0.04,0.08-0.04 c0.02-0.01,0.04-0.02,0.11-0.03c0.21-0.05,0.42-0.1,0.64-0.14c0.75-0.14,1.53-0.22,2.31-0.27c0.85,1.77,1.71,3.56,3.04,5.17 c0.37,0.42,0.78,0.83,1.3,1.15c0.14,0.07,0.27,0.16,0.42,0.22c0.16,0.05,0.31,0.12,0.48,0.16c0.17,0.02,0.36,0.05,0.52,0.06 l0.39,0l3.13,0.03l12.52,0.11c1.07-0.01,2.16-0.08,3.26-0.31c1.1-0.22,2.22-0.68,3.16-1.38c0.94-0.71,1.66-1.58,2.28-2.46 c0.64-0.89,1.17-1.84,1.65-2.78c0.96-1.89,1.79-3.81,2.57-5.75c0.76-1.92,1.48-3.83,2.07-5.86c0.28-0.62,0.48-1.19,0.66-1.81 c0.19-0.63,0.34-1.28,0.43-1.95c0.08-0.67,0.13-1.37,0.05-2.09c-0.01-0.08-0.02-0.15-0.04-0.23l0.51-0.1l1.16-0.22l4.64-0.88 c3.1-0.58,6.19-1.14,9.3-1.68c6.2-1.12,12.41-2.17,18.63-3.13l4.67-0.71c1.43-0.23,2.86-0.4,4.34-0.69l-0.01,0.07 c3.82,0.27,7.66,0.58,11.45,1.02c0.47,0.05,0.94,0.12,1.41,0.18l0.7,0.1l0.35,0.05l0.31,0.06c0.82,0.17,1.61,0.52,2.33,0.99 c0.72,0.47,1.39,1.07,1.98,1.74c0.43,0.48,0.83,1.03,1.17,1.57c-4.11,2.77-8.36,5.4-12.73,7.75c-1.15,0.61-2.32,1.2-3.49,1.74 c-1.16,0.52-2.38,0.95-3.63,1.3c-2.49,0.7-5.07,1.13-7.67,1.43c-2.6,0.29-5.21,0.43-7.83,0.45c-2.62,0.01-5.24-0.08-7.83-0.41 c-2.58-0.31-5.06-1.22-7.43-2.32c-1.18-0.56-2.34-1.17-3.48-1.82c-0.57-0.33-1.13-0.66-1.69-1l-0.84-0.52 c-0.26-0.15-0.49-0.31-0.78-0.45l2.52-4.83l-2.73,4.83l-0.04,0.08l0.1,0.05c0.54,0.29,1.1,0.69,1.65,1.03 c0.55,0.36,1.11,0.71,1.67,1.05c1.13,0.68,2.28,1.32,3.46,1.91c2.36,1.17,4.86,2.15,7.51,2.53c2.62,0.39,5.27,0.54,7.91,0.59 c2.64,0.04,5.29-0.04,7.93-0.28c2.64-0.24,5.27-0.62,7.86-1.28c1.29-0.33,2.58-0.74,3.82-1.27c1.23-0.53,2.42-1.1,3.6-1.69 c4.72-2.39,9.25-5.07,13.69-7.95l0.59-0.38l-0.32-0.64c-0.25-0.5-0.5-0.91-0.79-1.34c-0.28-0.42-0.59-0.83-0.92-1.22 c-0.66-0.78-1.41-1.5-2.28-2.1c-0.87-0.6-1.86-1.06-2.92-1.32l-0.4-0.08l-0.36-0.06l-0.73-0.12c-0.48-0.08-0.96-0.15-1.44-0.22 c-2.14-0.3-4.27-0.55-6.41-0.78l4.21-1.49c2.98-1.04,5.92-2.16,8.89-3.09c2.98-0.94,6.01-1.76,9.06-2.51 c6.09-1.53,12.28-2.71,18.46-3.98c3.09-0.63,6.19-1.25,9.25-2.03c1.53-0.39,3.06-0.81,4.55-1.34c0.74-0.27,1.49-0.54,2.2-0.87 c0.36-0.16,0.71-0.34,1.06-0.54c0.34-0.2,0.68-0.41,0.94-0.71c-0.27,0.28-0.63,0.46-0.97,0.65c-0.35,0.17-0.71,0.33-1.08,0.47 c-0.73,0.29-1.48,0.52-2.23,0.75c-1.51,0.43-3.04,0.79-4.58,1.11c-3.08,0.63-6.19,1.12-9.3,1.64c-6.22,1.01-12.45,2.05-18.64,3.4 c-3.09,0.69-6.17,1.45-9.21,2.35c-3.06,0.89-6.04,1.93-9.02,2.95l-4.47,1.52c-1.4,0.46-2.78,0.91-4.16,1.21 c-0.03,0-0.05-0.01-0.08-0.01l0,0.03c-0.06,0.01-0.12,0.03-0.19,0.04c-1.46,0.29-3.05,0.46-4.61,0.68 c-1.57,0.21-3.13,0.44-4.69,0.67c-6.25,0.94-12.48,1.97-18.69,3.06c-3.11,0.56-6.21,1.13-9.31,1.73l-4.65,0.9l-1.16,0.23 l-0.58,0.11l-0.21,0.04l-0.16-0.25c-0.24-0.36-0.5-0.71-0.78-1.04c-0.57-0.66-1.23-1.28-2.06-1.76c-0.41-0.24-0.87-0.42-1.35-0.55 c-0.47-0.13-1.03-0.15-1.38-0.16c-1.59-0.06-3.16-0.11-4.74-0.14c-3.16-0.07-6.32-0.11-9.49-0.09c-1.58,0.01-3.17,0.03-4.75,0.1 c-1.59,0.07-3.16,0.12-4.8,0.34c-1.62,0.22-3.23,0.62-4.77,1.25c-0.76,0.32-1.51,0.7-2.22,1.16c-0.35,0.23-0.69,0.48-1.02,0.77 c-0.08,0.07-0.16,0.14-0.24,0.22l-0.16,0.15c-0.02,0.02-0.07,0.04-0.11,0.05l-1.94-0.07l-0.05,0l-0.02,0 c-0.1,0.01-0.21-0.04-0.26-0.13c-0.01,0.02-0.08-0.26-0.14-0.44c-0.07-0.2-0.14-0.39-0.23-0.59c-0.34-0.76-0.88-1.54-1.73-2 c-0.41-0.23-0.92-0.33-1.29-0.37c-0.4-0.05-0.78-0.09-1.16-0.12c-0.76-0.06-1.52-0.1-2.28-0.14c-3.03-0.14-6.05-0.16-9.08-0.12 c-0.76,0.01-1.51,0.03-2.27,0.07c-0.75,0.02-1.58,0.12-2.32,0.36c-0.75,0.24-1.46,0.6-2.1,1.05c-0.32,0.22-0.62,0.47-0.9,0.74 c-0.14,0.13-0.28,0.27-0.41,0.41c-0.14,0.16-0.22,0.26-0.35,0.33c-0.26,0.13-0.57,0.11-0.84-0.09c-0.32-0.2-0.64-0.41-0.97-0.59 c-0.65-0.39-1.33-0.72-2.02-1.04c-1.28-0.57-2.61-1.03-3.98-1.3c0.2-0.26,0.4-0.51,0.62-0.74c1.45-1.51,3.22-2.72,5.08-3.73 c1.86-1.02,3.82-1.85,5.81-2.61c3.99-1.52,8.11-2.68,12.27-3.71c4.15-1.05,8.35-1.93,12.56-2.73c8.43-1.61,16.92-2.91,25.43-4.07 c2.13-0.3,4.26-0.57,6.39-0.85l3.2-0.4l1.61-0.2c0.57-0.08,1.14-0.18,1.7-0.32c1.13-0.28,2.22-0.7,3.25-1.24 c1.02-0.54,1.96-1.18,2.85-1.87c0.88-0.68,1.7-1.41,2.51-2.12l2.41-2.13c3.21-2.84,6.44-5.62,9.77-8.28 c3.35-2.64,6.78-5.16,10.36-7.45c3.58-2.3,7.31-4.36,11.18-6.08c1.93-0.87,3.92-1.61,5.94-2.29c2.01-0.69,4.06-1.28,6.13-1.82 c4.13-1.08,8.33-1.94,12.55-2.67c4.23-0.71,8.48-1.27,12.75-1.76c4.27-0.48,8.55-0.85,12.84-1.15c4.29-0.28,8.59-0.51,12.89-0.7 c-8.61-0.04-17.22,0.24-25.82,0.91c-4.3,0.33-8.59,0.82-12.86,1.43c-0.61,0.09-1.22,0.18-1.83,0.28c-1.04,0.13-2.08,0.26-3.11,0.4 c-1.46,0.21-2.93,0.43-4.38,0.68c-0.87,0.14-1.74,0.29-2.61,0.45c0.27-0.13,0.54-0.26,0.81-0.39l13.69-6.55l6.86-3.27 c2.28-1.12,4.59-2.17,6.85-3.34c-4.88,1.46-9.68,3.16-14.4,5.07c-4.74,1.86-9.37,3.96-13.96,6.16c-2.59,1.25-5.15,2.55-7.69,3.91 c-2.31,0.52-4.61,1.04-6.9,1.61c-2.87,0.71-5.71,1.49-8.56,2.28c-1.42,0.39-2.83,0.83-4.25,1.25c-1.41,0.42-2.82,0.85-4.23,1.29 c-2.81,0.9-5.6,1.85-8.39,2.81c-2.77,1.02-5.54,2.03-8.28,3.13c2.88-0.65,5.74-1.39,8.59-2.12l4.28-1.09l4.27-1.12 c2.86-0.69,5.69-1.5,8.54-2.19c2.48-0.63,4.96-1.28,7.44-1.89c-3.25,1.51-6.39,3.24-9.42,5.13c-3.68,2.29-7.21,4.81-10.6,7.48 c-3.39,2.67-6.67,5.47-9.89,8.31c-3.28,2.78-6.22,6-10.11,6.89c-0.48,0.12-0.97,0.21-1.46,0.28l-1.59,0.21l-3.2,0.41 c-2.14,0.29-4.27,0.57-6.4,0.88c-4.27,0.59-8.52,1.29-12.78,2.01c-4.25,0.73-8.49,1.5-12.71,2.4c-8.43,1.81-16.86,3.85-24.89,7.13 c-2,0.83-3.96,1.78-5.83,2.89c-1.86,1.12-3.64,2.43-5.09,4.07c-1.44,1.69-2.66,4.2-3.15,6.28c-0.47,2.1-0.9,6.21-0.03,6.62 c-0.03-2.13,0.17-4.94,0.74-6.98c0.48-1.71,1.2-3.37,2.27-4.77c1.35,0.34,2.65,0.87,3.88,1.5c0.66,0.34,1.31,0.72,1.94,1.12 c0.32,0.2,0.62,0.42,0.93,0.63c0.32,0.27,0.86,0.38,1.29,0.17c0.11-0.05,0.21-0.12,0.29-0.2l0.21-0.21 c0.13-0.13,0.26-0.25,0.4-0.37c0.28-0.24,0.57-0.45,0.88-0.65c0.61-0.39,1.28-0.69,1.97-0.88c0.7-0.19,1.39-0.25,2.15-0.24 c0.75-0.01,1.5,0,2.25,0.02c3.01,0.07,6.02,0.22,9.01,0.43c0.75,0.06,1.5,0.12,2.23,0.2c0.37,0.04,0.74,0.09,1.09,0.14 c0.37,0.06,0.61,0.12,0.86,0.26c0.49,0.27,0.85,0.79,1.1,1.4c0.06,0.15,0.12,0.31,0.16,0.47c0.06,0.17,0.05,0.27,0.2,0.63 c0.27,0.6,0.93,0.98,1.58,0.95l-0.07,0l2,0.13l0.03,0l0.04,0c0.34-0.01,0.69-0.13,0.97-0.34l0.47-0.41 c0.27-0.22,0.57-0.43,0.88-0.63c0.62-0.39,1.29-0.71,1.98-0.99c0.7-0.27,1.42-0.48,2.15-0.66c0.74-0.16,1.48-0.31,2.23-0.38 c1.49-0.17,3.08-0.19,4.64-0.23c1.57-0.02,3.13-0.03,4.7-0.02c3.14,0.02,6.29,0.1,9.43,0.21c1.57,0.06,3.14,0.12,4.71,0.2 c0.44,0.02,0.67,0.04,0.96,0.11c0.28,0.08,0.56,0.19,0.83,0.35c0.54,0.31,1.05,0.77,1.5,1.3c0.22,0.27,0.43,0.55,0.63,0.84 l0.13,0.21l-0.03,0.02c0.21,0.38,0.35,0.84,0.42,1.34c0.07,0.5,0.04,1.05-0.01,1.59C266.9,480.21,266.78,480.76,266.63,481.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M337.99,528.08c-0.19,7.04,1.21,13.72,3.95,18.81c2.84,5.27,6.79,8.24,11.11,8.36c0.09,0,0.18,0,0.27,0 c4.23,0,8.23-2.74,11.29-7.75c3.01-4.93,4.77-11.52,4.96-18.57c0.19-7.04-1.21-13.72-3.95-18.81c-2.84-5.27-6.79-8.24-11.11-8.36 c-4.33-0.12-8.43,2.63-11.55,7.74C339.94,514.44,338.18,521.03,337.99,528.08z M341.74,515.96l0.97,6.71l-1.82,0.09l1.65,1.14 l-2.88,4.98c0-0.25,0-0.51,0.01-0.76C339.78,523.78,340.5,519.63,341.74,515.96z M343.48,546.43c-0.05-0.1-0.1-0.2-0.16-0.3 l2.55,0.55l-0.57,1.95l1.31-1.02l1.42,4.43C346.34,550.75,344.79,548.87,343.48,546.43z M359.49,551.37l1.54-5.58l1.55,0.94 l-0.87-2.01l3.34-1.62C363.61,546.62,361.69,549.48,359.49,551.37z M365.85,521.19l0.5-4.94c0.84,2.88,1.35,6.04,1.5,9.34 l-1.8-3.28l1.32-0.94L365.85,521.19z M354.46,503.1c1.53,0.04,3.02,0.54,4.42,1.44l-3.76,3.16l-0.67-3.22l-0.7,3.34l-4.32-3.19 c1.54-1,3.16-1.53,4.81-1.53C354.32,503.1,354.39,503.1,354.46,503.1z M347.67,506.02l6.83,5.05l6.12-5.15 c1.27,1.2,2.43,2.76,3.46,4.66c0.2,0.37,0.39,0.74,0.57,1.13l-1.08,10.58l4.28,7.77c-0.2,3.71-0.83,7.2-1.81,10.31l-0.06-0.12 l-6.53,3.16l-2.68,9.73c-1.11,0.5-2.27,0.77-3.45,0.77c-0.07,0-0.14,0-0.22,0c-0.78-0.02-1.55-0.17-2.31-0.42l-2.76-8.57 l-5.83-1.25c-1.27-3.18-2.09-6.82-2.4-10.7l5.28-9.12l-1.7-11.81c0.34-0.69,0.71-1.36,1.1-1.99 C345.45,508.43,346.53,507.09,347.67,506.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M413.42,567.64l-7.59-0.78l-15.17-1.56c-9.73-0.96-19.47-1.91-29.21-2.83c3.97-0.71,7.95-1.41,11.92-2.16 c9.04-1.67,18.07-3.42,27.06-5.38c-9.14,1.07-18.25,2.36-27.34,3.72c-3.89,0.56-7.77,1.19-11.65,1.79 c2.13-1.68,4.1-3.96,5.84-6.82c3.87-6.34,6.17-14.79,6.51-23.84l1.75-0.64l-1.72-0.55c0.16-9.07-1.68-17.65-5.21-24.21 c-3.71-6.89-8.85-10.76-14.47-10.92c-0.34-0.01-0.69,0-1.03,0.01l0-0.07l-13.99,0.22c1.65-2.02,3.89-3.46,6.34-4.48 c2.54-1.05,5.28-1.65,8.05-2.1c1.4-0.17,2.79-0.39,4.2-0.48c0.7-0.06,1.41-0.13,2.11-0.17l1.02-0.03c0.34,0,0.68,0.02,1.02,0.03 c1.35,0.09,2.69,0.35,3.94,0.83c1.26,0.48,2.43,1.16,3.48,2.02c2.11,1.71,3.68,4.06,4.84,6.58c1.17,2.53,1.95,5.25,2.51,8.01 c0.28,1.39,0.52,2.78,0.69,4.18c0.16,1.4,0.29,2.81,0.37,4.23c0.16,2.83,0.16,5.67-0.04,8.49c-0.39,5.65-1.52,11.28-3.63,16.55 l-0.15,0.37l0.39-0.07l14.32-2.7l-14.01,2.21c2.17-5.17,3.41-10.71,3.93-16.3c0.26-2.86,0.34-5.74,0.24-8.61 c-0.04-1.44-0.16-2.87-0.3-4.31c-0.15-1.44-0.38-2.86-0.64-4.28c-0.53-2.83-1.29-5.65-2.48-8.32c-1.18-2.66-2.81-5.22-5.12-7.15 c-1.15-0.96-2.45-1.76-3.85-2.31c-1.4-0.56-2.89-0.88-4.38-1c-0.37-0.02-0.75-0.05-1.12-0.05l-1.12,0.02 c-0.73,0.04-1.44,0.1-2.16,0.15c-1.44,0.07-2.87,0.28-4.31,0.43c-2.86,0.42-5.74,1-8.5,2.09l-1.03,0.42 c-0.34,0.15-0.66,0.34-1,0.51c-0.33,0.18-0.67,0.34-0.99,0.54l-0.94,0.63l-0.47,0.32c-0.15,0.12-0.29,0.24-0.44,0.36l-0.87,0.73 c-0.27,0.26-0.53,0.54-0.79,0.81l-0.39,0.41c-0.13,0.14-0.24,0.29-0.36,0.44l-0.7,0.88c-0.22,0.3-0.42,0.62-0.63,0.93l-0.31,0.47 c-0.1,0.16-0.19,0.32-0.28,0.48l-0.55,0.96c-0.68,1.3-1.31,2.61-1.89,3.92l-0.44,0.98l-0.42,1.01c-0.29,0.67-0.54,1.35-0.78,2.03 c-0.51,1.35-0.96,2.71-1.42,4.07c-1.8,5.44-3.41,10.92-4.98,16.42c-1.49,5.25-2.93,10.5-4.33,15.78 c-3.34,0.21-6.7,0.39-10.05,0.53c-3.6,0.16-7.21,0.27-10.81,0.3c-1.8,0.01-3.6,0.01-5.38-0.05c-1.78-0.06-3.58-0.17-5.38-0.29 c-3.6-0.24-7.2-0.54-10.8-0.84c-14.4-1.21-28.8-2.6-43.21-3.89l-10.81-0.95c-3.61-0.31-7.21-0.59-10.78-1 c-3.58-0.41-7.15-0.91-10.66-1.63c-1.76-0.36-3.5-0.79-5.2-1.31c-1.7-0.53-3.37-1.16-4.89-2.02c-0.76-0.43-1.47-0.93-2.08-1.51 c-0.6-0.59-1.1-1.27-1.35-2.04c-0.13-0.38-0.21-0.78-0.22-1.19c-0.02-0.42-0.01-0.9-0.02-1.34l-0.03-2.71l-0.13-10.85l-0.13-10.85 c-0.04-1.8,0.03-3.6,0.37-5.38c0.33-1.77,0.84-3.52,1.69-5.12c-0.9,1.57-1.47,3.32-1.86,5.08c-0.4,1.77-0.54,3.6-0.55,5.41 l-0.13,10.85l-0.13,10.85l-0.03,2.71c0,0.46-0.02,0.89-0.01,1.37c0,0.49,0.09,0.99,0.24,1.47c0.29,0.96,0.88,1.8,1.55,2.48 c0.68,0.69,1.46,1.24,2.26,1.72c1.62,0.95,3.34,1.62,5.09,2.19c0.94,0.31,1.89,0.58,2.85,0.83c2.12,8.77,5.19,13.87,10.07,16.33 c-0.64-0.05-1.28-0.1-1.93-0.14l-5.46-0.32l-7.69-0.48l-8.27-0.28l7.58,0.82l7.59,0.78l6.17,0.53c6.43,0.64,12.85,1.26,19.28,1.88 c-2.19,0.23-4.38,0.45-6.57,0.72c-2.97,0.33-5.95,0.71-8.92,1.1c-2.97,0.42-5.94,0.81-8.89,1.36c6-0.15,11.98-0.41,17.95-0.79 c2.99-0.16,5.97-0.4,8.96-0.6l8.81-0.71c10.03,0.96,20.07,1.85,30.1,2.78l30.38,2.68l28.58,2.42c0.33,0.07,0.67,0.13,1.02,0.17 l16.17,1.47l-12.86,2.22c-4.52,0.82-9.05,1.6-13.57,2.47c-4.52,0.84-9.03,1.71-13.54,2.6c-4.51,0.92-9.02,1.81-13.5,2.86 c9.13-1.16,18.23-2.43,27.32-3.81c4.55-0.66,9.08-1.41,13.63-2.11l13.61-2.22l8.59-1.48c1.79,0.14,3.57,0.28,5.36,0.42 c10.14,0.8,20.27,1.56,30.41,2.31l15.21,1.07l7.61,0.53l7.61,0.49L413.42,567.64z M354.1,495.25 c10.3,0.28,18.27,15.47,17.77,33.86c-0.24,9.01-2.48,17.42-6.29,23.66c-3.69,6.05-8.4,9.32-13.27,9.19l-1.25-0.11 c-9.69-1.4-17.02-16.09-16.54-33.75c0.24-9.01,2.48-17.42,6.29-23.66c3.62-5.94,8.23-9.19,13-9.19 C353.91,495.25,354,495.25,354.1,495.25z M322.46,542.6l0.2-0.75c2.91-11.01,5.92-22.03,9.36-32.86c0.89-2.7,1.79-5.36,2.93-7.93 c0.56-1.3,1.16-2.57,1.79-3.81l0.51-0.9c0.09-0.15,0.17-0.3,0.26-0.45l0.05-0.08l8.94-0.14c-2.72,1.71-5.23,4.37-7.39,7.9 c-3.96,6.49-6.28,15.18-6.53,24.46c-0.25,9.28,1.6,18.08,5.2,24.78c1.87,3.47,4.1,6.18,6.58,8.03l-15.11-1.37 c-7.02-1.01-10.73-5.53-13.34-16.48c1.93-0.11,3.86-0.23,5.8-0.36L322.46,542.6z M235,538.04c6.02,0.63,12.05,1.23,18.08,1.83 c-3.7,7.3-9,11.54-14.39,11.39l-1.37-0.13c-5.45-0.86-10.31-6.04-13.32-14.22c0.07,0.01,0.14,0.01,0.21,0.02L235,538.04z  M202.57,533.95c0.02,0.01,0.05,0.01,0.07,0.02c3.56,0.78,7.15,1.35,10.76,1.81c2.74,0.35,5.48,0.63,8.22,0.9 c2.13,6.26,5.31,11.02,9.07,13.84l-14.91-1.39C208.92,548.14,205.15,543.84,202.57,533.95z M299.55,556.88l-30.39-2.57 c-6.82-0.55-13.64-1.11-20.45-1.66c2.73-0.29,5.46-0.55,8.18-0.87c5.95-0.67,11.89-1.42,17.81-2.38c-6,0.06-11.98,0.34-17.96,0.7 c-2.99,0.16-5.97,0.4-8.96,0.59l-0.89,0.07c3.27-2.27,6.21-5.91,8.49-10.66c0.4,0.04,0.81,0.08,1.21,0.12 c7.2,0.71,14.4,1.43,21.61,2.05c3.61,0.31,7.21,0.62,10.83,0.87c1.81,0.12,3.62,0.24,5.45,0.31c1.83,0.07,3.65,0.08,5.46,0.07 c4.6-0.03,9.17-0.18,13.75-0.41c1.63,7.04,3.88,12.56,8.17,15.73L299.55,556.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M201.63,525.01c-0.41,0.28-0.91,0.49-1.42,0.68c-1.01,0.38-2.07,0.67-3.13,0.98 c-1.02,0.33-2.12,0.31-3.17,0.02c-1.05-0.28-2.05-0.76-2.95-1.39c0.86,0.68,1.84,1.22,2.9,1.57c1.05,0.35,2.23,0.45,3.32,0.15 c1.07-0.26,2.14-0.5,3.2-0.84c0.53-0.17,1.06-0.36,1.57-0.68c0.25-0.17,0.53-0.36,0.68-0.74c0.07-0.19,0.07-0.42,0.01-0.61 c-0.06-0.19-0.16-0.33-0.26-0.47l-0.02-0.02l-0.04-0.03l-7.92-5.87l0,0l-0.03-0.02c-0.22-0.14-0.36-0.39-0.37-0.64l-0.01-1.25 l-0.01-1.29c0-0.24,0.15-0.48,0.34-0.61c0.1-0.06,0.2-0.1,0.3-0.1c0.05,0,0.1,0,0.15,0.01l0.32,0.06 c0.42,0.08,0.85,0.16,1.27,0.24c0.85,0.15,1.71,0.29,2.56,0.41c3.42,0.49,6.84,0.82,10.26,1.14c3.42,0.3,6.84,0.58,10.27,0.83 c3.42,0.24,6.85,0.46,10.27,0.68c3.42,0.21,6.85,0.42,10.28,0.6l10.28,0.52l10.28,0.48l10.28,0.42l10.28,0.39l2.57,0.09l0.32,0.01 c0.07,0,0.06,0,0.1,0.01c0.05,0.01,0.1,0.04,0.14,0.07c0.03,0.03,0.02,0.02,0.07,0.08l0.19,0.26l0.37,0.52l0.74,1.05l0.19,0.26 l0.09,0.13c0.04,0.06,0.04,0.06,0.05,0.08c0.03,0.05,0.04,0.09,0.04,0.12c0.01,0.06-0.04,0.2-0.18,0.31 c-0.04,0.03-0.07,0.06-0.12,0.08c-0.02,0.01-0.04,0.02-0.07,0.03l-0.03,0.02l-0.07,0.03l-0.6,0.21c-3.21,1.11-6.49,2.11-9.76,3.17 c-1.63,0.53-3.27,1.05-4.9,1.62c-0.41,0.14-0.82,0.29-1.24,0.46l-0.32,0.13c-0.13,0.06-0.26,0.12-0.4,0.21 c-0.07,0.04-0.15,0.11-0.23,0.17c-0.09,0.09-0.17,0.15-0.26,0.3c-0.08,0.12-0.16,0.31-0.18,0.51c-0.02,0.21,0.02,0.39,0.08,0.54 c0.13,0.3,0.27,0.41,0.4,0.54c0.13,0.11,0.25,0.2,0.36,0.27c0.23,0.15,0.44,0.25,0.65,0.36c0.42,0.2,0.83,0.36,1.24,0.52l1.2,0.45 l0.58,0.23c0.21,0.08,0.45,0.18,0.67,0.24c0.93,0.29,1.87,0.34,2.77,0.33c0.89-0.02,1.75-0.09,2.59-0.13 c0.83-0.03,1.69-0.06,2.55-0.11l10.29-0.5c6.86-0.35,13.71-0.71,20.56-1.14c-6.86,0.02-13.72,0.09-20.57,0.19l-10.28,0.16 c-0.86,0.02-1.71,0.03-2.59,0.03c-0.87,0.02-1.73,0.06-2.55,0.05c-0.82-0.02-1.61-0.09-2.31-0.33c-0.18-0.05-0.34-0.13-0.53-0.2 l-0.61-0.26l-1.19-0.48c-0.39-0.16-0.77-0.32-1.12-0.49c-0.05-0.03-0.1-0.05-0.15-0.08c0.36-0.13,0.74-0.26,1.12-0.38 c1.61-0.52,3.26-1.01,4.9-1.5c3.29-0.98,6.57-1.96,9.86-3.05l0.62-0.21l0.08-0.03l0.11-0.05c0.08-0.03,0.15-0.06,0.22-0.1 c0.15-0.07,0.29-0.16,0.42-0.27c0.53-0.4,0.96-1.08,0.95-1.89c0-0.39-0.13-0.78-0.32-1.1c-0.11-0.19-0.15-0.23-0.22-0.33 l-0.18-0.26l-0.73-1.06l-0.37-0.53l-0.18-0.26c-0.08-0.12-0.22-0.29-0.35-0.41c-0.28-0.26-0.61-0.44-0.98-0.54 c-0.17-0.05-0.39-0.08-0.54-0.08l-0.32-0.02l-2.57-0.12l-10.28-0.44l-4.89-0.22l2.89-10.37c4.92-2.31,9.92-4.52,15-6.39 c1.31-0.48,2.63-0.93,3.95-1.32c0.66-0.2,1.32-0.37,1.98-0.53c0.66-0.15,1.3-0.26,2-0.36c2.74-0.4,5.51-0.61,8.29-0.62 c1.39-0.01,2.78,0.02,4.17,0.1c0.7,0.04,1.39,0.08,2.09,0.14c0.35,0.02,0.6,0.05,0.73,0.08c0.01,0.02,0.01,0.04,0.02,0.06 c0.04,0.14,0.09,0.38,0.2,0.65c0.11,0.27,0.3,0.56,0.52,0.77c0.45,0.44,0.92,0.62,1.33,0.76c0.84,0.26,1.59,0.33,2.34,0.39 c0.75,0.05,1.48,0.05,2.2,0.04l2.11-0.04c1.4-0.02,2.82-0.02,4.27-0.1c1.45-0.08,2.97-0.26,4.44-0.79 c1.48-0.53,2.8-1.43,3.88-2.47c1.09-1.04,2-2.2,2.84-3.38c0.42-0.59,0.81-1.2,1.2-1.8c0.37-0.58,0.76-1.15,1.16-1.71 c0.8-1.12,1.66-2.19,2.59-3.21c1.85-2.03,3.97-3.82,6.3-5.26c4.67-2.92,10.16-4.41,15.69-4.9c2.76-0.23,5.57-0.17,8.15,0.69 c1.29,0.43,2.51,1.07,3.62,1.89c1.11,0.81,2.13,1.77,3.09,2.78c0.95,1.01,1.89,2.13,3.06,2.99c0.58,0.43,1.23,0.79,1.94,1.02 c0.7,0.22,1.44,0.3,2.16,0.3c1.44-0.01,2.83-0.25,4.23-0.39c1.4-0.15,2.81-0.25,4.22-0.29c-1.41-0.03-2.83,0-4.24,0.09 c-1.41,0.08-2.82,0.24-4.21,0.21c-0.69-0.02-1.37-0.12-2.01-0.35c-0.64-0.23-1.22-0.58-1.76-1.01c-1.09-0.85-1.94-1.95-2.88-3.03 c-0.94-1.06-1.95-2.09-3.09-2.99c-1.14-0.9-2.42-1.64-3.79-2.15c-1.37-0.51-2.81-0.82-4.26-0.94c-1.44-0.14-2.89-0.12-4.32-0.04 c-2.86,0.19-5.71,0.6-8.49,1.37c-2.78,0.77-5.47,1.89-7.96,3.38c-2.49,1.48-4.77,3.33-6.76,5.44c-1,1.05-1.92,2.17-2.78,3.34 c-0.43,0.58-0.84,1.18-1.23,1.78c-0.39,0.59-0.77,1.16-1.17,1.71c-1.6,2.22-3.46,4.27-5.85,5.08c-1.19,0.42-2.51,0.57-3.87,0.63 c-1.37,0.06-2.78,0.04-4.19,0.06c-1.44,0.01-2.83,0.09-4.15-0.01c-0.66-0.04-1.32-0.13-1.83-0.29c-0.25-0.08-0.45-0.19-0.5-0.26 c-0.06-0.07-0.07-0.06-0.17-0.47c-0.05-0.19-0.14-0.53-0.4-0.86c-0.26-0.34-0.62-0.54-0.9-0.64c-0.28-0.09-0.54-0.15-0.76-0.17 l-0.17-0.02l-0.13-0.01l-0.26-0.02c-0.71-0.05-1.42-0.11-2.13-0.15c-1.43-0.08-2.86-0.12-4.3-0.12c-2.87,0.01-5.75,0.2-8.59,0.63 c-0.7,0.1-1.46,0.23-2.17,0.4c-0.71,0.17-1.42,0.36-2.11,0.57c-1.38,0.42-2.74,0.88-4.07,1.38c-2.68,0.99-5.3,2.08-7.9,3.21 c-2.52,1.11-5.02,2.24-7.5,3.45l-17.65-0.77l-17.91-0.73l-17.92-0.66l-17.81-0.55c-0.44-0.59-0.86-1.2-1.28-1.81l-1.31-1.94 c-0.87-1.3-1.72-2.61-2.57-3.92c0.77,1.36,1.56,2.71,2.35,4.06c0.4,0.67,0.8,1.35,1.21,2.01c0.42,0.67,0.83,1.32,1.28,1.98 l0.06,0.08l0.13,0.01l17.88,1.18l17.9,1.1l17.9,1.04l16.79,0.92l-0.81,10.11l-15.66-0.7l-20.54-0.96 c-3.42-0.17-6.84-0.35-10.27-0.54c-3.42-0.19-6.84-0.38-10.26-0.62c-3.41-0.24-6.83-0.5-10.21-0.88c-0.85-0.09-1.69-0.2-2.53-0.33 c-0.42-0.06-0.84-0.13-1.26-0.2l-0.32-0.05c-0.16-0.02-0.32-0.03-0.49-0.02c-0.33,0.03-0.64,0.16-0.89,0.34 c-0.5,0.37-0.81,0.97-0.81,1.59l0.05,1.29l0.05,1.32c0.04,0.61,0.4,1.17,0.92,1.47l-0.03-0.02l8.1,5.53 c0.13,0.16,0.18,0.29,0.14,0.41C202,524.69,201.83,524.87,201.63,525.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M259.07,529.43c-0.77-0.26-1.58-0.48-2.45-0.57l-2.35-0.25c-3.13-0.34-6.26-0.6-9.39-0.89l-9.4-0.74 c-6.27-0.42-12.55-0.81-18.84-0.98c-3.15-0.09-6.29-0.16-9.47-0.04c-0.41,0.03-0.78,0.04-1.26,0.14 c-0.17,0.04-0.23,0.08-0.33,0.11l-0.28,0.11l-0.55,0.22c-0.73,0.3-1.46,0.61-2.17,0.95c-1.43,0.66-2.84,1.38-4.2,2.18 c1.46-0.6,2.93-1.14,4.41-1.65c0.74-0.25,1.49-0.49,2.23-0.72l0.56-0.17l0.28-0.08c0.09-0.03,0.21-0.06,0.23-0.06 c0.29-0.03,0.71-0.02,1.09-0.01c3.1,0.13,6.24,0.44,9.36,0.68l9.39,0.77l9.39,0.71l9.4,0.64c3.14,0.17,6.27,0.39,9.41,0.54 l2.35,0.12c0.7,0.03,1.42,0.19,2.16,0.38c1.47,0.38,2.94,0.91,4.39,1.49c2.91,1.13,5.77,2.44,8.63,3.75 c-2.62-1.75-5.36-3.32-8.19-4.75C262.05,530.62,260.61,529.96,259.07,529.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M304.91,499.5c-0.21,0-0.44,0.01-0.69,0.01c-1.6,0-1.6,1.43-1.6,2.12c0,0.39,0.02,2.26,0.05,4.62 c0.05,3.91,0.12,9.27,0.12,11.11c0,3.12,0.42,3.77,1.57,5.54c0.35,0.54,0.58,0.95,0.75,1.26c0.39,0.7,0.67,1.2,1.52,1.2 c0.06,0,0.11,0,0.17,0c0.05,0,0.09,0,0.15,0c0.25,0,0.54-0.03,0.79-0.27c0.36-0.35,0.4-0.91,0.4-2v-19.71 c0-1.89-0.2-2.79-0.75-3.33C306.79,499.47,305.96,499.48,304.91,499.5z M306.84,523.08c0,0.51-0.01,0.81-0.03,0.97 c-0.07,0-0.18,0-0.22,0c0,0-0.01,0-0.01,0c-0.07-0.07-0.2-0.31-0.33-0.53c-0.18-0.32-0.42-0.76-0.81-1.35 c-1.09-1.68-1.35-2.08-1.35-4.81c0-1.85-0.07-7.21-0.12-11.13c-0.03-2.36-0.05-4.22-0.05-4.61c0-0.63,0.07-0.77,0.08-0.79 c0,0,0.05-0.03,0.22-0.03c0.26,0,0.49,0,0.71-0.01c0.77-0.01,1.33-0.02,1.54,0.18c0.37,0.36,0.37,1.9,0.37,2.4V523.08z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M135.59,437.82c-0.4,0.63-0.86,1.23-1.37,1.77c-0.59,0.63-1.14,1.15-1.66,1.58 c0.31,0.79,0.62,1.6,0.92,2.43C134.28,442.29,135.17,440.36,135.59,437.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.2,559.34c0.03,0.01,0.06,0.01,0.09,0.02c-0.16-0.3-0.32-0.61-0.47-0.91c-1.43-1.84-2.35-4.09-2.6-6.41 c0.07,1.16,0.14,2.32,0.21,3.49c-0.55-2.69-0.7-5.45-0.45-8.18c-0.09,0.99-0.28,1.98-0.57,2.93c0.27-2.45,0.24-4.94-0.09-7.38 c-0.01,0.94-0.02,1.87-0.03,2.81c0-0.3-0.13-0.66-0.18-0.96c-0.06-0.33-0.11-0.66-0.15-1c-0.08-0.65-0.14-1.31-0.17-1.97 c-2.32,0.11-4.42,1.21-6.29,2.91c-0.23,5.55-0.02,10.72,1.15,13.52l-0.23,0.01c0.12,0,0.25,0.01,0.37,0.01 c2.66-0.08,5.71,0.21,9.35,1.09c-0.09-0.12-0.18-0.25-0.27-0.38C108.98,559.08,109.09,559.21,109.2,559.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M90.01,558.82c0.18-0.02,0.35-0.05,0.52-0.07l-0.51,0.03C90.02,558.8,90.02,558.81,90.01,558.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M133.85,504.35c0,1.45,0.03,4.97,0.68,5.78c0.31-1.7,1.02-3.46,1.02-4.25c0-0.62-0.31-1.03-0.52-1.23 c0.01-0.06,0.02-0.12,0.03-0.18c1.24-0.25,0.85-1.09,0.43-2.44c0.05-0.3,0.1-0.61,0.15-0.92c-0.11,0.04-0.23,0.08-0.36,0.13 C134.23,501.71,133.85,501.35,133.85,504.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M133.1,467.57c-0.26,0.17-0.46,0.35-0.63,0.53C132.68,467.89,132.9,467.72,133.1,467.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M131.83,445.75c0,0,0.78-0.72,1.64-2.15c-0.3-0.83-0.6-1.63-0.92-2.43c-7.32,6.14-8.43-4.63-12.15,11.91 c-0.96,4.29-1.18,8.56-1.1,12.59c0.3,1.69,0.59,3.79,0.85,6.38c1.74,17.29,11.31,25.85,16.14,23.45 c0.02,0.01,0.05,0.02,0.07,0.03c0.01-0.1,0.02-0.21,0.02-0.31c0.48-0.39,0.98-0.8,1.35-1.05c-0.8,0.5-1.26,0.9-1.26,0.9 c0.12-5.15-0.03-7.8-1.78-13.04c-1.75-5.24-1.39-7.32-1.45-9.62c0.52,4.37,1.7,6.72,2.46,9.42s0.64,6.63,1.87,8.53 c1.22,1.9,6.01,1.68,3.64,2.3c-1.28,0.33-2.37,0.86-3.17,1.33c0.04-0.02,0.08-0.04,0.11-0.05c5.07-1.41,6.37-2.43,3.06-8.34 c-2.63-4.7-6.13-12.34-7.66-15.75c0.25-1.08,0.66-2,1.1-2.92c-0.32,0.06-0.6,0.15-0.85,0.26c0.05,0.96-0.37,2.32-0.37,2.32 c-0.52,0.07-1.32-0.55-1.49-0.69c-0.01,0.02-0.02,0.05-0.03,0.07c0,0,0.01-0.03,0.03-0.07c-0.02-0.02-0.03-0.03-0.03-0.03 c0.05-0.08,0.1-0.16,0.16-0.24c0.92-1.86,2.55-3.43,2.55-3.43s-0.11,1.35,0.08,1.22c0.04-0.03,0.14-0.04,0.27-0.05 c0.7-1.42,1.43-2.94,1.75-5.13c-0.15,0.28-0.33,0.53-0.54,0.72c-1.51,1.4-3.17,2.88-3.17,2.88s1.1-4.07,1.98-5.37 c0.88-1.3,1.78-1.12,1.78-1.12c0.04-0.03,0.07-0.04,0.11-0.06c-0.09-3.12-0.89-7.35-3.01-13.51c-0.07-0.19-0.14-0.38-0.2-0.58 C132.49,445.42,131.83,445.75,131.83,445.75z M130.42,469.62c0,0,0.92,0.08,1.35-0.64C131.08,470.9,129.48,468.98,130.42,469.62 z M130.75,470.35l1.06-1.15C131.81,469.2,131.73,469.98,130.75,470.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M137.57,490.38c-1.23-1.9-1.11-5.83-1.87-8.53s-1.94-5.05-2.46-9.42c0.06,2.3-0.3,4.39,1.45,9.62 c1.75,5.24,1.9,7.89,1.78,13.04c0,0,0.46-0.4,1.26-0.9c0.09-0.06,0.2-0.12,0.3-0.18c0.81-0.47,1.89-1,3.17-1.33 C143.58,492.06,138.8,492.27,137.57,490.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M134.62,465.14c0,0-1.64,1.57-2.55,3.43c-0.06,0.08-0.11,0.16-0.16,0.24c0,0,0.01,0.01,0.03,0.03 c-0.02,0.05-0.03,0.07-0.03,0.07c0.01-0.02,0.02-0.05,0.03-0.07c0.17,0.14,0.98,0.77,1.49,0.69c0,0,0.43-1.36,0.37-2.32 c0.25-0.1,0.53-0.19,0.85-0.26c0.02,0,0.03-0.01,0.05-0.01c2.18-0.42,1.79-0.61,1.79-0.61s-1.01-0.07-1.53-0.03 c-0.13,0.01-0.24,0.03-0.27,0.05C134.51,466.49,134.62,465.14,134.62,465.14z M132.47,468.1c0.17-0.17,0.37-0.36,0.63-0.53 C132.9,467.72,132.68,467.89,132.47,468.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M134.98,459.4c-0.88,1.3-1.98,5.37-1.98,5.37s1.66-1.48,3.17-2.88c0.21-0.2,0.39-0.45,0.54-0.72 c0.71-1.29,0.73-3.16,0.15-2.95c-0.03,0.01-0.07,0.03-0.11,0.06C136.77,458.28,135.86,458.1,134.98,459.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M106.53,530.72c-0.03,0.05-0.05,0.11-0.08,0.16c-0.11,0.27-0.22,0.53-0.33,0.8 c0,0.05-0.01,0.09-0.01,0.14c0.11-0.32,0.24-0.63,0.37-0.94C106.5,530.82,106.51,530.77,106.53,530.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M99.74,469.06c2.48,0.5,4.33,3.79,1.98,6.65s-3.19,4.09-3.71,6.3c-0.52,2.21,1.07,4.23,1.07,4.23 s0.33-1.69,0.86-3.73c0.53-2.04,3.01,0.74,5.39-1.79c2.38-2.53,0.74-9.37-0.22-10.95c-0.96-1.58-2.82-4.08-6.51-3.11 c-3.69,0.98-4.49,5.37-5.3,8.43C93.3,475.09,96.26,468.36,99.74,469.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M102.29,485.3c-1.07,1.25,1.92,5.99,3.49,7.85c1.57,1.86,3.07,0.07,1.39-3.11 c-1.68-3.18-0.57-3.94,0.23-5.67c0.8-1.73-0.06-2.16-0.06-2.16C105.67,484.85,103.37,484.05,102.29,485.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M103.43,498.67c0,0-8.43-9.09-9.1-17.02C94.33,481.66,95.28,495.71,103.43,498.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M184.9,526.23c6.75-5.09,14.36-8.96,18.89-11.31c4.64-2.42,10.5-3.5,14.12-5.03 c3.63-1.53,10.24,0.25,12.47-2.04c0.54-0.56,0.82,0.28,1.26,0.82c0.56,0.7,1.2,1.29,1.16,1.6c-0.17,1.33-0.19,3.12,1.08,3.18 c1.27,0.06,1.78-0.76,1.53-2.1c0.22,0.86,0.19,1.52,0.01,2.04c0.38,0.29,0.73,0.55,1.03,0.79c1.06-0.72,1.08-2.62,0.1-3.66 c-1.02-1.08-3.44-3.5-5.92-5.03c-2.48-1.53-5.98-4.45-8.08-5.15c-1.32-0.44-4.41-1.66-7.97-2.94c3.39,2.6,6.89,5.29,10.13,7.78 c-0.61,0.12-1.22,0.28-1.84,0.44c-1.42,0.37-2.18,0.51-3.5,0.63c-0.02-0.02-0.05-0.04-0.07-0.06c-0.6,0.05-1.69,0.15-2.67,0.28 c-0.4,0.03-0.84,0.07-1.33,0.11c-1.84,0.15-3.35,0.53-4.6,0.95c-0.14,0.02-0.28,0.04-0.4,0.06c-1.34,0.18,1.52-0.89,2.23-1.07 c0.71-0.18-0.89-1.88-1.34-3.48c-0.45-1.61,0-2.77,2.59-1.16c0.13,0.08,0.27,0.17,0.41,0.26c-3.23-2.57-6.47-5.15-9.34-7.43 c-3.09-0.03-3.94,1.99-5.33,4.12c-1.78,2.74-4.71,7.12-8.4,10.37c-3.69,3.24-6.49,6.87-8.46,8.84 c-0.81,0.81-2.23,2.03-3.63,3.19C180.07,521.81,182.56,523.38,184.9,526.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M213.78,501.88c-2.59-1.61-3.04-0.45-2.59,1.16c0.45,1.61,2.05,3.31,1.34,3.48 c-0.71,0.18-3.57,1.25-2.23,1.07c0.12-0.02,0.26-0.04,0.4-0.06c1.25-0.42,2.76-0.8,4.6-0.95c0.49-0.04,0.93-0.07,1.33-0.11 c0.98-0.13,2.07-0.23,2.67-0.28c-1.66-1.32-3.38-2.69-5.11-4.07C214.05,502.05,213.91,501.96,213.78,501.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M219.3,506.21c0.02,0.02,0.05,0.04,0.07,0.06c1.32-0.12,2.08-0.26,3.5-0.63 c0.61-0.16,1.23-0.31,1.84-0.44c-3.24-2.49-6.74-5.18-10.13-7.78c-8.9-6.84-16.99-13.06-17.26-13.26c-0.6-0.46-0.55,0.18-0.74,0 c-0.18-0.18-1.94-1.66-2.9-0.65c-0.97,1.01,1.38,2.63,1.57,2.81c0.18,0.18-0.5,0.4-0.13,0.64c0,0,4.17,3.32,9.74,7.75 c2.87,2.28,6.11,4.86,9.34,7.43C215.91,503.51,217.63,504.88,219.3,506.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M230.38,514.99c1.35,1.08,2.26,1.8,2.53,2.04c5.66,4.88,9.29,5.53,9.75,5.67 c0.1,0.03,0.21,0.04,0.3,0.03c0.11,0.09,0.23,0.18,0.34,0.25c0.33,0.19,0.41-0.08,0.28-0.28c-0.1-0.14-0.18-0.24-0.26-0.33 c0.03-0.2-0.05-0.48-0.29-0.87c-0.65-1.06-1.73-2.91-6.59-7.34c-0.28-0.26-0.65-0.5-1.03-0.79 C235.08,514.37,231.08,515.11,230.38,514.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M233.04,515.07c1.05-0.21,2.02-0.66,2.38-1.67c0.18-0.52,0.2-1.18-0.01-2.04 c0.25,1.34-0.25,2.16-1.53,2.1c-1.27-0.06-1.25-1.85-1.08-3.18c0.04-0.31-0.6-0.89-1.16-1.6c-0.43-0.54-0.71-1.38-1.26-0.82 c-2.23,2.29-8.84,0.51-12.47,2.04c-3.63,1.53-9.48,2.61-14.12,5.03c-4.53,2.36-12.14,6.23-18.89,11.31 c2.58,3.14,4.97,7.83,5.07,14.46c1.61-1.69,2.29-2.06,3.26-2.49c1.27-0.57,1.21-0.57,1.97-1.34c0.76-0.76,4.14-0.06,6.68-2.23 s5.34-6.04,5.6-6.23c0.25-0.19,1.53-0.51,1.91-0.76c0.38-0.25,2.54,0.19,4.07,0.83c1.53,0.64,2.99,0.95,4.01,1.34 c1.02,0.38,2.42,0.7,3.75-0.25c1.34-0.95,1.59-2.29,0.51-3.37c-1.08-1.08-2.29-2.16-2.93-2.86s-2.99-1.21-4.45-2.04 c0,0,0,0,0-0.01c-1.66,1.35-3.3,2.6-4.46,3.31c-3.44,2.1-10.31,4.2-10.31,4.2c6.81-2.86,11.07-5.73,14-7.82 c2.93-2.1,6.3-4.77,7.38-5.34c0,0-2.63,2.37-5.49,4.74c0.29,0.11,0.67,0.33,1.24,0.54c1.08,0.38,2.61,0.45,3.94,1.53 s1.72,1.15,2.42,2.42c0.7,1.27,2.04,2.99,3.69,1.97c1.65-1.02,1.72-2.48,1.34-3.82c-0.38-1.34-0.45-2.29-0.64-2.61 c-0.19-0.32-1.21-1.21-1.84-1.65c-0.64-0.45-2.16-1.84-2.16-1.84s2.29,1.21,2.86,1.91c0.57,0.7,1.59,2.23,2.48,2.74 c0.89,0.51,2.48,0.25,3.12-1.02c0.64-1.27,0.19-3.37-0.76-4.39c-0.09-0.1-0.18-0.19-0.27-0.28c-0.04-0.01-0.11-0.05-0.21-0.12 c-0.87-0.57-4.63-1.45-5.67-1.6c-1.11-0.16-2.33,0.61-2.33,0.61s1.26-1.23,2.6-0.83c1.19,0.35,3.57,0.57,5,1.09 c0.03,0.01,0.06,0.01,0.1,0.02C231.07,515.15,232.1,515.26,233.04,515.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M213.57,520.97c-2.93,2.1-7.19,4.96-14,7.82c0,0,6.87-2.1,10.31-4.2c1.16-0.71,2.8-1.96,4.46-3.31 c0.37-0.3,0.74-0.61,1.11-0.91c2.87-2.38,5.49-4.74,5.49-4.74C219.87,516.19,216.5,518.87,213.57,520.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M166.06,537.58c3.02,5.47,2.22,6.73,1.28,7.42c3.64,4.69,3.86,5.59,4.78,9.2 c0.1,0.41,0.19,0.83,0.26,1.26c0.52,1.27,1.23,2.2,3.93,2.33c1.4-0.3,2.87-0.38,4.42-0.34c0.8-0.08,1.64-0.11,2.52-0.09 c3.42-9.28,6.71-15.51,6.71-15.51c0.01-0.39,0.01-0.77,0-1.15c-0.09-6.63-2.49-11.32-5.07-14.46c-2.34-2.85-4.83-4.43-5.86-5.01 c-0.32-0.18-0.5-0.26-0.5-0.26c-4.1,0.37-7.14,1.45-18.1,10.55C161.69,531.42,163.76,533.41,166.06,537.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M158.45,580.19c-0.22,0.1-0.44,0.2-0.66,0.3c0.07,0.05,0.14,0.1,0.21,0.14 C158.14,580.49,158.3,580.34,158.45,580.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M159.47,532.32c-0.15,0.12-0.3,0.25-0.45,0.38c0.07,0.1,0.15,0.19,0.22,0.29 C159.3,532.79,159.37,532.56,159.47,532.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M109.41,559.6c-0.04-0.08-0.09-0.16-0.13-0.24c-0.03-0.01-0.06-0.01-0.09-0.02 C109.27,559.43,109.34,559.51,109.41,559.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M52.89,562.34c17.54,0,28.27-2.36,37.12-3.52c0-0.01,0.01-0.02,0.01-0.04l0.51-0.03l8.88-0.53l0.23-0.01 c-1.18-2.8-1.39-7.97-1.15-13.52c1.87-1.7,3.96-2.8,6.29-2.91c0-0.01,0-0.03,0-0.04c-0.06-1.19-0.03-2.38,0.08-3.56 c0.06-0.59,0.13-1.17,0.23-1.75c0.03-0.2,0.05-0.44,0.1-0.67c0.16-1.34,0.47-2.67,0.93-3.94c0-0.05,0.01-0.09,0.01-0.14 c-0.3,0.74-0.61,1.48-0.91,2.22c0.27-0.78,0.58-1.56,0.92-2.32c0.77-8.98,3.79-19.03,4.12-24.98c0.13-2.37,0.23-4.53,0.31-6.53 c0.35-0.52,0.62-1.23,0.78-2.17c0.62-3.61-0.13-6.31-0.79-11.67c-0.13-2.44-0.34-4.51-0.61-6.43c-0.04-0.26-0.06-0.52-0.07-0.78 c-1.05-6.85-4.08-17.98-12.54-15.2c-9.42,3.1-7.31,15.2-10.86,38.11c-3.85,24.91-28.95,36.17-51.18,23.47 c0,0-0.12-0.62-0.33-1.69c0.06,3.93-0.36,7.4-1.07,10.43c-1.39,4.06-4.12,8.4-6.64,11.25c-0.02,0.03-0.05,0.05-0.07,0.08 c-1.65,1.89-2.46,3.63-2.48,5.23C26.06,553.65,31.85,562.34,52.89,562.34z M94.33,481.66c0.67,7.92,9.1,17.02,9.1,17.02 C95.28,495.71,94.33,481.66,94.33,481.66z M107.33,482.22c0,0,0.86,0.43,0.06,2.16c-0.8,1.73-1.91,2.49-0.23,5.67 c1.68,3.18,0.19,4.97-1.39,3.11c-1.57-1.86-4.56-6.6-3.49-7.85C103.37,484.05,105.67,484.85,107.33,482.22z M98.59,466.66 c3.69-0.98,5.55,1.52,6.51,3.11c0.96,1.58,2.6,8.42,0.22,10.95c-2.38,2.53-4.85-0.25-5.39,1.79c-0.53,2.04-0.86,3.73-0.86,3.73 s-1.59-2.03-1.07-4.23c0.52-2.21,1.36-3.44,3.71-6.3s0.5-6.15-1.98-6.65c-3.48-0.7-6.44,6.03-6.44,6.03 C94.1,472.03,94.91,467.64,98.59,466.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M145.87,552.83c0.03,0.08,0.06,0.17,0.09,0.25c0.04-0.16,0.09-0.32,0.13-0.48 c0.08,0.06,0.13,0.14,0.17,0.23c0.02-0.16,0.07-0.32,0.15-0.47c0.04,0.07,0.1,0.12,0.17,0.16c-0.01-0.15,0.03-0.31,0.11-0.44 c0.08,0.16,0.2,0.3,0.34,0.4c0-0.21,0.03-0.42,0.08-0.62c0.09,0.11,0.19,0.21,0.28,0.32c0-0.19,0.01-0.39,0.01-0.58 c0.09,0.11,0.18,0.23,0.28,0.34c-0.02-0.19-0.04-0.39-0.06-0.58c0.13,0.18,0.28,0.35,0.45,0.49c-0.06-0.32-0.1-0.64-0.13-0.97 c0.34,0.16,0.66,0.43,0.9,0.69c-0.24-0.31-0.43-0.66-0.58-1.03c0.01-0.01,0.02-0.01,0.02-0.02c0.31,0.24,0.62,0.48,0.93,0.71 c-0.24-0.31-0.42-0.67-0.52-1.06c0,0,0.01-0.01,0.01-0.01c0.25,0.15,0.5,0.29,0.76,0.44c-0.16-0.24-0.28-0.5-0.36-0.78 c0.03-0.03,0.06-0.05,0.09-0.08c0.21,0.1,0.43,0.17,0.66,0.2c-0.15-0.13-0.27-0.31-0.34-0.51c0.05-0.05,0.09-0.1,0.14-0.15 c0.17-0.02,0.33-0.05,0.5-0.07c-0.09-0.07-0.17-0.14-0.25-0.23c0.02-0.03,0.04-0.05,0.06-0.08c0.42,0.05,0.55,0.12,1.03-0.04 c-0.42-0.07-0.65-0.16-0.81-0.27c0,0,0,0,0,0c0.48-0.01,0.95-0.12,1.39-0.33c-0.38-0.03-0.75-0.06-1.13-0.08 c0.01-0.02,0.03-0.04,0.04-0.07c0.39-0.08,0.77-0.2,1.14-0.38c-0.3,0.04-0.6,0.02-0.89-0.04c0.07-0.13,0.15-0.27,0.22-0.42 c0.18-0.09,0.36-0.2,0.54-0.32c-0.13,0.01-0.25,0.01-0.38,0c0.04-0.09,0.08-0.17,0.12-0.26c0.27-0.11,0.53-0.25,0.77-0.41 c-0.2,0-0.4,0.01-0.6,0.01c0.02-0.05,0.04-0.1,0.06-0.15c0.13-0.08,0.26-0.17,0.37-0.29c-0.08,0-0.16,0-0.25,0 c0.04-0.1,0.08-0.19,0.12-0.29c0.06-0.04,0.12-0.09,0.18-0.14c-0.03-0.02-0.07-0.03-0.1-0.05c0.01-0.03,0.02-0.05,0.03-0.08 c0.02-0.01,0.05-0.02,0.08-0.03c0.14-0.05,0.28-0.11,0.42-0.16c-0.12,0.01-0.24,0.04-0.35,0.08c0.1-0.02,0.19-0.07,0.24-0.15 c-0.07,0.01-0.13,0.02-0.2,0.02c0.2-0.14,0.37-0.31,0.51-0.5c-0.14,0.07-0.28,0.13-0.43,0.19c0.15-0.11,0.29-0.23,0.42-0.37 c-0.11,0.02-0.22,0.06-0.31,0.13c0.15-0.11,0.29-0.26,0.38-0.42c-0.09,0.02-0.17,0.04-0.25,0.06c0.14-0.12,0.26-0.26,0.37-0.41 c-0.08,0-0.15,0.03-0.21,0.08c0.08-0.09,0.16-0.19,0.24-0.28c-0.04-0.03-0.1-0.02-0.13,0.01c0.06-0.07,0.12-0.15,0.18-0.22 c-0.04-0.04-0.11-0.02-0.13,0.03c0.17-0.3,0.26-0.64,0.26-0.99c0-0.06-0.01-0.14-0.08-0.16c-0.01,0-0.02,0-0.02,0 c0.02-0.1,0.02-0.16,0-0.17c-0.14-0.04-0.87,2.01-1.77,3.79c-0.9,1.78-1.76,3-3.37,4.54c-1.62,1.54-2.17,2.41-2.1,2.46 c0.01,0.01,0.05-0.01,0.11-0.06c0,0.14,0.06,0.29,0.07,0.41C145.8,553.09,145.84,552.96,145.87,552.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M147.53,552.92l-0.66,0.36c4.42-1.38,6.34-5.57,6.34-5.57C151.04,551.04,147.53,552.92,147.53,552.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M137.46,564.09c-0.06-0.01-0.11-0.02-0.17,0.01c0.03-0.11,0.04-0.19,0.02-0.24c0,0-0.64,0.48-1.12,1.38 c-0.25,0.47-0.92,1.46-1.74,2.51c0.17,0.2,0.35,0.4,0.52,0.61c0.01-0.09,0.01-0.19,0.01-0.28c0.05,0.11,0.09,0.22,0.14,0.33 c-0.02-0.2-0.02-0.4,0.02-0.59c0.1,0.12,0.18,0.25,0.25,0.39c-0.01-0.21-0.02-0.42-0.02-0.63c0.06,0.07,0.11,0.15,0.17,0.22 c0-0.14,0-0.28-0.01-0.42c0.08,0.06,0.16,0.13,0.24,0.19c-0.02-0.17-0.04-0.35-0.06-0.52c0.1,0.08,0.19,0.15,0.29,0.23 c-0.03-0.16-0.06-0.32-0.09-0.47c0.1,0.09,0.19,0.18,0.29,0.27c-0.02-0.16-0.04-0.31-0.06-0.47c0.08,0.07,0.17,0.13,0.26,0.17 c-0.03-0.19-0.05-0.38-0.08-0.57c0.1,0.07,0.21,0.12,0.33,0.14c-0.09-0.12-0.17-0.24-0.26-0.36c0.14,0.04,0.28,0.1,0.4,0.18 c-0.06-0.11-0.13-0.22-0.19-0.33c0.08,0.05,0.17,0.1,0.25,0.15c-0.05-0.1-0.11-0.19-0.16-0.29c0.09,0.07,0.2,0.12,0.31,0.16 c-0.06-0.12-0.11-0.24-0.15-0.36c0.07,0.01,0.15,0.02,0.22,0.03c-0.07-0.1-0.16-0.19-0.27-0.25c0.13,0,0.26-0.02,0.38-0.06 c-0.07-0.04-0.14-0.06-0.21-0.08c0.08-0.1,0.21-0.15,0.34-0.13c-0.1-0.06-0.2-0.12-0.3-0.18c0.2-0.02,0.39-0.09,0.55-0.2 c-0.11-0.08-0.24-0.12-0.38-0.1c0.14-0.09,0.29-0.14,0.45-0.14c-0.15-0.04-0.31-0.06-0.46-0.06c0,0,0,0,0-0.01 c0.14-0.04,0.27-0.09,0.4-0.15c-0.1-0.01-0.21-0.02-0.31-0.03c0.17-0.01,0.33-0.01,0.5-0.02 C137.67,564.15,137.57,564.12,137.46,564.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M148.16,566.04c-0.84,0.18-1.62,0.48-2.18,1.33c-0.62,0.94,0.05,0.71,0.69,0.18 c0.47-0.39,1.21-1.06,1.56-1.38C148.28,566.12,148.24,566.02,148.16,566.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M150.6,561.69c-0.75,0.47-1.24,1.69-1.21,2.65c0,0.06,0.08,0.08,0.11,0.02c0.19-0.39,0.65-1.27,1.2-1.85 C151.41,561.77,151.41,561.18,150.6,561.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E99794",
    d: "M159.37,562.59c-0.4,1.08-0.83,1.27-1.89,1.93c-1.06,0.66-1.87,1.11-2.64,1.8 c-0.77,0.69-0.32,1.55-1.44,2.21c-1.12,0.66-1.21,0.94-1.67,2.13c-0.47,1.19-0.5,1.54-1.43,2.09c-0.93,0.56-1.29,0.65-1.49,1.44 c0.65-0.78,0.87-0.76,1.37-1.04c0.5-0.28,0.87-0.27,1.62-0.73c0.75-0.46,2.32-0.1,3.3-0.79c2.28-1.62,3.6-3.29,4.3-4.57 c0.68-1.24,0.42-3.03,0.43-3.79c0.01-0.76,0.7-2.4,0.7-2.4C160.04,561.18,159.77,561.51,159.37,562.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M144.29,568.98c-0.4-0.17-0.7-0.54-0.83-0.97c-0.07-0.19-0.1-0.49-0.2-0.74 c-0.1-0.26-0.23-0.51-0.4-0.72c-0.35-0.43-0.78-0.73-1.22-1c0.31,0.42,0.66,0.81,0.9,1.22c0.12,0.21,0.22,0.42,0.27,0.65 c0.07,0.23,0.09,0.45,0.17,0.75c0.17,0.55,0.6,1.05,1.2,1.19c0.29,0.07,0.59,0.04,0.85-0.06c0.26-0.11,0.47-0.27,0.65-0.46 c-0.24,0.1-0.48,0.19-0.72,0.22C144.72,569.09,144.49,569.06,144.29,568.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M150.25,560.06c0.44-0.01,0.89,0.16,1.17,0.49c0.14,0.17,0.24,0.38,0.28,0.61 c0.04,0.24,0.03,0.49,0.01,0.75c0.13-0.23,0.22-0.48,0.24-0.76c0.02-0.28-0.05-0.58-0.2-0.83c-0.31-0.52-0.93-0.78-1.5-0.77 c-0.31,0.01-0.52,0.06-0.76,0.06c-0.24,0.01-0.47-0.02-0.7-0.06c-0.47-0.1-0.94-0.32-1.44-0.48c0.39,0.34,0.81,0.66,1.32,0.86 c0.26,0.1,0.54,0.15,0.81,0.16C149.76,560.11,150.05,560.06,150.25,560.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M147.84,541.98c1.78-1.42,2.47-2.33,2.47-2.33s-1.68-0.03-5.22,3.26s-4.89,7.57-4,6.32 C142.34,547.47,145.03,544.23,147.84,541.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M129.07,563.4c0.33,0.18,0.64,0.37,0.96,0.59c1.39-1.95,2.88-3.66,3.86-4.66 C134.86,558.32,131.62,559.99,129.07,563.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M110.22,567.04c-0.04-0.07-0.15-0.26-0.33-0.67C109.97,566.6,110.08,566.82,110.22,567.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M159.4,533.17c0.4,0.53,0.82,1.08,1.23,1.63c0-0.49,0.13-0.98,0.7-1.08c0.83-0.16,1.73,1.07,2.4,1.9 c0,0-1.69-1.68-2.2-1.03c-0.26,0.33-0.2,1.07,0.2,1.67c0.05,0.07,0.1,0.14,0.15,0.2c0.12,0.14,0.27,0.27,0.44,0.38 c0.91,0.58,1.28,0.85,1.75,1.45c0.47,0.6,0.54,1.41,0.54,1.41s-0.35-0.47-0.8-1.02c-0.45-0.55-0.41,0.59-1.27,0.12 c-0.66-0.36-1.34-1.78-1.66-2.7c-0.4-0.45-0.76-0.95-1.13-1.49c0.14,0.48,0.27,0.96,0.41,1.44c-0.9-1.09-1.8-2.19-2.7-3.28 c0.35,1.01,0.69,2.02,1.04,3.04c-1.22-1.5-2.48-2.97-3.79-4.39c0.2,0.79,0.56,1.54,1.06,2.18c-1.01-0.98-2.02-1.96-3.03-2.94 c0.28,0.79,0.72,1.52,1.3,2.12c-1.07-1.05-2.14-2.11-3.21-3.16c0.68,0.85,1.23,1.82,1.62,2.84c-1.77-2.46-4.13-4.49-6.83-5.86 l0.44-0.99c-1.2,0.02-2.48,0.23-4.46-0.04c-0.79-0.1-2.31-0.54-3.6-1.08c1.52,0.96,3.33,2.14,3.33,2.14s-2.44-0.65-4.71-1.28 c-1.43-0.4-1.78-0.39-3.01-0.89c0.67,0.39,2.02,1.69,2.15,2.06c-3.43-1.58-6.75-1.06-9.36-1.59c0.32,0.91,3.58,0.86,4.48,1.2 c-1.57,0.8-5.99,1.74-7.66,1.18c0.47,0.23,0.06,3.41-0.07,3.92c-0.33-1.78-1.42-2.32-2.31-2.84c0.39,0.25-0.22,4.09-0.1,4.53 c-0.52-1.55-0.96-3.43-1.7-3.96c0.2,0.81-0.91,4.09-0.72,4.9c-0.8,0.24-0.44-2.85-0.56-3.68c-0.27,0.77,0.11-0.08-0.16,0.7 c-0.02,0.95-0.69,3.52-0.7,4.46c-0.31-0.35-0.56-0.76-0.71-1.2c0.22,0.85,0.34,1.71,0.37,2.59c-0.31-0.31-0.58-0.67-0.78-1.05 c0.26,0.91,0.4,1.86,0.4,2.81c-0.79-1.37-1.5-2.78-2.12-4.24c0.71,2.58,1.42,5.17,2.13,7.75c-1.04-1.94-2.07-3.88-3.11-5.81 c1.09,1.96,1.71,4.19,1.77,6.44c-0.49-0.73-0.98-1.46-1.47-2.18c0.2,0.93,0.4,1.86,0.6,2.8c-0.63-0.79-1.17-1.65-1.6-2.57 c0.5,1.38,0.65,3.44,2.18,7.35c-1.3-2.05-3.3-7.74-4.14-10.02c0.98,3.72,2.07,7.41,3.26,11.07c-1.81-3.17-1.93-2.96-3.35-6.32 c1.09,4.95,1.16,6.31,3.19,10.96c-1.92-3.32-3.47-6.85-4.62-10.51c0.16,4.01,1.01,7.98,2.5,11.7c-0.38-0.64-0.76-1.28-1.13-1.91 c0.33,0.91,0.66,1.82,0.99,2.73c-0.8-1.14-1.5-2.35-2.1-3.6c0.87,2.45,1.83,4.87,2.88,7.25c-1.47-2.23-2.78-4.58-3.9-7 c1.14,3.28,2.3,6.6,4.09,9.56c-0.03,0.02-0.06,0.04-0.09,0.06c-1.29-1.8-2.45-3.69-3.47-5.65c0,0.01,0,0.01,0.01,0.02 c0.99,1.96,2.03,3.96,3.23,5.82c-0.16,0.13-0.33,0.25-0.48,0.37c-0.08,0.06-0.17,0.13-0.25,0.19c-1.31,1-1.69,2.43-1.26,3.65 c0.03,0.03,0.48,0.51,1.16,0.11c0.69-0.42,2.23-1.4,2.92-1.81c0.69-0.42,2.39-0.45,3.26-0.5l3.08,2.02 c-0.6-0.32-2.83-1.03-3.83-1.26c-0.76-0.18-1.8-0.36-4,0.89c-1.42,0.81-2.24,1.28-2.24,1.28s-2.23,1.83-1.35,3.58 c0.79,0.91,1.74,0.2,2.87-0.32c1.25-0.57,2-0.37,2.84-0.3l3.4,0.57c-0.49,0-1.07,0.07-2.8-0.08c-1.73-0.15-2.12-0.26-2.82,0.04 s-1.68,0.74-2.34,1.13c0,0-1.58,1.18-0.65,2.84c0.13,0.24,0.26,0.43,0.38,0.58c-0.02-0.05-0.03-0.08-0.03-0.08 c0.55,0.37,0.93,0.31,1.29,0.12c0.36-0.19-0.71-0.68-1.04-1.68s0.66,1.38,1.87,1.32l4.34,0.69c0.84,0.02,0.94,0.6,0.45,0.9 c-0.05,0.08-0.25,0.13-0.6,0.13c-0.93,0.01-2.83-0.26-4.08,0.08c-1.26,0.34-1.78,1.46-1.86,2.41c-0.08,0.96,1.09,1.41,1.88,2.08 c0.78,0.67,0.95,0.81,2.47,1.05c1.51,0.24,2.64,0.19,3.34,0.42s1.74,1.48,2.94,1.75c1.2,0.27,2.32,1.96,4.08,2.59 c1.76,0.63,3.32,1.04,5.23,0.76c0,0,0.91,1.08,2.78,3.47c0.46,0.59,0.94,1.14,1.39,1.63c2.17-1.4,9.47-11.43,10.54-15.33 c0,0,1.85-1.71,4.68-0.37c1.56,0.74,2.48,1.57,4.11,1.27c0.62-0.11,2.19,0.71,4.26,2.15c0.22-0.1,0.44-0.2,0.66-0.3 c1.4-1.39,2.77-3.22,4.05-6.31c4.65-11.17,8.83-15.02,13.81-16.09c-2.7-0.13-3.41-1.05-3.93-2.33 c-0.07-0.43-0.15-0.85-0.26-1.26c-0.92-3.61-1.15-4.51-4.78-9.2c0.94-0.69,1.74-1.95-1.28-7.42c-2.3-4.17-4.38-6.16-5.63-6.07 c-0.42,0.03-0.75,0.3-0.96,0.8c0,0,0,0,0,0c-0.1,0.25-0.18,0.47-0.22,0.67C159.3,533.05,159.35,533.11,159.4,533.17z  M133.89,559.32c-0.98,1.01-2.47,2.72-3.86,4.66c-0.31-0.21-0.63-0.41-0.96-0.59C131.62,559.99,134.86,558.32,133.89,559.32z  M137.6,564.19c-0.13,0.06-0.27,0.11-0.4,0.15c0,0,0,0,0,0.01c0.16,0,0.31,0.02,0.46,0.06c-0.16,0.01-0.32,0.05-0.45,0.14 c0.13-0.02,0.27,0.02,0.38,0.1c-0.16,0.12-0.36,0.19-0.55,0.2c0.1,0.06,0.2,0.12,0.3,0.18c-0.12-0.02-0.26,0.03-0.34,0.13 c0.07,0.01,0.15,0.04,0.21,0.08c-0.12,0.04-0.25,0.06-0.38,0.06c0.11,0.06,0.2,0.15,0.27,0.25c-0.07-0.01-0.15-0.02-0.22-0.03 c0.04,0.12,0.09,0.24,0.15,0.36c-0.11-0.04-0.22-0.09-0.31-0.16c0.05,0.1,0.11,0.19,0.16,0.29c-0.08-0.05-0.17-0.1-0.25-0.15 c0.06,0.11,0.13,0.22,0.19,0.33c-0.12-0.08-0.26-0.14-0.4-0.18c0.09,0.12,0.17,0.24,0.26,0.36c-0.12-0.02-0.23-0.07-0.33-0.14 c0.03,0.19,0.05,0.38,0.08,0.57c-0.1-0.04-0.19-0.1-0.26-0.17c0.02,0.16,0.04,0.31,0.06,0.47c-0.1-0.09-0.19-0.18-0.29-0.27 c0.03,0.16,0.06,0.32,0.09,0.47c-0.1-0.08-0.19-0.15-0.29-0.23c0.02,0.17,0.04,0.35,0.06,0.52c-0.08-0.06-0.16-0.13-0.24-0.19 c0,0.14,0,0.28,0.01,0.42c-0.06-0.07-0.11-0.15-0.17-0.22c0.01,0.21,0.02,0.42,0.02,0.63c-0.07-0.14-0.15-0.27-0.25-0.39 c-0.03,0.19-0.04,0.39-0.02,0.59c-0.05-0.11-0.09-0.22-0.14-0.33c0,0.09,0,0.19-0.01,0.28c-0.17-0.21-0.35-0.41-0.52-0.61 c0.82-1.05,1.49-2.04,1.74-2.51c0.47-0.9,1.12-1.38,1.12-1.38c0.02,0.05,0.01,0.13-0.02,0.24c0.05-0.02,0.11-0.02,0.17-0.01 c0.11,0.03,0.22,0.06,0.33,0.06c-0.17,0.01-0.33,0.01-0.5,0.02C137.4,564.17,137.5,564.18,137.6,564.19z M145.09,542.91 c3.54-3.29,5.22-3.26,5.22-3.26s-0.7,0.91-2.47,2.33c-2.82,2.25-5.5,5.49-6.75,7.25C140.2,550.48,141.55,546.2,145.09,542.91z  M145.02,569.3c-0.26,0.1-0.56,0.13-0.85,0.06c-0.59-0.14-1.02-0.65-1.2-1.19c-0.08-0.3-0.1-0.52-0.17-0.75 c-0.06-0.23-0.16-0.44-0.27-0.65c-0.24-0.42-0.59-0.8-0.9-1.22c0.45,0.27,0.88,0.57,1.22,1c0.18,0.21,0.31,0.47,0.4,0.72 c0.1,0.25,0.14,0.55,0.2,0.74c0.13,0.42,0.43,0.8,0.83,0.97c0.2,0.08,0.43,0.11,0.67,0.08c0.24-0.03,0.47-0.12,0.72-0.22 C145.5,569.03,145.28,569.2,145.02,569.3z M145.58,552.85c-0.07-0.04,0.48-0.91,2.1-2.46c1.62-1.54,2.47-2.76,3.37-4.54 c0.9-1.78,1.63-3.83,1.77-3.79c0.02,0.01,0.01,0.06,0,0.17c0.01,0,0.01,0,0.02,0c0.06,0.01,0.08,0.09,0.08,0.16 c0,0.34-0.1,0.69-0.26,0.99c0.02-0.05,0.1-0.06,0.13-0.03c-0.06,0.07-0.12,0.15-0.18,0.22c0.03-0.03,0.09-0.04,0.13-0.01 c-0.08,0.09-0.16,0.19-0.24,0.28c0.06-0.05,0.13-0.07,0.21-0.08c-0.11,0.15-0.24,0.28-0.37,0.41c0.08-0.02,0.17-0.04,0.25-0.06 c-0.1,0.16-0.23,0.31-0.38,0.42c0.09-0.06,0.2-0.11,0.31-0.13c-0.13,0.14-0.27,0.26-0.42,0.37c0.14-0.07,0.28-0.13,0.43-0.19 c-0.14,0.19-0.31,0.37-0.51,0.5c0.07-0.01,0.13-0.02,0.2-0.02c-0.06,0.08-0.15,0.14-0.24,0.15c0.11-0.04,0.23-0.07,0.35-0.08 c-0.14,0.05-0.28,0.11-0.42,0.16c-0.03,0.01-0.05,0.02-0.08,0.03c-0.01,0.03-0.02,0.05-0.03,0.08c0.03,0.02,0.07,0.03,0.1,0.05 c-0.06,0.05-0.12,0.1-0.18,0.14c-0.04,0.1-0.08,0.19-0.12,0.29c0.08,0,0.16,0,0.25,0c-0.11,0.12-0.23,0.21-0.37,0.29 c-0.02,0.05-0.04,0.1-0.06,0.15c0.2,0,0.4-0.01,0.6-0.01c-0.25,0.16-0.51,0.3-0.77,0.41c-0.04,0.09-0.08,0.18-0.12,0.26 c0.12,0.01,0.25,0.01,0.38,0c-0.17,0.12-0.35,0.23-0.54,0.32c-0.07,0.15-0.15,0.29-0.22,0.42c0.29,0.06,0.59,0.08,0.89,0.04 c-0.36,0.17-0.75,0.3-1.14,0.38c-0.01,0.02-0.03,0.04-0.04,0.07c0.38,0.03,0.75,0.06,1.13,0.08c-0.44,0.2-0.92,0.31-1.39,0.33 c0,0,0,0,0,0c0.17,0.11,0.39,0.19,0.81,0.27c-0.48,0.16-0.61,0.08-1.03,0.04c-0.02,0.03-0.04,0.05-0.06,0.08 c0.08,0.08,0.16,0.16,0.25,0.23c-0.17,0.02-0.33,0.05-0.5,0.07c-0.05,0.05-0.09,0.1-0.14,0.15c0.08,0.2,0.19,0.37,0.34,0.51 c-0.23-0.03-0.45-0.1-0.66-0.2c-0.03,0.03-0.06,0.05-0.09,0.08c0.09,0.28,0.21,0.54,0.36,0.78c-0.25-0.15-0.5-0.29-0.76-0.44 c0,0-0.01,0.01-0.01,0.01c0.1,0.39,0.28,0.76,0.52,1.06c-0.31-0.24-0.62-0.48-0.93-0.71c-0.01,0.01-0.02,0.01-0.02,0.02 c0.15,0.37,0.34,0.72,0.58,1.03c-0.24-0.26-0.57-0.54-0.9-0.69c0.03,0.32,0.07,0.65,0.13,0.97c-0.17-0.15-0.32-0.31-0.45-0.49 c0.02,0.19,0.04,0.39,0.06,0.58c-0.09-0.11-0.18-0.23-0.28-0.34c0,0.19-0.01,0.39-0.01,0.58c-0.09-0.11-0.19-0.21-0.28-0.32 c-0.06,0.2-0.08,0.41-0.08,0.62c-0.15-0.1-0.27-0.24-0.34-0.4c-0.08,0.13-0.12,0.29-0.11,0.44c-0.07-0.04-0.13-0.09-0.17-0.16 c-0.08,0.14-0.13,0.3-0.15,0.47c-0.04-0.09-0.1-0.17-0.17-0.23c-0.04,0.16-0.09,0.32-0.13,0.48c-0.03-0.08-0.06-0.17-0.09-0.25 c-0.04,0.13-0.07,0.26-0.11,0.38c-0.01-0.12-0.07-0.28-0.07-0.41C145.63,552.84,145.59,552.86,145.58,552.85z M153.21,547.71 c0,0-1.93,4.19-6.34,5.57l0.66-0.36C147.53,552.92,151.04,551.04,153.21,547.71z M148.23,566.17c-0.35,0.32-1.09,0.99-1.56,1.38 c-0.64,0.53-1.3,0.76-0.69-0.18c0.56-0.85,1.34-1.15,2.18-1.33C148.24,566.02,148.28,566.12,148.23,566.17z M147.34,559.07 c0.5,0.16,0.97,0.38,1.44,0.48c0.24,0.05,0.47,0.08,0.7,0.06c0.24,0,0.45-0.05,0.76-0.06c0.57,0,1.19,0.25,1.5,0.77 c0.16,0.25,0.22,0.55,0.2,0.83c-0.02,0.28-0.11,0.54-0.24,0.76c0.02-0.26,0.04-0.51-0.01-0.75c-0.04-0.24-0.14-0.44-0.28-0.61 c-0.28-0.33-0.73-0.5-1.17-0.49c-0.2,0-0.5,0.05-0.77,0.03c-0.28-0.01-0.56-0.06-0.81-0.16 C148.15,559.74,147.74,559.41,147.34,559.07z M150.69,562.52c-0.55,0.57-1.01,1.46-1.2,1.85c-0.03,0.05-0.11,0.04-0.11-0.02 c-0.03-0.96,0.46-2.18,1.21-2.65C151.41,561.18,151.41,561.77,150.69,562.52z M159.4,567.07c-0.7,1.28-2.02,2.96-4.3,4.57 c-0.98,0.7-2.55,0.34-3.3,0.79c-0.75,0.46-1.12,0.44-1.62,0.73c-0.5,0.28-0.72,0.26-1.37,1.04c0.19-0.8,0.55-0.89,1.49-1.44 c0.93-0.56,0.97-0.91,1.43-2.09c0.47-1.19,0.55-1.47,1.67-2.13c1.12-0.66,0.67-1.52,1.44-2.21c0.77-0.69,1.58-1.14,2.64-1.8 c1.06-0.66,1.49-0.86,1.89-1.93c0.4-1.08,0.66-1.4,1.16-1.71c0,0-0.68,1.64-0.7,2.4C159.82,564.04,160.08,565.82,159.4,567.07z  M163.82,541.85c-0.25-1.17-0.58-1.26-1.02-1.69c-0.44-0.43-0.36-0.66-0.36-0.66c0.75,0.59,1.03,0.07,1.44,0.31 c0.41,0.25,0.69,2.05,0.73,2.81C164.64,543.38,164.06,543.03,163.82,541.85z M165.98,544.01c0,0-0.06-3.79-1.3-6.27 C164.67,537.73,166.92,542.11,165.98,544.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M132.6,516.47c-1.61,0.07-3.21,0.41-4.71,1c0.35-0.68,0.71-1.35,1.06-2.03 c-1.03,0.81-2.07,1.62-3.1,2.43c0.33-0.62,0.66-1.24,0.99-1.86c-1.11,0.68-2.24,1.33-3.37,1.98c0.22-0.34,0.37-0.71,0.34-1.11 c-0.36,0.52-0.84,0.96-1.39,1.28c0.39-0.57,0.64-1.22,0.75-1.9c-0.46,1.22-1.4,2.26-2.57,2.83c0.55-0.8,1.1-1.6,1.66-2.4 c-1.2,1.3-2.4,2.6-3.7,3.81c0.54-0.77,0.9-1.66,1.07-2.58c-0.29,0.84-0.73,1.63-1.27,2.34c-0.01-0.05-0.01-0.1-0.02-0.15 c-0.04,0.04-0.07,0.07-0.11,0.11c0.01-0.09,0.03-0.18,0.04-0.27c-0.09,0.16-0.17,0.32-0.25,0.48c-0.08,0.08-0.15,0.15-0.23,0.23 c0.11-0.4,0.21-0.8,0.32-1.21c-0.29,0.39-0.63,0.75-1.01,1.05c-0.01-0.04-0.02-0.08-0.03-0.13c0.04-0.19,0.07-0.38,0.11-0.57 c-0.04,0.17-0.08,0.34-0.12,0.5c-0.05-0.22-0.05-0.45-0.01-0.68c-0.24,0.44-0.51,0.87-0.79,1.29c0.09-0.74,0.12-1.48,0.09-2.22 c-0.15,1.01-0.37,2.01-0.65,2.99c-0.03,0.03-0.05,0.07-0.08,0.11c0.14-0.62,0.18-1.25,0.12-1.88c-0.25,0.48-0.5,0.96-0.74,1.44 c-0.05-0.26-0.1-0.52-0.15-0.77c0.06-0.39,0.12-0.79,0.18-1.18c-0.11,0.2-0.21,0.4-0.31,0.6c-0.11-0.51-0.23-1.01-0.35-1.51 c-0.02,0.94-0.09,1.87-0.2,2.8c-0.11,0.31-0.21,0.62-0.3,0.93c-0.01-0.06-0.01-0.12-0.02-0.17c0.08-0.45,0.17-0.9,0.25-1.34 c-0.1,0.24-0.21,0.48-0.31,0.72c-0.05-0.49-0.1-0.99-0.15-1.48c0.04-0.24,0.09-0.47,0.13-0.71c-0.04,0.2-0.09,0.4-0.14,0.59 c-0.09-0.88-0.18-1.76-0.27-2.65c-0.01,0.27-0.03,0.54-0.04,0.82c-0.05-0.36-0.1-0.72-0.15-1.07c-0.09,0.81-0.21,1.61-0.36,2.41 c0.02-0.46,0.02-0.91,0.01-1.37c-0.14,0.96-0.35,1.92-0.59,2.86c-0.02-1.83-0.05-3.66-0.07-5.49c-0.29,2.28-0.67,4.54-1.15,6.79 c-0.04-0.17-0.09-0.34-0.14-0.51c0.02,0.31,0.04,0.61,0.05,0.92c-0.06,0.29-0.12,0.59-0.19,0.88c-0.08-0.31-0.17-0.62-0.25-0.93 c-0.01,0.72-0.26,1.44-0.69,2.01c-0.15-0.63-0.18-1.29-0.07-1.93c-0.33,0.8-0.52,1.65-0.56,2.51c0.15-1.66,0.06-3.33-0.28-4.96 c-0.05,3.11-0.76,5.94-1.48,9c-0.02,0.04-0.04,0.07-0.06,0.11l0.02-0.09c-0.19,0.35-0.37,0.7-0.54,1.06 c-0.09,0.18-0.17,0.35-0.26,0.53c-0.02,0.05-0.03,0.11-0.05,0.16c-0.13,0.31-0.25,0.62-0.37,0.94c-0.45,1.27-0.76,2.6-0.93,3.94 c-0.05,0.23-0.06,0.47-0.1,0.67c-0.1,0.58-0.17,1.16-0.23,1.75c-0.11,1.18-0.14,2.37-0.08,3.56c0,0.01,0,0.03,0,0.04 c0.03,0.66,0.09,1.31,0.17,1.97c0.04,0.33,0.09,0.67,0.15,1c0.05,0.3,0.19,0.65,0.18,0.96c0.01-0.94,0.02-1.87,0.03-2.81 c0.33,2.45,0.36,4.93,0.09,7.38c0.29-0.95,0.48-1.94,0.57-2.93c-0.25,2.73-0.1,5.5,0.45,8.18c-0.07-1.16-0.14-2.32-0.21-3.49 c0.24,2.32,1.16,4.57,2.6,6.41c0.15,0.31,0.31,0.61,0.47,0.91c0.04,0.08,0.08,0.16,0.13,0.24c-0.07-0.09-0.15-0.17-0.22-0.26 c-0.11-0.13-0.22-0.26-0.33-0.39c0.09,0.12,0.18,0.25,0.27,0.38c0.75,1.06,1.51,2.13,2.26,3.19c0.16-0.12,0.32-0.24,0.48-0.37 c-1.2-1.86-2.24-3.85-3.23-5.82c0-0.01,0-0.01-0.01-0.02c1.03,1.96,2.19,3.85,3.47,5.65c0.03-0.02,0.06-0.04,0.09-0.06 c-1.79-2.96-2.95-6.28-4.09-9.56c1.12,2.43,2.42,4.77,3.9,7c-1.05-2.38-2.01-4.8-2.88-7.25c0.6,1.26,1.31,2.46,2.1,3.6 c-0.33-0.91-0.66-1.82-0.99-2.73c0.38,0.64,0.76,1.28,1.13,1.91c-1.5-3.72-2.35-7.7-2.5-11.7c1.16,3.66,2.71,7.19,4.62,10.51 c-2.03-4.65-2.1-6-3.19-10.96c1.42,3.36,1.54,3.15,3.35,6.32c-1.19-3.66-2.28-7.35-3.26-11.07c0.85,2.28,2.85,7.96,4.14,10.02 c-1.54-3.91-1.68-5.96-2.18-7.35c0.43,0.91,0.97,1.78,1.6,2.57c-0.2-0.93-0.4-1.86-0.6-2.8c0.49,0.73,0.98,1.46,1.47,2.18 c-0.07-2.25-0.68-4.47-1.77-6.44c1.04,1.94,2.07,3.88,3.11,5.81c-0.71-2.58-1.42-5.17-2.13-7.75c0.62,1.45,1.33,2.87,2.12,4.24 c0-0.95-0.13-1.9-0.4-2.81c0.21,0.39,0.47,0.74,0.78,1.05c-0.02-0.87-0.15-1.74-0.37-2.59c0.16,0.44,0.4,0.85,0.71,1.2 c0.02-0.95,0.69-3.52,0.7-4.46c0.27-0.77-0.11,0.08,0.16-0.7c0.11,0.83-0.25,3.92,0.56,3.68c-0.2-0.81,0.91-4.09,0.72-4.9 c0.74,0.53,1.18,2.41,1.7,3.96c-0.12-0.44,0.49-4.28,0.1-4.53c0.89,0.52,1.98,1.06,2.31,2.84c0.13-0.5,0.54-3.69,0.07-3.92 c1.67,0.57,6.09-0.37,7.66-1.18c-0.9-0.35-4.16-0.3-4.48-1.2c2.61,0.52,5.93,0.01,9.36,1.59c-0.13-0.37-1.48-1.67-2.15-2.06 c1.23,0.5,1.59,0.49,3.01,0.89c2.27,0.63,4.71,1.28,4.71,1.28s-1.81-1.18-3.33-2.14c1.29,0.54,2.81,0.98,3.6,1.08 c1.98,0.26,3.26,0.06,4.46,0.04l-0.44,0.99c2.7,1.37,5.07,3.4,6.83,5.86c-0.39-1.02-0.94-1.98-1.62-2.84 c1.07,1.05,2.14,2.11,3.21,3.16c-0.58-0.6-1.02-1.33-1.3-2.12c1.01,0.98,2.02,1.96,3.03,2.94c-0.49-0.65-0.86-1.39-1.06-2.18 c1.31,1.42,2.58,2.89,3.79,4.39c-0.35-1.01-0.69-2.02-1.04-3.04c0.9,1.09,1.8,2.19,2.7,3.28c-0.14-0.48-0.27-0.96-0.41-1.44 c0.37,0.54,0.73,1.03,1.13,1.49c0.32,0.91,1,2.33,1.66,2.7c0.86,0.47,0.83-0.67,1.27-0.12c0.45,0.55,0.8,1.02,0.8,1.02 s-0.07-0.81-0.54-1.41c-0.47-0.6-0.84-0.87-1.75-1.45c-0.17-0.11-0.31-0.24-0.44-0.38c-0.05-0.07-0.1-0.14-0.15-0.2 c-0.4-0.6-0.46-1.34-0.2-1.67c0.5-0.64,2.2,1.03,2.2,1.03c-0.67-0.83-1.57-2.06-2.4-1.9c-0.56,0.11-0.7,0.59-0.7,1.08 c-0.41-0.55-0.83-1.09-1.23-1.63c-0.05-0.06-0.1-0.13-0.15-0.19c-0.07-0.1-0.15-0.2-0.22-0.29c-1.16-1.5-2.27-2.77-3.72-4.08 c-0.83-0.75-1.73-1.42-2.67-2.02c-2.2-2.9-4.66-5.65-7.95-7.11c0.46,0.35,0.93,0.71,1.39,1.06c-1.91-1.06-2.1-1.24-2.82-1.47 c0.45,0.14-2.47-1.19-2.14-0.84c1.75,1.26-1.19-0.18-3.51,0.31c0.6-0.15,1.91-0.8,2.39-0.88c-1.54,0.11-3.08,0.23-4.62,0.34 c0.26-0.4,0.6-0.76,0.98-1.06c-0.72,0.08-1.44,0.15-2.16,0.23c-0.81,0.09-1.63,0.17-2.44,0.26 C132.03,517.12,132.31,516.79,132.6,516.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M106.57,530.6c-0.04,0.09-0.08,0.19-0.11,0.28c0.03-0.05,0.05-0.11,0.08-0.16 C106.54,530.68,106.56,530.64,106.57,530.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M106.14,531.57c-0.34,0.76-0.64,1.53-0.92,2.32c0.3-0.74,0.61-1.48,0.91-2.22 c0.11-0.27,0.22-0.53,0.33-0.8C106.35,531.11,106.24,531.34,106.14,531.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M163.87,539.82c-0.41-0.25-0.68,0.28-1.44-0.31c0,0-0.08,0.23,0.36,0.66c0.44,0.43,0.77,0.52,1.02,1.69 c0.25,1.17,0.82,1.53,0.78,0.77C164.56,541.87,164.28,540.07,163.87,539.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M164.67,537.73c1.25,2.48,1.3,6.27,1.3,6.27C166.92,542.11,164.67,537.73,164.67,537.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M180.73,557.45c-1.56-0.04-3.02,0.04-4.42,0.34c-4.98,1.07-9.16,4.91-13.81,16.09 c-1.29,3.1-2.66,4.92-4.05,6.31c-0.15,0.15-0.3,0.3-0.46,0.44c-0.07-0.05-0.14-0.1-0.21-0.14c-2.07-1.43-3.64-2.26-4.26-2.15 c-1.63,0.3-2.54-0.53-4.11-1.27c-2.83-1.34-4.68,0.37-4.68,0.37c-1.08,3.9-8.38,13.93-10.54,15.33 c-0.07,0.05-0.14,0.09-0.21,0.12c-0.25,2.75,3.23,4.89,2.89,6.6c-0.34,1.71,2.67,4.21,6.46,10.08 c1.69,2.62,6.39,7.64,11.6,12.29c-0.11-0.66-0.04-0.83,0.25-0.42c0.45,0.65,0.9,1.25,1.36,1.83c4.2,3.61,8.56,6.8,11.85,8.19 c3.8,0.97,6.47,0.32,6.47,0.32s-0.76,2.17,1.93,6.74c9.4,15.98,20.95,41.88,26.38,54.4l0.51-0.04 c7.78-17.53,19.33-18.82,22.36-24.93c3.03-6.11,6.44-17.17,10.54-19.9c0.26-0.17,0.52-0.32,0.78-0.46 c-0.01-0.15-0.01-0.3-0.02-0.44c-0.2-1.44-0.48-3.79-0.36-5.04c0.17-1.87,1.38-2.94,2.2-4.06c0.83-1.12,0.86-2.8,1.02-4.94 c0.16-2.14,0.84-3.02,1.42-3.96c0.01-0.02,0.02-0.03,0.03-0.05c-2.3-5.56-5.14-11-7.69-16.44 c-5.16-11.01-14.44-22.03-19.93-29.73c-4.1-5.75-5.8-10.38-9.47-14.7c-6.48-7.63-14.8-10.71-21.31-10.87 C182.37,557.34,181.53,557.37,180.73,557.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M110.04,571.68c-0.14-0.03-0.27-0.07-0.38-0.12C109.89,571.69,110.04,571.68,110.04,571.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M116.2,575.49l-4.34-0.69c-1.21,0.06-2.2-2.31-1.87-1.32s1.39,1.49,1.04,1.68 c-0.36,0.19-0.73,0.25-1.29-0.12c0,0,0.01,0.03,0.03,0.08c0.07,0.19,0.32,0.65,0.97,0.61c0.5-0.03,0.66-0.3,1.45-0.14 c0.73,0.16,2.45,0.29,3.45,0.41c0.08,0.01,0.15,0.02,0.22,0.03c0.94,0.13,0.68,0.42,0.68,0.42c0.04-0.02,0.07-0.04,0.11-0.06 C117.14,576.09,117.04,575.51,116.2,575.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M115.2,570.51c1.73,0.15,2.31,0.08,2.8,0.08l-3.4-0.57c-0.84-0.07-1.6-0.27-2.84,0.3 c-1.13,0.52-2.08,1.22-2.87,0.32c0,0,0.18,0.62,0.77,0.91c0.11,0.05,0.24,0.1,0.38,0.12c0.65-0.39,1.64-0.84,2.34-1.13 S113.47,570.36,115.2,570.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M116.48,564.9c1,0.24,3.23,0.94,3.83,1.26l-3.08-2.02c-0.87,0.06-2.57,0.09-3.26,0.5 c-0.69,0.42-2.23,1.4-2.92,1.81c-0.67,0.4-1.13-0.08-1.16-0.11c0,0,0,0.01,0.01,0.01c0.18,0.41,0.29,0.6,0.33,0.67 c0.01,0.02,0.02,0.03,0.02,0.03s0.82-0.47,2.24-1.28C114.68,564.54,115.71,564.72,116.48,564.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M261.47,664.24c0.08-0.24,0.16-0.47,0.25-0.68c0.36-0.89,0.6-1.66,0.74-2.33 c-0.25,0.84-0.64,1.79-1.02,2.9C261.45,664.16,261.46,664.2,261.47,664.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M260.24,646.9c-0.23-0.38-0.42-0.75-0.5-1.12c0,0.04,0,0.08,0,0.12 C259.82,646.26,260.02,646.6,260.24,646.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M261.89,657.14c0.14,0.28,0.3,0.6,0.47,0.97C262.23,657.74,262.06,657.42,261.89,657.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M248.22,627.48c0,0-1.89-0.75-3.8,0c-1.91,0.76-2.19,1.6-1.97,2.57c0.15,0.64,0.41,6.19,2.55,12.64 c0.6,1.81,1.97,3.84,3.09,5.75c6.23,1.34,10.6,7.34,12.9,14.25c0.34-2.54-0.19-5.14,0.16-6.91c0,0,0.01,0.01,0.02,0.03 c-0.02-0.1-0.02-0.21-0.01-0.32c0.31-2.01,1.19-3.94,0.58-5.8c-0.19-0.58-0.45-1.08-0.72-1.54c0,0.05,0,0.1-0.01,0.14 c-0.19,0.59-1.06,3.55-1.17,1.57c-0.07-1.15-0.09-2.97-0.1-3.97c-0.03-0.11-0.04-0.23-0.04-0.35c-0.12-1.19,0.72-2.41-0.71-5.11 c-0.45-0.84-1.32-1.34-1.96-1.97c0.53,0.72,1.15,1.05,1.15,1.05c-0.37,1.08-1.71,3.76-1.93,1.77c-0.22-1.99-0.11-3.41,0.06-4.78 c0.31-2.01-1.09-4.58-3.57-5.83c-0.76-0.38-1.79-0.77-2.85-1.11c-0.38-4.29-3-6.03-5.46-4.84c-0.49,0.24-0.85,0.48-1.12,0.73 c-0.46,0.69-0.14,0.78-0.42,1.95C242.62,628.62,243.77,625.19,248.22,627.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M237.37,647.58c0.01-0.01,0.03-0.01,0.04-0.02c-0.02-0.13-0.04-0.27-0.06-0.42 C237.35,647.29,237.36,647.44,237.37,647.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M240.21,633.11c-0.16,2.14-0.2,3.82-1.02,4.94c-0.83,1.12-2.03,2.19-2.2,4.06 c-0.12,1.25,0.16,3.6,0.36,5.04c0.02,0.15,0.04,0.29,0.06,0.42c3.83-1.93,7.66,0.27,10.5,0.84c0.06,0.01,0.12,0.03,0.19,0.04 c-1.13-1.91-2.49-3.95-3.09-5.75c-2.14-6.45-2.4-12-2.55-12.64c-0.22-0.97,0.06-1.82,1.97-2.57c1.91-0.76,3.8,0,3.8,0 c-4.45-2.29-5.6,1.14-5.31-0.07c0.28-1.17-0.05-1.26,0.42-1.95c0.02-0.02,0.03-0.05,0.05-0.07c0,0-0.57,0.36-0.79,1.14 c-0.22,0.77-0.36,1.65-0.92,2.58c-0.01,0.02-0.02,0.03-0.03,0.05C241.05,630.09,240.37,630.96,240.21,633.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M261.47,664.24c-0.01-0.04-0.02-0.08-0.03-0.11c-0.01,0.03-0.02,0.05-0.03,0.07 c0-0.17-0.42-1.47-0.42-1.47c0-0.01,0-0.02,0-0.04c-2.3-6.91-6.67-12.91-12.9-14.25c-0.06-0.01-0.12-0.03-0.19-0.04 c-2.84-0.56-6.67-2.77-10.5-0.84c-0.01,0.01-0.03,0.01-0.04,0.02c-0.26,0.13-0.52,0.28-0.78,0.46 c-4.09,2.73-7.5,13.78-10.54,19.9c-3.03,6.11-14.58,7.4-22.36,24.93l-0.51,0.04c-5.43-12.52-16.98-38.42-26.38-54.4 c-2.69-4.57-1.93-6.74-1.93-6.74s-2.67,0.65-6.47-0.32c-3.29-1.39-7.65-4.58-11.85-8.19c-0.46-0.57-0.91-1.18-1.36-1.83 c-0.28-0.41-0.35-0.24-0.25,0.42c-5.21-4.65-9.9-9.68-11.6-12.29c-3.79-5.87-6.8-8.37-6.46-10.08c0.34-1.71-3.15-3.85-2.89-6.6 c0.06-0.03,0.13-0.07,0.21-0.12c-0.45-0.49-0.93-1.03-1.39-1.63c-1.86-2.39-2.78-3.47-2.78-3.47c-1.9,0.28-3.47-0.13-5.23-0.76 c-1.76-0.63-2.88-2.32-4.08-2.59c-1.2-0.27-2.24-1.52-2.94-1.75s-1.83-0.18-3.34-0.42c-1.51-0.24-1.68-0.39-2.47-1.05 c-0.78-0.67-1.95-1.13-1.88-2.08c0.08-0.96,0.6-2.07,1.86-2.41c1.26-0.34,3.15-0.08,4.08-0.08c0.36,0,0.55-0.06,0.6-0.13 c-0.03,0.02-0.07,0.04-0.11,0.06c0,0,0.26-0.29-0.68-0.42c-0.07-0.01-0.14-0.02-0.22-0.03c-1-0.12-2.72-0.26-3.45-0.41 c-0.79-0.17-0.95,0.11-1.45,0.14c-0.65,0.04-0.89-0.43-0.97-0.61c-0.12-0.15-0.24-0.34-0.38-0.58 c-0.94-1.66,0.65-2.84,0.65-2.84s-0.16,0-0.38-0.12c-0.6-0.29-0.77-0.91-0.77-0.91c-0.88-1.75,1.35-3.58,1.35-3.58 s-0.01-0.01-0.02-0.03c-0.14-0.21-0.25-0.44-0.33-0.67c0,0,0-0.01-0.01-0.01c-0.42-1.21-0.04-2.65,1.26-3.65 c0.08-0.06,0.16-0.13,0.25-0.19c-0.75-1.06-1.51-2.13-2.26-3.19c-3.65-0.88-6.69-1.17-9.35-1.09c-0.12-0.01-0.25-0.01-0.37-0.01 l-8.88,0.53c-0.17,0.02-0.35,0.04-0.52,0.07c-8.85,1.15-19.58,3.52-37.12,3.52c-21.04,0-26.83-8.69-28.19-11.65 c0.02-1.61,0.82-3.34,2.48-5.23c-7.12-0.84-15.29,0.6-24.37,7.04c-21.72,15.39-22.67,58.88-16.63,89.08 c4.95,24.75,9.4,14.08,23.99,128.3c3.36,26.29,0,53.63,0,53.63s94.92,18.1,149.17,2.44c0,0-6.55-54.08-3.34-93.33 c13.18,17.52,18.16,23.61,30.17,26.47c0.03,0.01,0.06,0.02,0.09,0.04c3.85,1.51,8.09,1.81,12.5,1.16 c5.71-0.46,10.97-2.34,14.88-5.32c16.55-9.08,31.68-27.39,33.25-42.21c0.66-6.21,15.22-29.05,15.87-35.98 C263.12,672.92,262.67,668.46,261.47,664.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M256.26,641.3c0.22,1.99,1.56-0.69,1.93-1.77c0,0-0.62-0.33-1.15-1.05c-0.35-0.48-0.65-1.12-0.72-1.96 C256.15,637.89,256.04,639.31,256.26,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M259.85,649.87c0.12,1.97,0.98-0.98,1.17-1.57c0.01-0.05,0.02-0.09,0.01-0.14 c-0.03-0.33-0.43-0.76-0.79-1.25c-0.22-0.31-0.42-0.64-0.5-1C259.76,646.91,259.78,648.72,259.85,649.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M259.74,645.79c-0.01-0.63-0.02-0.86-0.04-0.23c0,0.12,0.01,0.23,0.04,0.35 C259.75,645.87,259.74,645.83,259.74,645.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M261,662.69c0,0.01,0,0.02,0,0.04c0,0,0.42,1.3,0.42,1.47c0.01-0.03,0.02-0.05,0.03-0.07 c0.38-1.1,0.77-2.05,1.02-2.9c0.32-1.08,0.43-1.98,0.03-2.83c-0.05-0.1-0.09-0.19-0.13-0.28c-0.18-0.37-0.33-0.69-0.47-0.97 c-0.4-0.8-0.65-1.23-0.71-1.33c-0.01-0.02-0.02-0.03-0.02-0.03C260.81,657.55,261.34,660.15,261,662.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M86.48,501.93c3.55-22.91,1.43-35.01,10.86-38.11c8.47-2.79,11.49,8.34,12.54,15.2 c0.01,0.26,0.04,0.52,0.07,0.78c0.26,1.92,0.47,3.99,0.61,6.43c0.66,5.36,1.42,8.06,0.79,11.67c-0.16,0.94-0.43,1.65-0.78,2.17 c-0.07,2-0.17,4.16-0.31,6.53c-0.33,5.95-3.35,16-4.12,24.98c0.1-0.23,0.21-0.47,0.32-0.7c0.04-0.09,0.08-0.19,0.11-0.28 c-0.01,0.04-0.02,0.08-0.04,0.12c0.09-0.18,0.17-0.36,0.26-0.53c0.17-0.36,0.35-0.71,0.54-1.06l-0.02,0.09 c0.02-0.04,0.04-0.07,0.06-0.11c0.72-3.06,1.43-5.89,1.48-9c0.34,1.63,0.43,3.31,0.28,4.96c0.04-0.86,0.23-1.72,0.56-2.51 c-0.11,0.64-0.09,1.3,0.07,1.93c0.44-0.58,0.68-1.29,0.69-2.01c0.08,0.31,0.17,0.62,0.25,0.93c0.07-0.29,0.13-0.59,0.19-0.88 c-0.01-0.31-0.03-0.61-0.05-0.92c0.05,0.17,0.1,0.34,0.14,0.51c0.47-2.25,0.86-4.51,1.15-6.79c0.02,1.83,0.05,3.66,0.07,5.49 c0.25-0.94,0.45-1.89,0.59-2.86c0.02,0.46,0.01,0.91-0.01,1.37c0.15-0.8,0.27-1.6,0.36-2.41c0.05,0.36,0.1,0.72,0.15,1.07 c0.01-0.27,0.03-0.54,0.04-0.82c0.09,0.88,0.18,1.76,0.27,2.65c0.05-0.2,0.1-0.39,0.14-0.59c-0.04,0.24-0.09,0.47-0.13,0.71 c0.05,0.49,0.1,0.99,0.15,1.48c0.1-0.24,0.21-0.48,0.31-0.72c-0.08,0.45-0.17,0.9-0.25,1.34c0.01,0.06,0.01,0.12,0.02,0.17 c0.09-0.31,0.19-0.62,0.3-0.93c0.11-0.93,0.18-1.87,0.2-2.8c0.12,0.5,0.23,1.01,0.35,1.51c0.1-0.2,0.2-0.41,0.31-0.6 c-0.06,0.39-0.12,0.79-0.18,1.18c0.05,0.26,0.11,0.51,0.15,0.77c0.25-0.48,0.5-0.96,0.74-1.44c0.06,0.63,0.02,1.27-0.12,1.88 c0.03-0.03,0.05-0.07,0.08-0.11c0.28-0.98,0.5-1.98,0.65-2.99c0.03,0.74-0.01,1.49-0.09,2.22c0.28-0.42,0.55-0.85,0.79-1.29 c-0.04,0.22-0.03,0.46,0.01,0.68c0.04-0.17,0.08-0.33,0.12-0.5c-0.04,0.19-0.07,0.38-0.11,0.57c0.01,0.04,0.02,0.09,0.03,0.13 c0.38-0.31,0.72-0.66,1.01-1.05c-0.11,0.4-0.21,0.8-0.32,1.21c0.08-0.08,0.15-0.15,0.23-0.23c0.08-0.16,0.16-0.32,0.25-0.48 c-0.01,0.09-0.03,0.18-0.04,0.27c0.04-0.04,0.07-0.07,0.11-0.11c0.01,0.05,0.01,0.1,0.02,0.15c0.54-0.71,0.98-1.49,1.27-2.34 c-0.17,0.92-0.53,1.81-1.07,2.58c1.3-1.2,2.5-2.51,3.7-3.81c-0.55,0.8-1.1,1.6-1.66,2.4c1.17-0.57,2.12-1.6,2.57-2.83 c-0.1,0.68-0.36,1.33-0.75,1.9c0.55-0.31,1.03-0.76,1.39-1.28c0.03,0.4-0.12,0.77-0.34,1.11c1.13-0.65,2.26-1.3,3.37-1.98 c-0.33,0.62-0.66,1.24-0.99,1.86c1.03-0.81,2.07-1.62,3.1-2.43c-0.35,0.68-0.71,1.35-1.06,2.03c1.5-0.59,3.1-0.93,4.71-1 c-0.28,0.32-0.57,0.65-0.85,0.97c0.81-0.09,1.63-0.17,2.44-0.26c0.03-0.89,0.01-1.49-0.09-1.9c0.27-0.54,0.51-1.31,0.67-2.32 c0.05-0.3,0.16-0.78,0.31-1.4c0.12-0.49-0.06-1.01-0.45-1.33c-0.03-0.02-0.06-0.05-0.08-0.09c-0.65-0.81-0.68-4.33-0.68-5.78 c0-3,0.38-2.64,1.45-3.1c0.13-0.05,0.25-0.1,0.36-0.13c0.84-0.27,1.3-0.18,1.71-1.4c0.02-0.07,0.05-0.11,0.07-0.14 c0.13-2.08-0.12-3.66-1.07-4.04c-0.02-0.01-0.04-0.02-0.07-0.03c-4.82,2.4-14.4-6.16-16.14-23.45 c-0.26-2.59-0.55-4.69-0.85-6.38c-0.08-4.03,0.14-8.3,1.1-12.59c3.72-16.54,4.83-5.77,12.15-11.91 c0.52-0.44,1.07-0.96,1.66-1.58c0.51-0.55,0.97-1.14,1.37-1.77c-0.42,2.53-1.31,4.46-2.12,5.78c-0.87,1.42-1.64,2.15-1.64,2.15 s0.66-0.34,1.83-1.61c0.89-0.97,2.07-2.47,3.49-4.78c2.62-4.27,2.75-9.05,1.35-12.89c1.28,1.87,1.98,3.27,1.98,3.27 c-0.8-5.59-3.11-9.43-5.42-11.93c-0.35-0.65-0.72-1.28-1.12-1.89c3.04,1.65,3.96,3.08,3.96,3.08c-2.6-5.05-6.85-8.35-12.09-9.91 c-1.37-0.52-2.83-0.84-4.37-0.9c-0.21-0.01-0.4-0.02-0.6-0.04c-0.1-0.01-0.21-0.01-0.32-0.02c-3.19-0.26-5.55-1.09-7.69-2.33 c5.85,0.9,10.89,0.86,6.42-0.08c-6.47-1.36-11.68-4.32-11.68-4.32l12.42,2.15c0,0-4.89-1.27-11.64-5.84 c-6.73-4.55-17.52-7.03-22.47-6.67c-9.49-0.55-18.88,4.48-34.02,4.99c-8.98,0.3-17.06,4.22-23.02,10.26 c-4.56,4.05-9.67,9.91-12.19,18.37c-3.32,11.16-4.53,16.9-4.53,16.9s3.46-8.9,5.63-13.86c2.17-4.96-0.78,3.88-2.79,12.41 c-2.02,8.53,0.78,25.59,0.78,25.59s-1.7-13.25,3.34-26.5c-1.32,7.05-3.85,17.94-2.27,32.49c0.43,3.92,1.23,7.5,2.21,10.76 c0.28,0.94,0.58,1.85,0.9,2.74c2.73,7.81,6.31,13.72,7.79,18.43c-1.07-3.8-4.42-15.67-6.57-23.58c-0.29-1.07-0.46-2.25-0.54-3.5 c2.11,8.3,4.89,15.78,7.39,21.99c3.43,8.51,6.07,20.73,6.97,25.17c0.22,1.07,0.33,1.69,0.33,1.69 C57.53,538.11,82.62,526.84,86.48,501.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M27.72,503.61c0.22,0.78,0.35,1.23,0.35,1.23C27.97,504.44,27.85,504.03,27.72,503.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M222.66,514.75c0,0,1.22-0.77,2.33-0.61c1.04,0.15,4.8,1.02,5.67,1.6c0.1,0.07,0.17,0.1,0.21,0.12 c0.27,0.08-0.56-0.83-0.56-0.83c-0.01,0-0.03-0.01-0.04-0.01c-1.43-0.52-3.81-0.74-5-1.09 C223.92,513.53,222.66,514.75,222.66,514.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M131.77,468.98c-0.43,0.72-1.35,0.64-1.35,0.64C129.48,468.98,131.08,470.9,131.77,468.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M131.81,469.2l-1.06,1.15C131.73,469.98,131.81,469.2,131.81,469.2z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M101.37,532.87c-0.43-4.12-0.73-6.45-0.93-7.75c-0.28,1.91-0.68,4.73-1.05,7.97 c-0.24,3.12-0.53,6.49-0.84,9.25c-0.05,0.81-0.09,1.61-0.13,2.41c0.34-0.35,1.1-1.06,2.31-1.65c1.01-0.5,2.33-0.92,3.99-1 c0-0.08-0.01-0.16-0.02-0.24c-0.01-0.16-0.01-0.32-0.01-0.49C101.8,540.01,101.91,538.01,101.37,532.87z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160,561.72c0.06-0.15,0.27-0.44,0.38-0.54c0.54-0.47,1.56-0.38,1.56-0.38c-1.44-0.55-1.88-1.31-1.67-0.83 c0.21,0.48,0.19,1.03-0.11,1.17l-0.01,0.07L160,561.72z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.83,571.88c-0.49,0.36-0.95,0.64-1.31,0.77c0,0,2.18-0.88,2.01-0.61c-0.45,0.69-0.58,1.36-0.2,1.07 c0.38-0.29,0.72-0.78,2.29-2.52c1.65-1.84,4.16-3.2,3.25-3.09s-1.28,0.82-1.23,0.31c0.05-0.52,0.12-1.27-0.12-0.86 c-0.18,0.3-0.3,0.59-0.79,1.2c-0.16,0.2-0.35,0.43-0.6,0.7C157.42,569.64,156.03,571,154.83,571.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB9996",
    d: "M149.06,573.67l0.08,0.21l-0.04,0.04c0,0,0.01-0.06,1.01-0.7c1.18-0.76,1.61-0.67,1.87-1.33 c0.26-0.66,0.29-0.85,1.72-1.89c1.44-1.05,1.74-1.53,2.56-3.1c0.82-1.57,1.96-1.67,2.78-2.67c0.79-0.97,0.88-2.19,1.09-2.99 c0.01-0.03,0.02-0.06,0.02-0.09c0,0-0.04,0.06-0.1,0.16c-0.14,0.22-0.4,0.65-0.57,0.96c-0.04,0.07-0.08,0.15-0.11,0.23 c-0.17,0.38-0.29,0.78-0.56,1.12c-0.14,0.17-0.5,0.38-0.99,0.71c-0.66,0.45-1.43,0.93-2.03,1.3c-0.15,0.1-0.34,0.21-0.46,0.29 c-0.57,0.38-0.85,0.74-0.97,1.11c-0.03,0.08-0.05,0.17-0.07,0.26c-0.06,0.32-0.15,0.52-0.29,0.71c-0.14,0.17-0.33,0.33-0.6,0.56 c-0.12,0.1-0.36,0.22-0.49,0.32c-0.38,0.29-0.64,0.58-0.91,1.07c-0.07,0.13-0.13,0.26-0.18,0.41c-0.01,0.04-0.03,0.08-0.04,0.12 c-0.3,0.89-0.42,1.21-0.69,1.63c-0.17,0.27-1.2,0.86-1.68,1.2C149.09,573.53,149.08,573.72,149.06,573.67z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.69,562.35c1.5-1.15,3.38-2.51,4.83-2.46c1.65,0.06,4.25,0.2,5.42,0.66c1.17,0.46,1.58,1.77,3.02,1.87 c3.48,0.22,4.92,1.62,7.39,3.46c2.47,1.85,4.88,6.19,7.23,7.52c0.98,0.55,2.14,1.52,3.11,2.4l3.73,0.94 c0.77-0.15,1.76-0.11,2.92,0.44c0.41,0.19,0.77,0.39,1.11,0.58l0.34,0.08c0,0-0.46-0.56-1.14-1.55 c-0.68-0.99-0.92-1.98-0.49-2.36l-0.06-0.01l-0.04-0.24l-0.07-0.01c0,0-0.46,0.87-0.05,2.05c0.09,0.27,0.25,0.54,0.43,0.78 c-0.99-0.91-2.28-2.02-3.09-2.46c-1.47-0.8-4.56-0.27-6.7-1.88c-1.53-1.15-2.86-3.92-3.49-5.41c-0.15-0.35-0.26-0.63-0.32-0.8 c-0.04-0.11-0.07-0.18-0.07-0.18c-4.55,0.84-4.97-2.46-4.97-2.46s0.41,0.23-0.04-0.19c-0.15-0.14-0.4-0.36-0.79-0.7 c-0.27-0.23-0.62-0.51-1.05-0.86c-6.36-5.12-10.38-5-16.01-6.48c-0.62-0.16-1.18-0.34-1.69-0.54c-0.04-0.02-0.08-0.03-0.13-0.05 c-0.13-0.05-0.26-0.1-0.38-0.15c-0.2-0.09-0.39-0.17-0.58-0.27c-0.13-0.07-0.26-0.14-0.39-0.21c-0.56-0.31-1.03-0.65-1.44-1.03 c-0.02-0.02-0.05-0.04-0.07-0.06c-1.06-1.01-1.66-2.29-1.97-3.9c-0.19-1.02-0.31-2-0.4-2.87l-0.21,3.48l-0.06,0.92l0.16-1.38 l0.07-0.61c-0.01,0.12-0.02,0.25-0.03,0.4c-0.03,0.69,0.02,1.62,0.1,2.58c0.19,2.08,0.53,4.26,0.53,4.26l0.11-0.52l-0.27-2.28 c0.05,0.41,0.19,0.92,0.39,1.48c0.3,0.87,0.74,1.85,1.19,2.78c0.42,0.87,0.85,1.69,1.18,2.31c0.35,0.65,0.59,1.07,0.59,1.07 l0.68,0.59L111.69,562.35z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M238.39,627.31c-0.43,2.29,0.66,3.15-0.35,5.16c-1.55,3.1-0.73,4.36-1.16,5.8 c-0.43,1.43-2.33,3.15-2.05,5.44c0.08,0.65,0.3,1.4,0.51,2.22c-0.66,2.17-3.12,7.01-5.93,10.08c-3.2,3.51-3,5.38-4.37,10.41 c-0.95,3.49-3.76,5.93-6.31,7.96c-0.4-0.39-0.79-0.77-1.17-1.17l0.07-0.05c0,0-7.38-10.2-8.58-12.05 c-2.32-3.57-1.83-5.5-2.32-10.68c-0.37-3.88-1.25,2.6-0.56,6.01c0.69,3.41-0.9-0.21-2.19-5.75c-1.28-5.55-1.48-0.15-0.09,3.22 c1.39,3.37,1.57,2.78-0.78,2c-4.55-1.51,0.73,0.3,3.69,3.74c0.73,1.02,2,2.81,3.44,4.94c2.18,3.37,4.55,7.27,5.53,8.91 c0.22,0.4,0.42,0.79,0.62,1.17c-1.13,0.63-6.02,3.57-9.53,8.61c-5.74-0.97-6.34-8.27-7.83-11.04c-3.17-5.88-7.01-7.69-6.11-12.22 c0.91-4.53-7.24-13.8-9.5-19.91c-2.26-6.11,2.14-22.16,0.49-17.44c-0.35,0.99-0.78,1.89-1.27,2.7c0.98-1.9,1.23-3.45,1.23-3.45 c-7.59,8.67-9.84-0.31-11.37-4.65c-1.54-4.37-2.57-7.46-2.57-4.12c0,3.34,2.06,10.55-1.54,4.89c-3.6-5.66-12.6-14.15-18.01-21.61 c-5.12-7.07-8.3-12.62-8.63-13.19c-0.02-0.03-0.03-0.05-0.03-0.05c-0.18,0.32-0.37,0.64-0.56,0.96c-0.69,1.14-1.43,2.26-2.18,3.3 l1.03-1.59l1.57-2.43c-1.7,1.07-2.95,1.23-6.3-1.21c-3.09-2.24-9.06-1.03-12.09-2.33c-3.14-1.35-9.34,0.06-12.45-0.69 c-0.36-0.09-0.56-0.22-0.65-0.38c0.15-0.88,0.69-1.82,1.82-2.12c1.26-0.34,3.15-0.08,4.08-0.08c0.36,0,0.55-0.06,0.6-0.13 c-0.03,0.02-0.07,0.04-0.11,0.06c0,0,0.26-0.29-0.68-0.42c-0.07-0.01-0.14-0.02-0.22-0.03c-1-0.12-2.72-0.26-3.45-0.41 c-0.79-0.17-0.95,0.11-1.45,0.14c-0.65,0.04-0.89-0.43-0.97-0.61c-0.12-0.15-0.24-0.34-0.38-0.58c-0.94-1.66,0.65-2.84,0.65-2.84 s-0.16,0-0.38-0.12c-0.6-0.29-0.77-0.91-0.77-0.91c-0.88-1.75,1.35-3.58,1.35-3.58s-0.01-0.01-0.02-0.03 c-0.53-0.79-0.65-1.77-0.32-2.68h0c0,0-0.84,1.82-0.7,2.81c0.14,0.98-1.54,2.24-0.98,3.65c0.56,1.4-0.42,2.38,0.28,3.93 c0.7,1.54,1.12,3.37,0.84,4.63c-0.05,0.22-0.03,0.53,0.06,0.88c0.03,0.19,0.09,0.38,0.19,0.56c0.66,1.58,2.48,3.61,5.36,3.61 c3.93,0,5.47,1.54,6.87,2.66c1.4,1.12,5.05,2.24,7.01,1.82c1.96-0.42,3.79,3.79,5.05,5.61c0.2,0.29,0.49,0.64,0.84,1.02 l2.16,3.94c0,0,0.85,1.83,2.48,4.54c0.8,1.32,1.79,2.86,2.96,4.49c3.13,5.4,6.82,11.21,10.44,15.67 c9.09,11.21,17.45,14.28,23.86,14.33c0.38,0.77,0.81,1.59,1.29,2.46c3.14,6.79,7.53,15.34,14.92,31.32 c6.91,14.94,10.27,26.12,10.06,37.22c0,0,2.81-7.2,0.34-15.97c0,0,0.01,0.01,0.02,0.02l2.53,5.5c1.42,4.15,2.72,10.48,1.68,18.48 c-1.9,14.58,1.94,3.28,3.23-10.26c0.87-9.17-1.21-12.57-2.65-13.81c2.25,1.44,6.93,5.23,8.14,12.5 c1.61,9.67,5.94-11.81-5.34-14.07c-11.28-2.26,0.16-6.54,9.18-2.67c0,0,1.93-3.87-6.77-3.54c-8.7,0.32,4.51-7.73,9.99-10.31 c5.21-2.45-5.98-0.57-12.1,5.9c0.63-0.73,1.28-1.45,1.96-2.14c0.91-0.92,1.87-1.79,2.88-2.57c-0.08,0.07-0.16,0.14-0.23,0.21 c-0.09,0.09-0.17,0.17-0.24,0.24c-1.89,2,6.49-2.79,8.47-5.88c0.23-0.36,0.52-0.85,0.86-1.44c0.71-1.24,1.61-2.93,2.56-4.73 c2.15-4.1,4.53-8.8,5.31-10.37c2.62-3.18,5.02-3.73,6.98-4.35c3.35-1.07,10.49-0.85,10.49-0.85s-0.87-0.45-2.02-0.94 c-0.03-0.01-0.06-0.02-0.09-0.04c-1.25-0.53-2.81-1.1-3.91-1.17c-2.15-0.14-1.72-1.86-6.41,0.13c-0.12,0.05-0.24,0.11-0.36,0.17 c-0.01,0.01-0.02,0.01-0.04,0.02c-0.01-0.15-0.01-0.29-0.02-0.43c-0.2-1.44-0.48-3.79-0.36-5.04c0.17-1.87,1.38-2.94,2.2-4.06 c0.83-1.12,0.86-2.8,1.02-4.94s0.84-3.02,1.42-3.96c0.02-0.04,0.04-0.08,0.06-0.11l-1.52-3.45c0,0-0.02-0.01-0.05-0.02 C239.8,625.58,238.77,625.31,238.39,627.31z M134.05,593.5c-0.05,0.05-0.09,0.1-0.13,0.14c-0.01-0.11-0.02-0.22-0.02-0.34 C133.96,593.37,134.01,593.44,134.05,593.5z M172.44,632.19c0.25-0.03,0.5-0.06,0.75-0.1c1.11-0.18,2.11-0.45,3-0.81 c-0.85,0.43-1.4,0.62-1.4,0.62S174.04,632.28,172.44,632.19z M204.08,695.3c0.41,0.82,0.92,1.94,1.42,3.33 C205.15,697.8,204.67,696.68,204.08,695.3z M237.04,647.84c-0.5,0.3-0.98,0.68-1.45,1.13l0.05-0.09l0.13-0.26 c0,0.04,0,0.09,0,0.13c0.24-0.22,0.49-0.42,0.74-0.59C236.69,648.05,236.86,647.94,237.04,647.84z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.31,606.17c0.67-2.92,1.28-19.53,0.39-23.07c-0.91,2.4-2.01,4.99-3.28,7.79 c-0.24,0.54-0.47,1.1-0.67,1.67c-0.16,0.51-0.33,1.02-0.49,1.55c-2.19,7.63-1.64,17.4-4.43,24.76 c11.05-7.66,22.64,2.02,31.51,7.97c9.08,6.09,12.33,6.18,10.44,5.45c-1.89-0.73,3.17,2.23-11.34-8.81 c-16.51-12.55-17.25-10.4-17.12-14.9c0.02-0.74,0.31-5.54,2.3-10.09C203.07,595.18,193.46,609.89,194.31,606.17z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.82,764.69c-1.23-29.65,4.62-34.35,4.62-34.35c-9.86-18.62-46.77-78.3-46.22-95.82 c0.55-17.52-4.38,10.95-3.83,25.19c0.55,14.24-6.57-8.76-8.76-21.9c-2.19-13.14,2.74,16.43,3.29,22.45 c0.55,6.02-7.12-7.12-14.24-8.76c-7.12-1.64,8.9,14.11,13.83,31.63c4.93,17.52,7.16,22.59,5.52,44.49 c-1.64,21.9,42.29,37.05,23.68,48.01c-18.62,10.95-60.45,15.78-78.52,15.78s25.1,15.49,53.57,6.18s4.14,13.08-29.81,14.72 c-31.7,1.53,27.78,13.09,5.49,15.06c-0.84-0.2-1.81-0.42-2.92-0.64c-27.46-5.63-62.31-15.16-51.4-33.8 c9.13-15.6,4.69-32.08-6.51-64.6c-1.01-2.94-2.1-6.02-3.23-9.2l0.25,0.25c-0.39-0.91-0.78-1.85-1.16-2.79 c-1.39-3.88-2.86-7.9-4.37-12.01C3.06,686.2-1.37,664.8-4.73,645.23c-4.12-24.01-3.76-23.52-1.93,2.81 c0.5,7.2-1.57,7.25-3.83,3.4c-0.21-0.58-0.41-1.16-0.62-1.74c-2.21-9.37-3.87-15.84-4.02-14.96c-0.03,0.18,0,0.7,0.11,1.59 c0.38,3.01,1,5.83,1.73,8.3c0.38,1.27,0.79,2.45,1.22,3.51c0.98,3.49,2.27,8.2,3.69,13.59c0.16,0.6,0.32,1.2,0.48,1.82 c2.45,10.75,5.04,22.38,6.91,30.82c1.08,4.88,1.92,8.69,2.35,10.66c0.37,2.3,0.69,4.49,0.93,6.53 c2.62,21.99,6.1,39.27,8.21,62.04c0.23,2.54,0.45,5.15,0.65,7.83c0.1,1.31,0.19,2.64,0.28,4c1.71,26.71-1.34,38.21-1.34,38.21 s5.34,0.7,13.59,2.27c1.86,0.35,3.87,0.75,6,1.2c6.08,1.27,16.29,2.28,26.15,2.85c2.89,0.17,5.74,0.3,8.46,0.38 c3.86,0.51,9.07,1.02,14.48,1.42c6.84,0.5,14.01,0.85,19.2,0.85c3.01,0,6.1-0.06,9.17-0.16c15.89-0.53,31.21-2.17,31.32-2.18 C139.66,827.46,151.27,799.51,149.82,764.69z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M172.37,593.75c3.51,4.09,4.48,6.43,4.87,7.99c0.39,1.56,0.55-1.23-1.36-3.9 c-1.92-2.67,1.22-0.21,2.78,1.71c1.56,1.92,2.4-1.08-1.44-3c-1.9-0.95-5.43-3.93-8.52-6.7 C169.99,591.14,171.3,592.5,172.37,593.75z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.69,589.85c-2.96-2.92-5.87-5.46-5.87-5.46S165.52,587.01,168.69,589.85z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.64,564.77c15.26,4.58,50.94-2.13,56.04-5.06c0.05-0.03,0.09-0.05,0.13-0.08 c-1.17-23.26,7.49-56.71,7.49-56.71c0.86-4.63,1.14-7.14,1.06-8.41c0.05-1.09-0.08-2.15-0.44-3.18 c-2.84-8.1-2.86-14.23-2.43-19.34c0.5-1.65,1.05-2.98,1.61-4.04c2.48-4.66,5.25-4.31,5.25-4.31s2.23-0.54,3.76-0.36 c2.52,0.28,2.32-1.2,1.12-5.41c-0.65-2.29-0.41-4.26,0.39-6.08l0.02,0.25c0,0,4.94-9.54,1.7,2.38 c4.09-7.49,12.16-19.63,8.17-10.9c-3.99,8.73,0.74,16.52-0.5,13.03c-1.25-3.49,0.85-10.48,4.49-17.7 c2.53-5.02,2.49-10.37,1.93-14.1c0.02-0.38,0.04-0.76,0.03-1.13c2.58,7.43,0.79,13.48,0.79,13.48s2.24-5.98,0.25-15.46 c-1.99-9.47-13.72-12.25-21.16-12.63l0.02,0.21c-11.87-1.76-20.47,1.78-13.09-1.91c10.24-5.12,21.52-2.38,5.52-4.3 c-11.75-1.41-24.32,5.3-24.81,5.56c0.14-0.08,1.61-0.89,4.84-2.94c7.56-4.79,13.13-6.11,15.49-6.42 c-0.3-0.01-0.66-0.02-1.09-0.05c-6.34-0.45-16.34,1.28-26.59-0.61c-9.03-1.66-16.46-0.34-23.03,2.45 c-0.38,0.16-0.76,0.33-1.14,0.5c-2.02,1.35-3.91,2.89-5.61,4.62c-4.31,3.83-9.11,9.27-11.75,16.99c-0.15,0.45-0.3,0.91-0.44,1.38 c-3.32,11.16-4.53,16.9-4.53,16.9s3.46-8.9,5.63-13.86c2.17-4.96-0.78,3.88-2.79,12.41c-1.6,6.78-0.17,18.95,0.49,23.66 c0.17,1.21,0.29,1.93,0.29,1.93s-1.55-12.03,2.67-24.63c0.21-0.62,0.43-1.25,0.67-1.87c-1.32,7.05-3.85,17.94-2.27,32.49 c0.43,3.93,1.23,7.5,2.21,10.76c0.28,0.94,0.58,1.85,0.9,2.74c2.31,6.61,5.23,11.85,6.97,16.17c0.32,0.78,0.6,1.54,0.83,2.27 c-1.07-3.8-4.42-15.67-6.57-23.57c-0.21-0.76-0.35-1.59-0.45-2.45c-0.04-0.34-0.07-0.69-0.09-1.05 c2.11,8.3,4.89,15.78,7.39,21.99c3.43,8.51,6.07,20.73,6.97,25.17c0,0.27,0,0.54,0,0.81c-0.01,3.27-0.34,6.21-0.89,8.83 c-0.05,0.21-0.11,0.43-0.18,0.64c-1.15,3.91-4.13,8.57-6.64,11.41c-0.09,0.1-0.17,0.2-0.25,0.29c-0.42-0.02-0.83-0.03-1.24-0.04 c-4.52-0.09-8.58,0.46-12.22,1.54c-5.83,1.73-10.59,4.78-14.47,8.65c-2.92,2.91-5.35,6.28-7.35,9.88 c-9.83,17.63-9.64,40.85-8.84,43.28c0.01,0.03,0.02,0.06,0.03,0.08C-12.99,593.96-7.56,553.91,28.64,564.77z M89.41,476.92 c-0.14,0.78-0.28,1.57-0.4,2.34c0.21-1.59,0.45-3.02,0.73-4.3c0.09-0.41,0.18-0.81,0.27-1.19 C89.82,474.7,89.61,475.79,89.41,476.92z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.78,580.87l5.03,3.52c0,0,0.27-2.63,0.63-6.35c0.35-3.72,3.81-13.41,3.54-12.92 c-0.66,1.21-1.9,3.35-3.24,5.87c-0.81,1.54-1.66,3.22-2.43,4.92c-0.46,1.01-0.9,1.82-1.3,2.47 C158.73,580.45,157.78,580.87,157.78,580.87z"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "line_2_",
    x: 36,
    y: 183,
    width: 1033,
    height: 7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 871.0859 220.3686)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "\u2026 und mit "), /*#__PURE__*/React.createElement("tspan", {
    x: 82.09,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "23px"
  }, "MINUS 53%"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.15,
    y: 26,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "sogar \xFCbertroffen!")))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-left"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 10 168.8479)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px",
    letterSpacing: -1
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.95,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px",
    letterSpacing: -1
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.48,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px",
    letterSpacing: -1
  }, "sag"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.23,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px"
  }, "t")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 35 226.1699)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "Wir wollen die"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.06,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "17px"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 112.14,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "23px"
  }, "CO2-EMISSIONEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "in der europ\xE4ischen Neufahrzeugflotte "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "zwischen 1995 und 2020 "), /*#__PURE__*/React.createElement("tspan", {
    x: 185.29,
    y: 52,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "23px"
  }, "HALBIEREN.")))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 984.6359 168.8477)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px",
    letterSpacing: -1
  }, "getan")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.8c0772f1.svg";
export { ForwardRef as ReactComponent };